/* tslint:disable */
/* eslint-disable */
/**
 * nocal API
 * The API for nocal
 *
 * The version of the OpenAPI document: 2.11.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration'
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from './common'
import type { RequestArgs } from './base'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base'

/**
 *
 * @export
 * @interface AccountDeletionCodeResponse
 */
export interface AccountDeletionCodeResponse {
  /**
   *
   * @type {string}
   * @memberof AccountDeletionCodeResponse
   */
  code: string
}
/**
 *
 * @export
 * @interface AccountDeletionConfirmRequest
 */
export interface AccountDeletionConfirmRequest {
  /**
   *
   * @type {string}
   * @memberof AccountDeletionConfirmRequest
   */
  code: string
}
/**
 *
 * @export
 * @interface AccountDeletionErrorResponse
 */
export interface AccountDeletionErrorResponse {
  /**
   *
   * @type {string}
   * @memberof AccountDeletionErrorResponse
   */
  detail: string
}
/**
 *
 * @export
 * @interface AddCalendarToGroupRequest
 */
export interface AddCalendarToGroupRequest {
  /**
   * UUID of the calendar account, or \'primary\' to use the primary calendar account
   * @type {string}
   * @memberof AddCalendarToGroupRequest
   */
  calendar_account_id: string
  /**
   *
   * @type {string}
   * @memberof AddCalendarToGroupRequest
   */
  remote_address: string
  /**
   *
   * @type {CalendarVisibility}
   * @memberof AddCalendarToGroupRequest
   */
  visibility: CalendarVisibility
}

/**
 *
 * @export
 * @interface AddLabels
 */
export interface AddLabels {
  /**
   *
   * @type {Array<string>}
   * @memberof AddLabels
   */
  labels?: Array<string>
  /**
   *
   * @type {Array<NewLabel>}
   * @memberof AddLabels
   */
  new_labels?: Array<NewLabel>
}
/**
 *
 * @export
 * @interface AllowedSender
 */
export interface AllowedSender {
  /**
   *
   * @type {string}
   * @memberof AllowedSender
   */
  value: string
}
/**
 *
 * @export
 * @interface ApiToken
 */
export interface ApiToken {
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  id: string
  /**
   *
   * @type {KindEnum}
   * @memberof ApiToken
   */
  kind: KindEnum
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  name?: string
  /**
   *
   * @type {boolean}
   * @memberof ApiToken
   */
  is_default?: boolean
  /**
   *
   * @type {ApiTokenStatusEnum}
   * @memberof ApiToken
   */
  status?: ApiTokenStatusEnum
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  token_hint?: string
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  created_at: string
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  rotated_at?: string | null
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  revoked_at?: string | null
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  last_used_at?: string | null
  /**
   *
   * @type {string}
   * @memberof ApiToken
   */
  last_used_client?: string | null
}

/**
 * * `active` - Active * `revoked` - Revoked
 * @export
 * @enum {string}
 */

export const ApiTokenStatusEnum = {
  Active: 'active',
  Revoked: 'revoked'
} as const

export type ApiTokenStatusEnum = (typeof ApiTokenStatusEnum)[keyof typeof ApiTokenStatusEnum]

/**
 * * `USER` - USER * `API` - API * `GOOGLE` - GOOGLE * `MICROSOFT` - MICROSOFT
 * @export
 * @enum {string}
 */

export const ApplierTypeEnum = {
  User: 'USER',
  Api: 'API',
  Google: 'GOOGLE',
  Microsoft: 'MICROSOFT'
} as const

export type ApplierTypeEnum = (typeof ApplierTypeEnum)[keyof typeof ApplierTypeEnum]

/**
 *
 * @export
 * @interface Attachment
 */
export interface Attachment {
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  file_id?: string | null
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  file_url: string
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  mime_type: string
  /**
   *
   * @type {number}
   * @memberof Attachment
   */
  size: number | null
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  event: string
}
/**
 *
 * @export
 * @interface Attendee
 */
export interface Attendee {
  /**
   *
   * @type {RsvpStatusEnum}
   * @memberof Attendee
   */
  rsvp_status: RsvpStatusEnum
  /**
   *
   * @type {boolean}
   * @memberof Attendee
   */
  is_self: boolean
  /**
   *
   * @type {string}
   * @memberof Attendee
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Attendee
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof Attendee
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof Attendee
   */
  name?: string | null
  /**
   *
   * @type {string}
   * @memberof Attendee
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof Attendee
   */
  email_domain: string
  /**
   *
   * @type {boolean}
   * @memberof Attendee
   */
  is_organizer: boolean
  /**
   *
   * @type {boolean}
   * @memberof Attendee
   */
  is_optional?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Attendee
   */
  is_resource: boolean
  /**
   *
   * @type {string}
   * @memberof Attendee
   */
  rsvp_comment?: string | null
}

/**
 *
 * @export
 * @interface AttendeeInput
 */
export interface AttendeeInput {
  /**
   *
   * @type {string}
   * @memberof AttendeeInput
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof AttendeeInput
   */
  name?: string | null
  /**
   *
   * @type {boolean}
   * @memberof AttendeeInput
   */
  is_optional?: boolean
  /**
   *
   * @type {RsvpStatusEnum}
   * @memberof AttendeeInput
   */
  rsvp_status?: RsvpStatusEnum
  /**
   *
   * @type {string}
   * @memberof AttendeeInput
   */
  rsvp_comment?: string | null
}

/**
 *
 * @export
 * @interface BillingCacheClearResponse
 */
export interface BillingCacheClearResponse {
  /**
   * Cache keys that were deleted (whether or not they existed).
   * @type {Array<string>}
   * @memberof BillingCacheClearResponse
   */
  cleared: Array<string>
}
/**
 *
 * @export
 * @interface BillingCheckoutCompleteEmbeddedCreate400Response
 */
export interface BillingCheckoutCompleteEmbeddedCreate400Response {
  /**
   *
   * @type {string}
   * @memberof BillingCheckoutCompleteEmbeddedCreate400Response
   */
  error?: string
}
/**
 *
 * @export
 * @interface BillingCheckoutCreate200Response
 */
export interface BillingCheckoutCreate200Response {
  /**
   *
   * @type {string}
   * @memberof BillingCheckoutCreate200Response
   */
  client_secret?: string
}
/**
 *
 * @export
 * @interface BillingPortalUrl
 */
export interface BillingPortalUrl {
  /**
   *
   * @type {string}
   * @memberof BillingPortalUrl
   */
  url: string
}
/**
 *
 * @export
 * @interface BlockedSender
 */
export interface BlockedSender {
  /**
   *
   * @type {string}
   * @memberof BlockedSender
   */
  value: string
}
/**
 *
 * @export
 * @interface Calendar
 */
export interface Calendar {
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  id: string
  /**
   *
   * @type {CalendarChannel}
   * @memberof Calendar
   */
  active_channel: CalendarChannel
  /**
   *
   * @type {UiModeEnum}
   * @memberof Calendar
   */
  ui_mode: UiModeEnum
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  color: string | null
  /**
   * List of online-meeting / conferencing solution identifiers the remote calendar advertises support for. Microsoft values: teamsForBusiness, skypeForBusiness, skypeForConsumer, unknown. Google values: hangoutsMeet, eventHangout, eventNamedHangout. NULL means not yet populated; an empty list means the remote returned no allowed solutions (admin disabled).
   * @type {Array<string>}
   * @memberof Calendar
   */
  available_conference_solutions: Array<string> | null
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  remote_id: string
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  remote_address: string
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  name?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Calendar
   */
  is_primary?: boolean
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  time_zone: string
  /**
   *
   * @type {boolean}
   * @memberof Calendar
   */
  writeable?: boolean
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  ui_show_hotkey?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Calendar
   */
  is_synced?: boolean
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  last_synced?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Calendar
   */
  include_in_inbox?: boolean
  /**
   * Whether the user is the data owner of this calendar (vs shared/subscribed)
   * @type {boolean}
   * @memberof Calendar
   */
  is_owned?: boolean
  /**
   *
   * @type {string}
   * @memberof Calendar
   */
  calendar_account: string
}

/**
 *
 * @export
 * @interface CalendarAccount
 */
export interface CalendarAccount {
  /**
   *
   * @type {string}
   * @memberof CalendarAccount
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof CalendarAccount
   */
  provider: string
  /**
   * Email address of the calendar account
   * @type {string}
   * @memberof CalendarAccount
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof CalendarAccount
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof CalendarAccount
   */
  picture: string
  /**
   * Whether this is the primary calendar account for this provider
   * @type {boolean}
   * @memberof CalendarAccount
   */
  is_primary?: boolean
  /**
   *
   * @type {string}
   * @memberof CalendarAccount
   */
  connected_at: string
  /**
   *
   * @type {Features}
   * @memberof CalendarAccount
   */
  features: Features
}
/**
 *
 * @export
 * @interface CalendarAccountTokenNotFound
 */
export interface CalendarAccountTokenNotFound {
  /**
   *
   * @type {string}
   * @memberof CalendarAccountTokenNotFound
   */
  error: string
}
/**
 *
 * @export
 * @interface CalendarChannel
 */
export interface CalendarChannel {
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  channel_id: string
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  resource_uri: string
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  resource_id: string
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  expiration: string
  /**
   *
   * @type {string}
   * @memberof CalendarChannel
   */
  last_notified?: string | null
  /**
   *
   * @type {boolean}
   * @memberof CalendarChannel
   */
  is_stopped?: boolean
}
/**
 *
 * @export
 * @interface CalendarGroup
 */
export interface CalendarGroup {
  /**
   *
   * @type {Array<CalendarGroupMembership>}
   * @memberof CalendarGroup
   */
  calendars: Array<CalendarGroupMembership>
  /**
   *
   * @type {string}
   * @memberof CalendarGroup
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof CalendarGroup
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof CalendarGroup
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof CalendarGroup
   */
  name?: string | null
  /**
   *
   * @type {number}
   * @memberof CalendarGroup
   */
  ordinal: number
  /**
   *
   * @type {boolean}
   * @memberof CalendarGroup
   */
  is_default: boolean
  /**
   *
   * @type {number}
   * @memberof CalendarGroup
   */
  user: number
}
/**
 *
 * @export
 * @interface CalendarGroupMembership
 */
export interface CalendarGroupMembership {
  /**
   *
   * @type {Calendar}
   * @memberof CalendarGroupMembership
   */
  calendar: Calendar
  /**
   *
   * @type {CalendarVisibility}
   * @memberof CalendarGroupMembership
   */
  visibility: CalendarVisibility
  /**
   *
   * @type {string}
   * @memberof CalendarGroupMembership
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof CalendarGroupMembership
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof CalendarGroupMembership
   */
  updated: string
  /**
   *
   * @type {number}
   * @memberof CalendarGroupMembership
   */
  ordinal: number
  /**
   *
   * @type {string}
   * @memberof CalendarGroupMembership
   */
  calendar_group: string
}

/**
 *
 * @export
 * @interface CalendarOrder
 */
export interface CalendarOrder {
  /**
   *
   * @type {string}
   * @memberof CalendarOrder
   */
  remote_address: string
  /**
   *
   * @type {number}
   * @memberof CalendarOrder
   */
  ordinal: number
}
/**
 * * `ALWAYS_SHOW` - ALWAYS_SHOW * `BACKGROUND` - BACKGROUND
 * @export
 * @enum {string}
 */

export const CalendarVisibility = {
  AlwaysShow: 'ALWAYS_SHOW',
  Background: 'BACKGROUND'
} as const

export type CalendarVisibility = (typeof CalendarVisibility)[keyof typeof CalendarVisibility]

/**
 *
 * @export
 * @interface Checkout
 */
export interface Checkout {
  /**
   *
   * @type {SkuEnum}
   * @memberof Checkout
   */
  sku?: SkuEnum | null
  /**
   *
   * @type {IntervalEnum}
   * @memberof Checkout
   */
  interval: IntervalEnum
  /**
   *
   * @type {boolean}
   * @memberof Checkout
   */
  embedded?: boolean
}

/**
 *
 * @export
 * @interface CompleteEmbeddedCheckout
 */
export interface CompleteEmbeddedCheckout {
  /**
   *
   * @type {string}
   * @memberof CompleteEmbeddedCheckout
   */
  checkout_session_id: string
}
/**
 *
 * @export
 * @interface ConferencingDetails
 */
export interface ConferencingDetails {
  /**
   *
   * @type {ConferencingDetailsPlatformEnum}
   * @memberof ConferencingDetails
   */
  platform: ConferencingDetailsPlatformEnum
  /**
   *
   * @type {string}
   * @memberof ConferencingDetails
   */
  remote_conference_id: string | null
  /**
   *
   * @type {string}
   * @memberof ConferencingDetails
   */
  join_url: string | null
  /**
   *
   * @type {string}
   * @memberof ConferencingDetails
   */
  pin: string | null
  /**
   *
   * @type {string}
   * @memberof ConferencingDetails
   */
  password: string | null
}

/**
 * * `ZOOM` - ZOOM * `GOOGLE_MEET` - GOOGLE_MEET * `MICROSOFT_TEAMS` - MICROSOFT_TEAMS * `CISCO_WEBEX` - CISCO_WEBEX * `GOTOMEETING` - GOTOMEETING * `SKYPE` - SKYPE * `JITSI` - JITSI * `RINGCENTRAL` - RINGCENTRAL * `GONG` - GONG
 * @export
 * @enum {string}
 */

export const ConferencingDetailsPlatformEnum = {
  Zoom: 'ZOOM',
  GoogleMeet: 'GOOGLE_MEET',
  MicrosoftTeams: 'MICROSOFT_TEAMS',
  CiscoWebex: 'CISCO_WEBEX',
  Gotomeeting: 'GOTOMEETING',
  Skype: 'SKYPE',
  Jitsi: 'JITSI',
  Ringcentral: 'RINGCENTRAL',
  Gong: 'GONG'
} as const

export type ConferencingDetailsPlatformEnum =
  (typeof ConferencingDetailsPlatformEnum)[keyof typeof ConferencingDetailsPlatformEnum]

/**
 *
 * @export
 * @interface ConnectedOAuthApp
 */
export interface ConnectedOAuthApp {
  /**
   *
   * @type {number}
   * @memberof ConnectedOAuthApp
   */
  application_id: number
  /**
   *
   * @type {string}
   * @memberof ConnectedOAuthApp
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ConnectedOAuthApp
   */
  client_id: string
  /**
   *
   * @type {Array<string>}
   * @memberof ConnectedOAuthApp
   */
  scopes: Array<string>
  /**
   *
   * @type {string}
   * @memberof ConnectedOAuthApp
   */
  expires_at: string | null
}
/**
 *
 * @export
 * @interface CreateCalendarGroupRequest
 */
export interface CreateCalendarGroupRequest {
  /**
   *
   * @type {string}
   * @memberof CreateCalendarGroupRequest
   */
  name?: string | null
}
/**
 * * `ZOOM` - 0 * `GOOGLE_MEET` - 1 * `MICROSOFT_TEAMS` - 2 * `CISCO_WEBEX` - 3 * `GOTOMEETING` - 4 * `SKYPE` - 5 * `JITSI` - 6 * `RINGCENTRAL` - 7 * `GONG` - 8
 * @export
 * @enum {string}
 */

export const DefaultConferencePlatformEnum = {
  Zoom: 'ZOOM',
  GoogleMeet: 'GOOGLE_MEET',
  MicrosoftTeams: 'MICROSOFT_TEAMS',
  CiscoWebex: 'CISCO_WEBEX',
  Gotomeeting: 'GOTOMEETING',
  Skype: 'SKYPE',
  Jitsi: 'JITSI',
  Ringcentral: 'RINGCENTRAL',
  Gong: 'GONG'
} as const

export type DefaultConferencePlatformEnum =
  (typeof DefaultConferencePlatformEnum)[keyof typeof DefaultConferencePlatformEnum]

/**
 *
 * @export
 * @interface DesktopNotificationSettings
 */
export interface DesktopNotificationSettings {
  /**
   *
   * @type {boolean}
   * @memberof DesktopNotificationSettings
   */
  is_enabled?: boolean
  /**
   *
   * @type {boolean}
   * @memberof DesktopNotificationSettings
   */
  is_high_visibility?: boolean
  /**
   *
   * @type {boolean}
   * @memberof DesktopNotificationSettings
   */
  is_sound_enabled?: boolean
}
/**
 *
 * @export
 * @interface DisconnectError
 */
export interface DisconnectError {
  /**
   *
   * @type {string}
   * @memberof DisconnectError
   */
  error: string
}
/**
 *
 * @export
 * @interface DisconnectRequest
 */
export interface DisconnectRequest {
  /**
   *
   * @type {string}
   * @memberof DisconnectRequest
   */
  calendar_account_id: string
}
/**
 * * `SMALL` - Small * `MEDIUM` - Medium * `LARGE` - Large
 * @export
 * @enum {string}
 */

export const EditorTextSizeEnum = {
  Small: 'SMALL',
  Medium: 'MEDIUM',
  Large: 'LARGE'
} as const

export type EditorTextSizeEnum = (typeof EditorTextSizeEnum)[keyof typeof EditorTextSizeEnum]

/**
 *
 * @export
 * @interface Entitlement
 */
export interface Entitlement {
  /**
   *
   * @type {string}
   * @memberof Entitlement
   */
  sku?: string | null
  /**
   *
   * @type {Limits}
   * @memberof Entitlement
   */
  limits?: Limits
}
/**
 *
 * @export
 * @interface Event
 */
export interface Event {
  /**
   *
   * @type {Array<Attendee>}
   * @memberof Event
   */
  attendees: Array<Attendee>
  /**
   *
   * @type {Array<Attachment>}
   * @memberof Event
   */
  attachments: Array<Attachment>
  /**
   *
   * @type {Array<EventLabel>}
   * @memberof Event
   */
  labels: Array<EventLabel>
  /**
   *
   * @type {string}
   * @memberof Event
   */
  recurrence_id: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof Event
   */
  recurrence: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof Event
   */
  series_recurrence: Array<string>
  /**
   *
   * @type {RecurrenceFrequencyEnum}
   * @memberof Event
   */
  recurrence_frequency: RecurrenceFrequencyEnum | null
  /**
   *
   * @type {EventStatusEnum}
   * @memberof Event
   */
  status: EventStatusEnum
  /**
   *
   * @type {ConferencingDetails}
   * @memberof Event
   */
  conferencing_details: ConferencingDetails | null
  /**
   *
   * @type {Notability}
   * @memberof Event
   */
  notability: Notability
  /**
   *
   * @type {SenderTrust}
   * @memberof Event
   */
  sender_trust: SenderTrust | null
  /**
   *
   * @type {MuteLevelEnum}
   * @memberof Event
   */
  mute_level: MuteLevelEnum
  /**
   *
   * @type {VisibilityEnum}
   * @memberof Event
   */
  visibility: VisibilityEnum
  /**
   *
   * @type {string}
   * @memberof Event
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  creator?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  organizer?: string | null
  /**
   *
   * @type {number}
   * @memberof Event
   */
  sequence?: number
  /**
   *
   * @type {string}
   * @memberof Event
   */
  uid: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  remote_id: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  remote_series_id?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  remote_etag?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  remote_created_at?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  remote_updated_at?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  description?: string | null
  /**
   *
   * @type {number}
   * @memberof Event
   */
  attendee_count?: number
  /**
   *
   * @type {string}
   * @memberof Event
   */
  status_updated?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  location?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  start_time: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  start_time_zone?: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  end_time: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  end_time_zone?: string
  /**
   *
   * @type {boolean}
   * @memberof Event
   */
  is_all_day?: boolean
  /**
   *
   * @type {string}
   * @memberof Event
   */
  recurrence_summary?: string | null
  /**
   *
   * @type {string}
   * @memberof Event
   */
  recurrence_end_date?: string | null
  /**
   *
   * @type {EventTypeEnum}
   * @memberof Event
   */
  event_type?: EventTypeEnum
  /**
   *
   * @type {string}
   * @memberof Event
   */
  calendar: string
  /**
   *
   * @type {string}
   * @memberof Event
   */
  series: string | null
}

/**
 *
 * @export
 * @interface EventBatchGet
 */
export interface EventBatchGet {
  /**
   *
   * @type {string}
   * @memberof EventBatchGet
   */
  event_id: string
  /**
   *
   * @type {boolean}
   * @memberof EventBatchGet
   */
  exists: boolean
  /**
   *
   * @type {Event}
   * @memberof EventBatchGet
   */
  event: Event | null
}
/**
 *
 * @export
 * @interface EventBatchGetRequest
 */
export interface EventBatchGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof EventBatchGetRequest
   */
  event_ids: Array<string>
}
/**
 *
 * @export
 * @interface EventBatchGetResponse
 */
export interface EventBatchGetResponse {
  /**
   *
   * @type {Array<EventBatchGet>}
   * @memberof EventBatchGetResponse
   */
  events: Array<EventBatchGet>
}
/**
 *
 * @export
 * @interface EventLabel
 */
export interface EventLabel {
  /**
   *
   * @type {Label}
   * @memberof EventLabel
   */
  label: Label
  /**
   *
   * @type {ApplierTypeEnum}
   * @memberof EventLabel
   */
  applier_type: ApplierTypeEnum
  /**
   *
   * @type {string}
   * @memberof EventLabel
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof EventLabel
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof EventLabel
   */
  event: string
}

/**
 *
 * @export
 * @interface EventParams
 */
export interface EventParams {
  /**
   *
   * @type {string}
   * @memberof EventParams
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof EventParams
   */
  start_time: string
  /**
   *
   * @type {string}
   * @memberof EventParams
   */
  start_time_zone: string
  /**
   *
   * @type {string}
   * @memberof EventParams
   */
  end_time: string
  /**
   *
   * @type {string}
   * @memberof EventParams
   */
  end_time_zone: string
  /**
   *
   * @type {string}
   * @memberof EventParams
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof EventParams
   */
  location?: string | null
  /**
   *
   * @type {boolean}
   * @memberof EventParams
   */
  is_all_day?: boolean
  /**
   *
   * @type {Array<AttendeeInput>}
   * @memberof EventParams
   */
  attendees?: Array<AttendeeInput>
  /**
   *
   * @type {Array<Attachment>}
   * @memberof EventParams
   */
  attachments?: Array<Attachment>
  /**
   *
   * @type {Array<string>}
   * @memberof EventParams
   */
  recurrence?: Array<string>
  /**
   *
   * @type {EventStatusEnum}
   * @memberof EventParams
   */
  status?: EventStatusEnum
  /**
   *
   * @type {ConferencingDetails}
   * @memberof EventParams
   */
  conferencing_details?: ConferencingDetails | null
  /**
   *
   * @type {MuteLevelEnum}
   * @memberof EventParams
   */
  mute_level?: MuteLevelEnum
  /**
   *
   * @type {VisibilityEnum}
   * @memberof EventParams
   */
  visibility?: VisibilityEnum
  /**
   *
   * @type {EventTypeEnum}
   * @memberof EventParams
   */
  event_type?: EventTypeEnum
}

/**
 * * `TENTATIVE` - TENTATIVE * `CONFIRMED` - CONFIRMED * `CANCELLED` - CANCELLED * `DELETED` - DELETED
 * @export
 * @enum {string}
 */

export const EventStatusEnum = {
  Tentative: 'TENTATIVE',
  Confirmed: 'CONFIRMED',
  Cancelled: 'CANCELLED',
  Deleted: 'DELETED'
} as const

export type EventStatusEnum = (typeof EventStatusEnum)[keyof typeof EventStatusEnum]

/**
 * * `default` - Default * `focusTime` - Focus time * `outOfOffice` - Out of office * `workingLocation` - Working location * `birthday` - Birthday
 * @export
 * @enum {string}
 */

export const EventTypeEnum = {
  Default: 'default',
  FocusTime: 'focusTime',
  OutOfOffice: 'outOfOffice',
  WorkingLocation: 'workingLocation',
  Birthday: 'birthday'
} as const

export type EventTypeEnum = (typeof EventTypeEnum)[keyof typeof EventTypeEnum]

/**
 * Serializer for FCMDevice model.
 * @export
 * @interface FCMDevice
 */
export interface FCMDevice {
  /**
   *
   * @type {string}
   * @memberof FCMDevice
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof FCMDevice
   */
  registration_id: string
  /**
   *
   * @type {FCMDevicePlatformEnum}
   * @memberof FCMDevice
   */
  platform: FCMDevicePlatformEnum
  /**
   * Device model from Capacitor (e.g., \'iPhone13,4\', \'SM-S911B\'). Maps to DeviceInfo.model
   * @type {string}
   * @memberof FCMDevice
   */
  device_model?: string | null
  /**
   * Device manufacturer from Capacitor (e.g., \'Apple\', \'Samsung\'). Maps to DeviceInfo.manufacturer
   * @type {string}
   * @memberof FCMDevice
   */
  manufacturer?: string | null
  /**
   * OS version from Capacitor (e.g., \'17.0\', \'14\'). Maps to DeviceInfo.osVersion
   * @type {string}
   * @memberof FCMDevice
   */
  os_version?: string | null
  /**
   * User-assigned device name from Capacitor (e.g., \'John\'s iPhone\'). Maps to DeviceInfo.name. Optional.
   * @type {string}
   * @memberof FCMDevice
   */
  device_name?: string | null
  /**
   * Whether device is a simulator/emulator. Maps to DeviceInfo.isVirtual
   * @type {boolean}
   * @memberof FCMDevice
   */
  is_virtual?: boolean | null
  /**
   *
   * @type {string}
   * @memberof FCMDevice
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof FCMDevice
   */
  updated: string
  /**
   * Last time this device registered/updated its token
   * @type {string}
   * @memberof FCMDevice
   */
  last_seen: string
}

/**
 * * `ios` - iOS * `android` - Android
 * @export
 * @enum {string}
 */

export const FCMDevicePlatformEnum = {
  Ios: 'ios',
  Android: 'android'
} as const

export type FCMDevicePlatformEnum =
  (typeof FCMDevicePlatformEnum)[keyof typeof FCMDevicePlatformEnum]

/**
 *
 * @export
 * @interface FeatureAuthorization
 */
export interface FeatureAuthorization {
  /**
   *
   * @type {boolean}
   * @memberof FeatureAuthorization
   */
  required: boolean
  /**
   *
   * @type {boolean}
   * @memberof FeatureAuthorization
   */
  is_authorized: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof FeatureAuthorization
   */
  scopes: Array<string>
}
/**
 *
 * @export
 * @interface Features
 */
export interface Features {
  /**
   *
   * @type {FeatureAuthorization}
   * @memberof Features
   */
  calendar: FeatureAuthorization
  /**
   *
   * @type {FeatureAuthorization}
   * @memberof Features
   */
  contacts: FeatureAuthorization
  /**
   *
   * @type {FeatureAuthorization}
   * @memberof Features
   */
  resources: FeatureAuthorization
}
/**
 *
 * @export
 * @interface Folder
 */
export interface Folder {
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof Folder
   */
  user: number
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  parent_id: string | null
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  purpose?: string | null
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  sort_key?: string
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  deleted_at: string | null
  /**
   *
   * @type {boolean}
   * @memberof Folder
   */
  is_space?: boolean
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  icon?: string | null
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  color?: string | null
  /**
   *
   * @type {string}
   * @memberof Folder
   */
  template_id?: string | null
  /**
   *
   * @type {any}
   * @memberof Folder
   */
  template_state?: any
  /**
   *
   * @type {FolderSpaceNote}
   * @memberof Folder
   */
  space_note: FolderSpaceNote | null
}
/**
 *
 * @export
 * @interface FolderBreadcrumb
 */
export interface FolderBreadcrumb {
  /**
   *
   * @type {string}
   * @memberof FolderBreadcrumb
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof FolderBreadcrumb
   */
  name: string
}
/**
 * Folder serializer used only for POST. Extends FolderSerializer with an optional initial ``space_note_content`` to seed the auto-created space_note when is_space=True. The read/update serializer does not expose this field so it stays out of GET responses and PATCH requests.
 * @export
 * @interface FolderCreate
 */
export interface FolderCreate {
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof FolderCreate
   */
  user: number
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  parent_id: string | null
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  purpose?: string | null
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  sort_key?: string
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  deleted_at: string | null
  /**
   *
   * @type {boolean}
   * @memberof FolderCreate
   */
  is_space?: boolean
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  icon?: string | null
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  color?: string | null
  /**
   *
   * @type {string}
   * @memberof FolderCreate
   */
  template_id?: string | null
  /**
   *
   * @type {any}
   * @memberof FolderCreate
   */
  template_state?: any
  /**
   *
   * @type {FolderSpaceNote}
   * @memberof FolderCreate
   */
  space_note: FolderSpaceNote | null
  /**
   * Optional HTML to seed the auto-created space_note when is_space=True. Ignored otherwise.
   * @type {string}
   * @memberof FolderCreate
   */
  space_note_content?: string | null
}
/**
 * One folder move: id and optional parent_id and position. Position: provide at most one of sort_key (explicit), after_id (insert after), or before_id (insert before).
 * @export
 * @interface FolderMoveItem
 */
export interface FolderMoveItem {
  /**
   *
   * @type {string}
   * @memberof FolderMoveItem
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof FolderMoveItem
   */
  parent_id?: string | null
  /**
   *
   * @type {string}
   * @memberof FolderMoveItem
   */
  sort_key?: string | null
  /**
   *
   * @type {string}
   * @memberof FolderMoveItem
   */
  after_id?: string | null
  /**
   *
   * @type {string}
   * @memberof FolderMoveItem
   */
  before_id?: string | null
}
/**
 * @type FolderSpaceNote
 * @export
 */
export type FolderSpaceNote = NoteItem

/**
 *
 * @export
 * @interface FoldersScaffoldParaCreate201Response
 */
export interface FoldersScaffoldParaCreate201Response {
  /**
   *
   * @type {Array<Folder>}
   * @memberof FoldersScaffoldParaCreate201Response
   */
  folders?: Array<Folder>
  /**
   *
   * @type {Array<string>}
   * @memberof FoldersScaffoldParaCreate201Response
   */
  folder_ids?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof FoldersScaffoldParaCreate201Response
   */
  readme_note_ids?: Array<string>
  /**
   *
   * @type {string}
   * @memberof FoldersScaffoldParaCreate201Response
   */
  top_level_readme_note_id?: string | null
}
/**
 *
 * @export
 * @interface GoogleAuthHandleCodeError
 */
export interface GoogleAuthHandleCodeError {
  /**
   *
   * @type {string}
   * @memberof GoogleAuthHandleCodeError
   */
  error: string
}
/**
 *
 * @export
 * @interface GoogleAuthHandleCodeRequest
 */
export interface GoogleAuthHandleCodeRequest {
  /**
   *
   * @type {string}
   * @memberof GoogleAuthHandleCodeRequest
   */
  code: string
  /**
   *
   * @type {GoogleAuthHandleCodeRequestPlatformEnum}
   * @memberof GoogleAuthHandleCodeRequest
   */
  platform?: GoogleAuthHandleCodeRequestPlatformEnum
  /**
   *
   * @type {ProcessEnum}
   * @memberof GoogleAuthHandleCodeRequest
   */
  process?: ProcessEnum
}

/**
 * * `android` - android * `ios` - ios * `macos` - macos * `windows` - windows * `web` - web
 * @export
 * @enum {string}
 */

export const GoogleAuthHandleCodeRequestPlatformEnum = {
  Android: 'android',
  Ios: 'ios',
  Macos: 'macos',
  Windows: 'windows',
  Web: 'web'
} as const

export type GoogleAuthHandleCodeRequestPlatformEnum =
  (typeof GoogleAuthHandleCodeRequestPlatformEnum)[keyof typeof GoogleAuthHandleCodeRequestPlatformEnum]

/**
 *
 * @export
 * @interface GoogleAuthHandleCodeResponse
 */
export interface GoogleAuthHandleCodeResponse {
  /**
   *
   * @type {string}
   * @memberof GoogleAuthHandleCodeResponse
   */
  token: string
}
/**
 *
 * @export
 * @interface GroupOrder
 */
export interface GroupOrder {
  /**
   *
   * @type {string}
   * @memberof GroupOrder
   */
  calendar_group_id: string
  /**
   *
   * @type {number}
   * @memberof GroupOrder
   */
  ordinal: number
}
/**
 *
 * @export
 * @interface GroupedCalendarsResponse
 */
export interface GroupedCalendarsResponse {
  /**
   *
   * @type {Array<Calendar>}
   * @memberof GroupedCalendarsResponse
   */
  email: Array<Calendar>
}
/**
 *
 * @export
 * @interface IntegrationToken
 */
export interface IntegrationToken {
  /**
   *
   * @type {string}
   * @memberof IntegrationToken
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof IntegrationToken
   */
  expires_at: string
  /**
   *
   * @type {Features}
   * @memberof IntegrationToken
   */
  features: Features
}
/**
 * * `1-month` - 1-month * `1-year` - 1-year * `lifetime` - lifetime
 * @export
 * @enum {string}
 */

export const IntervalEnum = {
  _1Month: '1-month',
  _1Year: '1-year',
  Lifetime: 'lifetime'
} as const

export type IntervalEnum = (typeof IntervalEnum)[keyof typeof IntervalEnum]

/**
 * * `mcp` - MCP
 * @export
 * @enum {string}
 */

export const KindEnum = {
  Mcp: 'mcp'
} as const

export type KindEnum = (typeof KindEnum)[keyof typeof KindEnum]

/**
 *
 * @export
 * @interface Label
 */
export interface Label {
  /**
   *
   * @type {string}
   * @memberof Label
   */
  color: string
  /**
   *
   * @type {string}
   * @memberof Label
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Label
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof Label
   */
  updated: string
  /**
   *
   * @type {string}
   * @memberof Label
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof Label
   */
  user: number | null
}
/**
 * * `trusted` - trusted * `suspicious` - suspicious * `high-risk` - high-risk
 * @export
 * @enum {string}
 */

export const LevelEnum = {
  Trusted: 'trusted',
  Suspicious: 'suspicious',
  HighRisk: 'high-risk'
} as const

export type LevelEnum = (typeof LevelEnum)[keyof typeof LevelEnum]

/**
 *
 * @export
 * @interface Limits
 */
export interface Limits {
  /**
   *
   * @type {SpaceLimit}
   * @memberof Limits
   */
  spaces: SpaceLimit
}
/**
 *
 * @export
 * @interface MoveCreate200Response
 */
export interface MoveCreate200Response {
  /**
   *
   * @type {number}
   * @memberof MoveCreate200Response
   */
  folder_moves_applied?: number
  /**
   *
   * @type {number}
   * @memberof MoveCreate200Response
   */
  note_moves_applied?: number
}
/**
 * Request body for bulk move: one or more folder and/or note moves.
 * @export
 * @interface MoveRequest
 */
export interface MoveRequest {
  /**
   *
   * @type {Array<FolderMoveItem>}
   * @memberof MoveRequest
   */
  folder_moves?: Array<FolderMoveItem>
  /**
   *
   * @type {Array<NoteMoveItem>}
   * @memberof MoveRequest
   */
  note_moves?: Array<NoteMoveItem>
}
/**
 * * `UNMUTED` - UNMUTED * `MUTE_RSVP` - MUTE_RSVP
 * @export
 * @enum {string}
 */

export const MuteLevelEnum = {
  Unmuted: 'UNMUTED',
  MuteRsvp: 'MUTE_RSVP'
} as const

export type MuteLevelEnum = (typeof MuteLevelEnum)[keyof typeof MuteLevelEnum]

/**
 *
 * @export
 * @interface NewLabel
 */
export interface NewLabel {
  /**
   *
   * @type {string}
   * @memberof NewLabel
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof NewLabel
   */
  color: string
}
/**
 *
 * @export
 * @interface Notability
 */
export interface Notability {
  /**
   *
   * @type {boolean}
   * @memberof Notability
   */
  is_notable: boolean
  /**
   *
   * @type {number}
   * @memberof Notability
   */
  score: number
  /**
   *
   * @type {Array<string>}
   * @memberof Notability
   */
  reasons: Array<string>
}
/**
 *
 * @export
 * @interface NotableEvent
 */
export interface NotableEvent {
  /**
   *
   * @type {Event}
   * @memberof NotableEvent
   */
  event: Event
  /**
   *
   * @type {Array<string>}
   * @memberof NotableEvent
   */
  reasons: Array<string>
  /**
   *
   * @type {number}
   * @memberof NotableEvent
   */
  score: number
}
/**
 *
 * @export
 * @interface Note
 */
export interface Note {
  /**
   *
   * @type {string}
   * @memberof Note
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof Note
   */
  user: number
  /**
   *
   * @type {NoteTypeEnum}
   * @memberof Note
   */
  type: NoteTypeEnum
  /**
   *
   * @type {string}
   * @memberof Note
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof Note
   */
  content?: string
  /**
   *
   * @type {number}
   * @memberof Note
   */
  content_length: number
  /**
   *
   * @type {number}
   * @memberof Note
   */
  content_raw_length: number
  /**
   *
   * @type {string}
   * @memberof Note
   */
  creation_date: string
  /**
   *
   * @type {string}
   * @memberof Note
   */
  last_modified_date: string
  /**
   *
   * @type {string}
   * @memberof Note
   */
  associated_event?: string | null
  /**
   *
   * @type {string}
   * @memberof Note
   */
  associated_date?: string | null
  /**
   *
   * @type {string}
   * @memberof Note
   */
  associated_week?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Note
   */
  is_pinned: boolean
  /**
   *
   * @type {number}
   * @memberof Note
   */
  ordinal: number | null
  /**
   *
   * @type {any}
   * @memberof Note
   */
  associated_event_known_source_calendars?: any
  /**
   *
   * @type {string}
   * @memberof Note
   */
  folder_id: string | null
  /**
   *
   * @type {string}
   * @memberof Note
   */
  sort_key: string
  /**
   *
   * @type {string}
   * @memberof Note
   */
  after_note_id?: string | null
  /**
   *
   * @type {SourceEnum}
   * @memberof Note
   */
  source: SourceEnum
  /**
   *
   * @type {string}
   * @memberof Note
   */
  source_client: string | null
}

/**
 *
 * @export
 * @interface NoteItem
 */
export interface NoteItem {
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof NoteItem
   */
  user: number
  /**
   *
   * @type {NoteTypeEnum}
   * @memberof NoteItem
   */
  type: NoteTypeEnum
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  title: string
  /**
   *
   * @type {number}
   * @memberof NoteItem
   */
  content_length: number
  /**
   *
   * @type {number}
   * @memberof NoteItem
   */
  content_raw_length: number
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  creation_date: string
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  last_modified_date: string
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  associated_date: string | null
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  associated_week?: string | null
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  associated_event?: string | null
  /**
   *
   * @type {any}
   * @memberof NoteItem
   */
  associated_event_known_source_calendars?: any
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  folder_id: string | null
  /**
   *
   * @type {Array<FolderBreadcrumb>}
   * @memberof NoteItem
   */
  folder_breadcrumbs: Array<FolderBreadcrumb>
  /**
   *
   * @type {number}
   * @memberof NoteItem
   */
  ordinal: number | null
  /**
   *
   * @type {boolean}
   * @memberof NoteItem
   */
  is_pinned: boolean
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  sort_key?: string
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  pin_sort_key?: string | null
  /**
   *
   * @type {SourceEnum}
   * @memberof NoteItem
   */
  source: SourceEnum
  /**
   *
   * @type {string}
   * @memberof NoteItem
   */
  source_client: string | null
}

/**
 * One note move: id, optional folder_id (null = unfiled), optional position. Position: provide at most one of sort_key, after_id, or before_id. after_id/before_id note must be in the target folder.
 * @export
 * @interface NoteMoveItem
 */
export interface NoteMoveItem {
  /**
   *
   * @type {string}
   * @memberof NoteMoveItem
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof NoteMoveItem
   */
  folder_id?: string | null
  /**
   *
   * @type {string}
   * @memberof NoteMoveItem
   */
  sort_key?: string | null
  /**
   *
   * @type {string}
   * @memberof NoteMoveItem
   */
  after_id?: string | null
  /**
   *
   * @type {string}
   * @memberof NoteMoveItem
   */
  before_id?: string | null
}
/**
 *
 * @export
 * @interface NoteSearchResult
 */
export interface NoteSearchResult {
  /**
   *
   * @type {string}
   * @memberof NoteSearchResult
   */
  title_snippet: string | null
  /**
   *
   * @type {string}
   * @memberof NoteSearchResult
   */
  content_snippet: string | null
  /**
   *
   * @type {NoteItem}
   * @memberof NoteSearchResult
   */
  note: NoteItem
}
/**
 *
 * @export
 * @interface NoteTemplate
 */
export interface NoteTemplate {
  /**
   *
   * @type {string}
   * @memberof NoteTemplate
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof NoteTemplate
   */
  user: number
  /**
   *
   * @type {TypeEnum}
   * @memberof NoteTemplate
   */
  type: TypeEnum
  /**
   *
   * @type {string}
   * @memberof NoteTemplate
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof NoteTemplate
   */
  content: string
  /**
   *
   * @type {boolean}
   * @memberof NoteTemplate
   */
  is_public?: boolean
  /**
   *
   * @type {string}
   * @memberof NoteTemplate
   */
  creation_date: string
  /**
   *
   * @type {string}
   * @memberof NoteTemplate
   */
  last_modified_date: string
}

/**
 * * `ADHOC` - ADHOC * `EVENT` - EVENT * `DAILY` - DAILY * `WEEKLY` - WEEKLY * `SPACE` - SPACE
 * @export
 * @enum {string}
 */

export const NoteTypeEnum = {
  Adhoc: 'ADHOC',
  Event: 'EVENT',
  Daily: 'DAILY',
  Weekly: 'WEEKLY',
  Space: 'SPACE'
} as const

export type NoteTypeEnum = (typeof NoteTypeEnum)[keyof typeof NoteTypeEnum]

/**
 *
 * @export
 * @interface NotesCleanCreate200Response
 */
export interface NotesCleanCreate200Response {
  /**
   * IDs of notes removed (or that would be removed if dry_run=true).
   * @type {Array<string>}
   * @memberof NotesCleanCreate200Response
   */
  note_ids?: Array<string>
  /**
   * Number of notes.
   * @type {number}
   * @memberof NotesCleanCreate200Response
   */
  count?: number
  /**
   * Echo of request dry_run.
   * @type {boolean}
   * @memberof NotesCleanCreate200Response
   */
  dry_run?: boolean
  /**
   * Per-note details (title, content_raw_length, last_modified_date) for display.
   * @type {Array<NotesCleanCreate200ResponseNotesInner>}
   * @memberof NotesCleanCreate200Response
   */
  notes?: Array<NotesCleanCreate200ResponseNotesInner>
}
/**
 *
 * @export
 * @interface NotesCleanCreate200ResponseNotesInner
 */
export interface NotesCleanCreate200ResponseNotesInner {
  /**
   *
   * @type {string}
   * @memberof NotesCleanCreate200ResponseNotesInner
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof NotesCleanCreate200ResponseNotesInner
   */
  title?: string
  /**
   *
   * @type {number}
   * @memberof NotesCleanCreate200ResponseNotesInner
   */
  content_raw_length?: number | null
  /**
   *
   * @type {string}
   * @memberof NotesCleanCreate200ResponseNotesInner
   */
  last_modified_date?: string | null
}
/**
 *
 * @export
 * @interface NotesCleanCreateRequest
 */
export interface NotesCleanCreateRequest {
  /**
   * If true, return note_ids that would be removed without changing anything.
   * @type {boolean}
   * @memberof NotesCleanCreateRequest
   */
  dry_run?: boolean
  /**
   * Note IDs to skip (keep); excluded from cleaning.
   * @type {Array<string>}
   * @memberof NotesCleanCreateRequest
   */
  ignore_note_ids?: Array<string>
}
/**
 *
 * @export
 * @interface NotesCreateRequest
 */
export interface NotesCreateRequest {
  /**
   * Title of the note
   * @type {string}
   * @memberof NotesCreateRequest
   */
  title: string
  /**
   * Content of the note
   * @type {string}
   * @memberof NotesCreateRequest
   */
  content: string
  /**
   * Folder id to create the note in; omit or null for unfiled
   * @type {string}
   * @memberof NotesCreateRequest
   */
  folder_id?: string | null
  /**
   * If set, place the new note right after this note (same folder). Used e.g. when duplicating.
   * @type {string}
   * @memberof NotesCreateRequest
   */
  after_note_id?: string | null
}
/**
 *
 * @export
 * @interface NotesInitializeDemoNotesCreate200Response
 */
export interface NotesInitializeDemoNotesCreate200Response {
  /**
   *
   * @type {string}
   * @memberof NotesInitializeDemoNotesCreate200Response
   */
  detail?: string
}
/**
 *
 * @export
 * @interface NotesInitializeDemoNotesCreateRequest
 */
export interface NotesInitializeDemoNotesCreateRequest {
  /**
   * Platform the user is using
   * @type {string}
   * @memberof NotesInitializeDemoNotesCreateRequest
   */
  platform?: NotesInitializeDemoNotesCreateRequestPlatformEnum
}

export const NotesInitializeDemoNotesCreateRequestPlatformEnum = {
  MacOs: 'MacOS',
  Windows: 'Windows',
  Web: 'Web',
  IOs: 'iOS',
  Android: 'Android'
} as const

export type NotesInitializeDemoNotesCreateRequestPlatformEnum =
  (typeof NotesInitializeDemoNotesCreateRequestPlatformEnum)[keyof typeof NotesInitializeDemoNotesCreateRequestPlatformEnum]

/**
 *
 * @export
 * @enum {string}
 */

export const NullEnum = {
  Null: 'null'
} as const

export type NullEnum = (typeof NullEnum)[keyof typeof NullEnum]

/**
 *
 * @export
 * @interface Offer
 */
export interface Offer {
  /**
   * Filtered to the requesting platform. May be empty when this tier has no offer in that store.
   * @type {Array<OfferListing>}
   * @memberof Offer
   */
  listings: Array<OfferListing>
}
/**
 * What the client needs to register products and launch a purchase.  Nothing more. No offer set key, no control/variant flag, no price point name: this payload is readable in devtools, and any of those would tell a user they are in a price experiment and which arm. Purchases are attributed server-side from the store identifiers that come back on the purchase, so the client never needs to know or echo any of it.
 * @export
 * @interface OfferCatalog
 */
export interface OfferCatalog {
  /**
   * Opaque fingerprint of the offers below. Changes only when the offers change; use it to tell one cached catalog from another. Never send it back.
   * @type {string}
   * @memberof OfferCatalog
   */
  version: string
  /**
   * Purchasable tiers, keyed by sku (mobile | full)
   * @type {{ [key: string]: Offer; }}
   * @memberof OfferCatalog
   */
  offers: { [key: string]: Offer }
}
/**
 * One store\'s spelling of a price point for one period.  Deliberately carries no amount. The store quotes the price the user is charged; the reference amounts held server-side are for analysis, and shipping a second number the client could render out of step with the store\'s own would be a bug waiting to happen.
 * @export
 * @interface OfferListing
 */
export interface OfferListing {
  /**
   * P1M | P1Y
   * @type {string}
   * @memberof OfferListing
   */
  period: string
  /**
   * android | ios. Stripe listings exist server-side for desktop billing config and are never served here.
   * @type {string}
   * @memberof OfferListing
   */
  platform: string
  /**
   * Play subscriptionId or App Store productId
   * @type {string}
   * @memberof OfferListing
   */
  product_id: string
  /**
   * Play base plan id. Null means the client should fall back to the store\'s first matching offer. Always null on iOS.
   * @type {string}
   * @memberof OfferListing
   */
  offer_id?: string | null
}
/**
 *
 * @export
 * @interface OnboardingState
 */
export interface OnboardingState {
  /**
   *
   * @type {boolean}
   * @memberof OnboardingState
   */
  has_seen_account_initialization?: boolean
  /**
   *
   * @type {boolean}
   * @memberof OnboardingState
   */
  demo_notes_initialized: boolean
  /**
   *
   * @type {Array<OnboardingStep>}
   * @memberof OnboardingState
   */
  tutorial_steps?: Array<OnboardingStep>
  /**
   *
   * @type {boolean}
   * @memberof OnboardingState
   */
  has_completed_tutorial?: boolean
}
/**
 *
 * @export
 * @interface OnboardingStep
 */
export interface OnboardingStep {
  /**
   *
   * @type {string}
   * @memberof OnboardingStep
   */
  step: string
  /**
   *
   * @type {boolean}
   * @memberof OnboardingStep
   */
  is_completed: boolean
}
/**
 *
 * @export
 * @interface OneOnOneEvent
 */
export interface OneOnOneEvent {
  /**
   *
   * @type {Event}
   * @memberof OneOnOneEvent
   */
  event: Event
  /**
   *
   * @type {Array<Attendee>}
   * @memberof OneOnOneEvent
   */
  participants: Array<Attendee>
  /**
   *
   * @type {RecurrenceFrequencyEnum}
   * @memberof OneOnOneEvent
   */
  recurrence_frequency: RecurrenceFrequencyEnum
}

/**
 *
 * @export
 * @interface PaginatedAllowedSenderList
 */
export interface PaginatedAllowedSenderList {
  /**
   *
   * @type {string}
   * @memberof PaginatedAllowedSenderList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedAllowedSenderList
   */
  previous: string | null
  /**
   *
   * @type {Array<AllowedSender>}
   * @memberof PaginatedAllowedSenderList
   */
  results: Array<AllowedSender>
}
/**
 *
 * @export
 * @interface PaginatedApiTokenList
 */
export interface PaginatedApiTokenList {
  /**
   *
   * @type {string}
   * @memberof PaginatedApiTokenList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedApiTokenList
   */
  previous: string | null
  /**
   *
   * @type {Array<ApiToken>}
   * @memberof PaginatedApiTokenList
   */
  results: Array<ApiToken>
}
/**
 *
 * @export
 * @interface PaginatedBlockedSenderList
 */
export interface PaginatedBlockedSenderList {
  /**
   *
   * @type {string}
   * @memberof PaginatedBlockedSenderList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedBlockedSenderList
   */
  previous: string | null
  /**
   *
   * @type {Array<BlockedSender>}
   * @memberof PaginatedBlockedSenderList
   */
  results: Array<BlockedSender>
}
/**
 *
 * @export
 * @interface PaginatedCalendarAccountList
 */
export interface PaginatedCalendarAccountList {
  /**
   *
   * @type {string}
   * @memberof PaginatedCalendarAccountList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedCalendarAccountList
   */
  previous: string | null
  /**
   *
   * @type {Array<CalendarAccount>}
   * @memberof PaginatedCalendarAccountList
   */
  results: Array<CalendarAccount>
}
/**
 *
 * @export
 * @interface PaginatedCalendarGroupList
 */
export interface PaginatedCalendarGroupList {
  /**
   *
   * @type {string}
   * @memberof PaginatedCalendarGroupList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedCalendarGroupList
   */
  previous: string | null
  /**
   *
   * @type {Array<CalendarGroup>}
   * @memberof PaginatedCalendarGroupList
   */
  results: Array<CalendarGroup>
}
/**
 *
 * @export
 * @interface PaginatedCalendarList
 */
export interface PaginatedCalendarList {
  /**
   *
   * @type {string}
   * @memberof PaginatedCalendarList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedCalendarList
   */
  previous: string | null
  /**
   *
   * @type {Array<Calendar>}
   * @memberof PaginatedCalendarList
   */
  results: Array<Calendar>
}
/**
 *
 * @export
 * @interface PaginatedEventLabelList
 */
export interface PaginatedEventLabelList {
  /**
   *
   * @type {string}
   * @memberof PaginatedEventLabelList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedEventLabelList
   */
  previous: string | null
  /**
   *
   * @type {Array<EventLabel>}
   * @memberof PaginatedEventLabelList
   */
  results: Array<EventLabel>
}
/**
 *
 * @export
 * @interface PaginatedEventList
 */
export interface PaginatedEventList {
  /**
   *
   * @type {string}
   * @memberof PaginatedEventList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedEventList
   */
  previous: string | null
  /**
   *
   * @type {Array<Event>}
   * @memberof PaginatedEventList
   */
  results: Array<Event>
}
/**
 *
 * @export
 * @interface PaginatedFolderList
 */
export interface PaginatedFolderList {
  /**
   *
   * @type {string}
   * @memberof PaginatedFolderList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedFolderList
   */
  previous: string | null
  /**
   *
   * @type {Array<Folder>}
   * @memberof PaginatedFolderList
   */
  results: Array<Folder>
}
/**
 *
 * @export
 * @interface PaginatedLabelList
 */
export interface PaginatedLabelList {
  /**
   *
   * @type {string}
   * @memberof PaginatedLabelList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedLabelList
   */
  previous: string | null
  /**
   *
   * @type {Array<Label>}
   * @memberof PaginatedLabelList
   */
  results: Array<Label>
}
/**
 *
 * @export
 * @interface PaginatedNotableEventList
 */
export interface PaginatedNotableEventList {
  /**
   *
   * @type {string}
   * @memberof PaginatedNotableEventList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedNotableEventList
   */
  previous: string | null
  /**
   *
   * @type {Array<NotableEvent>}
   * @memberof PaginatedNotableEventList
   */
  results: Array<NotableEvent>
}
/**
 *
 * @export
 * @interface PaginatedNoteItemList
 */
export interface PaginatedNoteItemList {
  /**
   *
   * @type {string}
   * @memberof PaginatedNoteItemList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedNoteItemList
   */
  previous: string | null
  /**
   *
   * @type {Array<NoteItem>}
   * @memberof PaginatedNoteItemList
   */
  results: Array<NoteItem>
}
/**
 *
 * @export
 * @interface PaginatedNoteSearchResultList
 */
export interface PaginatedNoteSearchResultList {
  /**
   *
   * @type {string}
   * @memberof PaginatedNoteSearchResultList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedNoteSearchResultList
   */
  previous: string | null
  /**
   *
   * @type {Array<NoteSearchResult>}
   * @memberof PaginatedNoteSearchResultList
   */
  results: Array<NoteSearchResult>
}
/**
 *
 * @export
 * @interface PaginatedNoteTemplateList
 */
export interface PaginatedNoteTemplateList {
  /**
   *
   * @type {string}
   * @memberof PaginatedNoteTemplateList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedNoteTemplateList
   */
  previous: string | null
  /**
   *
   * @type {Array<NoteTemplate>}
   * @memberof PaginatedNoteTemplateList
   */
  results: Array<NoteTemplate>
}
/**
 *
 * @export
 * @interface PaginatedOneOnOneEventList
 */
export interface PaginatedOneOnOneEventList {
  /**
   *
   * @type {string}
   * @memberof PaginatedOneOnOneEventList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedOneOnOneEventList
   */
  previous: string | null
  /**
   *
   * @type {Array<OneOnOneEvent>}
   * @memberof PaginatedOneOnOneEventList
   */
  results: Array<OneOnOneEvent>
}
/**
 *
 * @export
 * @interface PaginatedPromoProgressList
 */
export interface PaginatedPromoProgressList {
  /**
   *
   * @type {string}
   * @memberof PaginatedPromoProgressList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedPromoProgressList
   */
  previous: string | null
  /**
   *
   * @type {Array<PromoProgress>}
   * @memberof PaginatedPromoProgressList
   */
  results: Array<PromoProgress>
}
/**
 *
 * @export
 * @interface PaginatedRecurringMeetingList
 */
export interface PaginatedRecurringMeetingList {
  /**
   *
   * @type {string}
   * @memberof PaginatedRecurringMeetingList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedRecurringMeetingList
   */
  previous: string | null
  /**
   *
   * @type {Array<RecurringMeeting>}
   * @memberof PaginatedRecurringMeetingList
   */
  results: Array<RecurringMeeting>
}
/**
 *
 * @export
 * @interface PaginatedUnrespondedEventList
 */
export interface PaginatedUnrespondedEventList {
  /**
   *
   * @type {string}
   * @memberof PaginatedUnrespondedEventList
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedUnrespondedEventList
   */
  previous: string | null
  /**
   *
   * @type {Array<UnrespondedEvent>}
   * @memberof PaginatedUnrespondedEventList
   */
  results: Array<UnrespondedEvent>
}
/**
 *
 * @export
 * @interface PatchedCalendar
 */
export interface PatchedCalendar {
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  id?: string
  /**
   *
   * @type {CalendarChannel}
   * @memberof PatchedCalendar
   */
  active_channel?: CalendarChannel
  /**
   *
   * @type {UiModeEnum}
   * @memberof PatchedCalendar
   */
  ui_mode?: UiModeEnum
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  color?: string | null
  /**
   * List of online-meeting / conferencing solution identifiers the remote calendar advertises support for. Microsoft values: teamsForBusiness, skypeForBusiness, skypeForConsumer, unknown. Google values: hangoutsMeet, eventHangout, eventNamedHangout. NULL means not yet populated; an empty list means the remote returned no allowed solutions (admin disabled).
   * @type {Array<string>}
   * @memberof PatchedCalendar
   */
  available_conference_solutions?: Array<string> | null
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  created?: string
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  updated?: string
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  remote_id?: string
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  remote_address?: string
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  name?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedCalendar
   */
  is_primary?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  time_zone?: string
  /**
   *
   * @type {boolean}
   * @memberof PatchedCalendar
   */
  writeable?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  ui_show_hotkey?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedCalendar
   */
  is_synced?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  last_synced?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedCalendar
   */
  include_in_inbox?: boolean
  /**
   * Whether the user is the data owner of this calendar (vs shared/subscribed)
   * @type {boolean}
   * @memberof PatchedCalendar
   */
  is_owned?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedCalendar
   */
  calendar_account?: string
}

/**
 *
 * @export
 * @interface PatchedCalendarGroup
 */
export interface PatchedCalendarGroup {
  /**
   *
   * @type {Array<CalendarGroupMembership>}
   * @memberof PatchedCalendarGroup
   */
  calendars?: Array<CalendarGroupMembership>
  /**
   *
   * @type {string}
   * @memberof PatchedCalendarGroup
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof PatchedCalendarGroup
   */
  created?: string
  /**
   *
   * @type {string}
   * @memberof PatchedCalendarGroup
   */
  updated?: string
  /**
   *
   * @type {string}
   * @memberof PatchedCalendarGroup
   */
  name?: string | null
  /**
   *
   * @type {number}
   * @memberof PatchedCalendarGroup
   */
  ordinal?: number
  /**
   *
   * @type {boolean}
   * @memberof PatchedCalendarGroup
   */
  is_default?: boolean
  /**
   *
   * @type {number}
   * @memberof PatchedCalendarGroup
   */
  user?: number
}
/**
 *
 * @export
 * @interface PatchedEventParams
 */
export interface PatchedEventParams {
  /**
   *
   * @type {string}
   * @memberof PatchedEventParams
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedEventParams
   */
  start_time?: string
  /**
   *
   * @type {string}
   * @memberof PatchedEventParams
   */
  start_time_zone?: string
  /**
   *
   * @type {string}
   * @memberof PatchedEventParams
   */
  end_time?: string
  /**
   *
   * @type {string}
   * @memberof PatchedEventParams
   */
  end_time_zone?: string
  /**
   *
   * @type {string}
   * @memberof PatchedEventParams
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedEventParams
   */
  location?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedEventParams
   */
  is_all_day?: boolean
  /**
   *
   * @type {Array<AttendeeInput>}
   * @memberof PatchedEventParams
   */
  attendees?: Array<AttendeeInput>
  /**
   *
   * @type {Array<Attachment>}
   * @memberof PatchedEventParams
   */
  attachments?: Array<Attachment>
  /**
   *
   * @type {Array<string>}
   * @memberof PatchedEventParams
   */
  recurrence?: Array<string>
  /**
   *
   * @type {EventStatusEnum}
   * @memberof PatchedEventParams
   */
  status?: EventStatusEnum
  /**
   *
   * @type {ConferencingDetails}
   * @memberof PatchedEventParams
   */
  conferencing_details?: ConferencingDetails | null
  /**
   *
   * @type {MuteLevelEnum}
   * @memberof PatchedEventParams
   */
  mute_level?: MuteLevelEnum
  /**
   *
   * @type {VisibilityEnum}
   * @memberof PatchedEventParams
   */
  visibility?: VisibilityEnum
  /**
   *
   * @type {EventTypeEnum}
   * @memberof PatchedEventParams
   */
  event_type?: EventTypeEnum
}

/**
 *
 * @export
 * @interface PatchedFolder
 */
export interface PatchedFolder {
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  id?: string
  /**
   *
   * @type {number}
   * @memberof PatchedFolder
   */
  user?: number
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  parent_id?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  purpose?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  sort_key?: string
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  created?: string
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  updated?: string
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  deleted_at?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedFolder
   */
  is_space?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  icon?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  color?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedFolder
   */
  template_id?: string | null
  /**
   *
   * @type {any}
   * @memberof PatchedFolder
   */
  template_state?: any
  /**
   *
   * @type {FolderSpaceNote}
   * @memberof PatchedFolder
   */
  space_note?: FolderSpaceNote | null
}
/**
 *
 * @export
 * @interface PatchedNote
 */
export interface PatchedNote {
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  id?: string
  /**
   *
   * @type {number}
   * @memberof PatchedNote
   */
  user?: number
  /**
   *
   * @type {NoteTypeEnum}
   * @memberof PatchedNote
   */
  type?: NoteTypeEnum
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  content?: string
  /**
   *
   * @type {number}
   * @memberof PatchedNote
   */
  content_length?: number
  /**
   *
   * @type {number}
   * @memberof PatchedNote
   */
  content_raw_length?: number
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  creation_date?: string
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  last_modified_date?: string
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  associated_event?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  associated_date?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  associated_week?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedNote
   */
  is_pinned?: boolean
  /**
   *
   * @type {number}
   * @memberof PatchedNote
   */
  ordinal?: number | null
  /**
   *
   * @type {any}
   * @memberof PatchedNote
   */
  associated_event_known_source_calendars?: any
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  folder_id?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  sort_key?: string
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  after_note_id?: string | null
  /**
   *
   * @type {SourceEnum}
   * @memberof PatchedNote
   */
  source?: SourceEnum
  /**
   *
   * @type {string}
   * @memberof PatchedNote
   */
  source_client?: string | null
}

/**
 *
 * @export
 * @interface PatchedNoteTemplate
 */
export interface PatchedNoteTemplate {
  /**
   *
   * @type {string}
   * @memberof PatchedNoteTemplate
   */
  id?: string
  /**
   *
   * @type {number}
   * @memberof PatchedNoteTemplate
   */
  user?: number
  /**
   *
   * @type {TypeEnum}
   * @memberof PatchedNoteTemplate
   */
  type?: TypeEnum
  /**
   *
   * @type {string}
   * @memberof PatchedNoteTemplate
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof PatchedNoteTemplate
   */
  content?: string
  /**
   *
   * @type {boolean}
   * @memberof PatchedNoteTemplate
   */
  is_public?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedNoteTemplate
   */
  creation_date?: string
  /**
   *
   * @type {string}
   * @memberof PatchedNoteTemplate
   */
  last_modified_date?: string
}

/**
 *
 * @export
 * @interface PatchedOnboardingState
 */
export interface PatchedOnboardingState {
  /**
   *
   * @type {boolean}
   * @memberof PatchedOnboardingState
   */
  has_seen_account_initialization?: boolean
  /**
   *
   * @type {boolean}
   * @memberof PatchedOnboardingState
   */
  demo_notes_initialized?: boolean
  /**
   *
   * @type {Array<OnboardingStep>}
   * @memberof PatchedOnboardingState
   */
  tutorial_steps?: Array<OnboardingStep>
  /**
   *
   * @type {boolean}
   * @memberof PatchedOnboardingState
   */
  has_completed_tutorial?: boolean
}
/**
 *
 * @export
 * @interface PatchedPreferences
 */
export interface PatchedPreferences {
  /**
   *
   * @type {WeekStartEnum}
   * @memberof PatchedPreferences
   */
  week_start?: WeekStartEnum
  /**
   *
   * @type {string}
   * @memberof PatchedPreferences
   */
  time_zone?: string
  /**
   *
   * @type {DefaultConferencePlatformEnum}
   * @memberof PatchedPreferences
   */
  default_conference_platform?: DefaultConferencePlatformEnum | null
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof PatchedPreferences
   */
  conference_platforms?: { [key: string]: any }
  /**
   *
   * @type {EditorTextSizeEnum}
   * @memberof PatchedPreferences
   */
  editor_text_size?: EditorTextSizeEnum
  /**
   * List of sidebar blocks to display
   * @type {Array<string>}
   * @memberof PatchedPreferences
   */
  layout_sidebar_blocks?: Array<string> | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedPreferences
   */
  scheduling_grace_time?: boolean
  /**
   *
   * @type {boolean}
   * @memberof PatchedPreferences
   */
  scheduling_speedy_meetings?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedPreferences
   */
  default_meeting_notes_folder_id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedPreferences
   */
  high_visibility_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof PatchedPreferences
   */
  show_desktop_notifications?: boolean
  /**
   *
   * @type {DesktopNotificationSettings}
   * @memberof PatchedPreferences
   */
  desktop_notifications?: DesktopNotificationSettings
  /**
   *
   * @type {boolean}
   * @memberof PatchedPreferences
   */
  defrag_enabled?: boolean
}

/**
 * Serializer for registering/updating an FCM device.
 * @export
 * @interface PatchedRegisterFCMDevice
 */
export interface PatchedRegisterFCMDevice {
  /**
   * FCM registration token
   * @type {string}
   * @memberof PatchedRegisterFCMDevice
   */
  registration_id?: string
  /**
   *
   * @type {RegisterFCMDevicePlatformEnum}
   * @memberof PatchedRegisterFCMDevice
   */
  platform?: RegisterFCMDevicePlatformEnum
  /**
   * Device model from Capacitor Device.getInfo().model (e.g., \'iPhone13,4\', \'SM-S911B\')
   * @type {string}
   * @memberof PatchedRegisterFCMDevice
   */
  device_model?: string
  /**
   * Device manufacturer from Capacitor Device.getInfo().manufacturer (e.g., \'Apple\', \'Samsung\')
   * @type {string}
   * @memberof PatchedRegisterFCMDevice
   */
  manufacturer?: string
  /**
   * OS version from Capacitor Device.getInfo().osVersion (e.g., \'17.0\', \'14\')
   * @type {string}
   * @memberof PatchedRegisterFCMDevice
   */
  os_version?: string
  /**
   * User-assigned device name from Capacitor Device.getInfo().name (e.g., \'John\'s iPhone\'). Optional.
   * @type {string}
   * @memberof PatchedRegisterFCMDevice
   */
  device_name?: string
  /**
   * Whether device is a simulator/emulator from Capacitor Device.getInfo().isVirtual
   * @type {boolean}
   * @memberof PatchedRegisterFCMDevice
   */
  is_virtual?: boolean | null
}

/**
 *
 * @export
 * @interface PatchedTaskToggle
 */
export interface PatchedTaskToggle {
  /**
   *
   * @type {boolean}
   * @memberof PatchedTaskToggle
   */
  is_completed?: boolean
  /**
   *
   * @type {string}
   * @memberof PatchedTaskToggle
   */
  modified_at?: string
}
/**
 *
 * @export
 * @interface PatchedUpdateMembershipRequest
 */
export interface PatchedUpdateMembershipRequest {
  /**
   *
   * @type {CalendarVisibility}
   * @memberof PatchedUpdateMembershipRequest
   */
  visibility?: CalendarVisibility
}

/**
 * One pinned note: note_id and position. Supports legacy (ordinal) or sort_key/after_id/before_id. - ordinal: legacy 0-based index; we set pin_sort_key from order and keep ordinal in sync. - pin_sort_key / after_id / before_id: at most one; we set ordinal from final order.
 * @export
 * @interface PinnedNote
 */
export interface PinnedNote {
  /**
   *
   * @type {string}
   * @memberof PinnedNote
   */
  note_id: string
  /**
   *
   * @type {number}
   * @memberof PinnedNote
   */
  ordinal?: number | null
  /**
   *
   * @type {string}
   * @memberof PinnedNote
   */
  pin_sort_key?: string | null
  /**
   *
   * @type {string}
   * @memberof PinnedNote
   */
  after_id?: string | null
  /**
   *
   * @type {string}
   * @memberof PinnedNote
   */
  before_id?: string | null
}
/**
 *
 * @export
 * @interface Preferences
 */
export interface Preferences {
  /**
   *
   * @type {WeekStartEnum}
   * @memberof Preferences
   */
  week_start?: WeekStartEnum
  /**
   *
   * @type {string}
   * @memberof Preferences
   */
  time_zone?: string
  /**
   *
   * @type {DefaultConferencePlatformEnum}
   * @memberof Preferences
   */
  default_conference_platform?: DefaultConferencePlatformEnum | null
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof Preferences
   */
  conference_platforms: { [key: string]: any }
  /**
   *
   * @type {EditorTextSizeEnum}
   * @memberof Preferences
   */
  editor_text_size?: EditorTextSizeEnum
  /**
   * List of sidebar blocks to display
   * @type {Array<string>}
   * @memberof Preferences
   */
  layout_sidebar_blocks: Array<string> | null
  /**
   *
   * @type {boolean}
   * @memberof Preferences
   */
  scheduling_grace_time?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Preferences
   */
  scheduling_speedy_meetings?: boolean
  /**
   *
   * @type {string}
   * @memberof Preferences
   */
  default_meeting_notes_folder_id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Preferences
   */
  high_visibility_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Preferences
   */
  show_desktop_notifications?: boolean
  /**
   *
   * @type {DesktopNotificationSettings}
   * @memberof Preferences
   */
  desktop_notifications?: DesktopNotificationSettings
  /**
   *
   * @type {boolean}
   * @memberof Preferences
   */
  defrag_enabled?: boolean
}

/**
 * * `login` - login * `connect` - connect
 * @export
 * @enum {string}
 */

export const ProcessEnum = {
  Login: 'login',
  Connect: 'connect'
} as const

export type ProcessEnum = (typeof ProcessEnum)[keyof typeof ProcessEnum]

/**
 *
 * @export
 * @interface PromoProgress
 */
export interface PromoProgress {
  /**
   *
   * @type {string}
   * @memberof PromoProgress
   */
  key: string
  /**
   *
   * @type {string}
   * @memberof PromoProgress
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof PromoProgress
   */
  description: string
  /**
   *
   * @type {number}
   * @memberof PromoProgress
   */
  current: number
  /**
   *
   * @type {number}
   * @memberof PromoProgress
   */
  max: number | null
  /**
   *
   * @type {boolean}
   * @memberof PromoProgress
   */
  achieved: boolean
  /**
   *
   * @type {string}
   * @memberof PromoProgress
   */
  achieved_at: string | null
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof PromoProgress
   */
  metadata: { [key: string]: any }
  /**
   *
   * @type {Array<ReferralAttribution>}
   * @memberof PromoProgress
   */
  referrals: Array<ReferralAttribution>
}
/**
 * * `google` - google * `apple` - apple
 * @export
 * @enum {string}
 */

export const ProviderEnum = {
  Google: 'google',
  Apple: 'apple'
} as const

export type ProviderEnum = (typeof ProviderEnum)[keyof typeof ProviderEnum]

/**
 * Response serializer for listing FCM devices.
 * @export
 * @interface PushDeviceListResponse
 */
export interface PushDeviceListResponse {
  /**
   *
   * @type {Array<FCMDevice>}
   * @memberof PushDeviceListResponse
   */
  devices: Array<FCMDevice>
}
/**
 * * `UNKNOWN` - UNKNOWN * `DAILY` - DAILY * `MORE_THAN_WEEKLY` - MORE_THAN_WEEKLY * `WEEKLY` - WEEKLY * `BIWEEKLY` - BIWEEKLY * `MONTHLY` - MONTHLY * `LESS_THAN_MONTHLY` - LESS_THAN_MONTHLY
 * @export
 * @enum {string}
 */

export const RecurrenceFrequencyEnum = {
  Unknown: 'UNKNOWN',
  Daily: 'DAILY',
  MoreThanWeekly: 'MORE_THAN_WEEKLY',
  Weekly: 'WEEKLY',
  Biweekly: 'BIWEEKLY',
  Monthly: 'MONTHLY',
  LessThanMonthly: 'LESS_THAN_MONTHLY'
} as const

export type RecurrenceFrequencyEnum =
  (typeof RecurrenceFrequencyEnum)[keyof typeof RecurrenceFrequencyEnum]

/**
 *
 * @export
 * @interface RecurringMeeting
 */
export interface RecurringMeeting {
  /**
   *
   * @type {Event}
   * @memberof RecurringMeeting
   */
  event: Event
  /**
   *
   * @type {number}
   * @memberof RecurringMeeting
   */
  cancellation_rate: number
  /**
   *
   * @type {number}
   * @memberof RecurringMeeting
   */
  acceptance_rate: number
  /**
   *
   * @type {number}
   * @memberof RecurringMeeting
   */
  user_acceptance_rate: number
}
/**
 *
 * @export
 * @interface ReferralAttribution
 */
export interface ReferralAttribution {
  /**
   *
   * @type {string}
   * @memberof ReferralAttribution
   */
  status: string
  /**
   *
   * @type {string}
   * @memberof ReferralAttribution
   */
  signed_up_at: string | null
  /**
   *
   * @type {string}
   * @memberof ReferralAttribution
   */
  qualified_at: string | null
}
/**
 *
 * @export
 * @interface ReferralCodeLookup
 */
export interface ReferralCodeLookup {
  /**
   *
   * @type {string}
   * @memberof ReferralCodeLookup
   */
  code: string
  /**
   *
   * @type {boolean}
   * @memberof ReferralCodeLookup
   */
  is_active: boolean
  /**
   *
   * @type {string}
   * @memberof ReferralCodeLookup
   */
  source_type: string
  /**
   *
   * @type {string}
   * @memberof ReferralCodeLookup
   */
  affiliate_partner: string | null
  /**
   *
   * @type {ReferralCodeReferrer}
   * @memberof ReferralCodeLookup
   */
  referrer: ReferralCodeReferrer | null
}
/**
 *
 * @export
 * @interface ReferralCodeReferrer
 */
export interface ReferralCodeReferrer {
  /**
   *
   * @type {number}
   * @memberof ReferralCodeReferrer
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ReferralCodeReferrer
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof ReferralCodeReferrer
   */
  first_name: string
  /**
   *
   * @type {string}
   * @memberof ReferralCodeReferrer
   */
  last_name: string
}
/**
 *
 * @export
 * @interface ReferralLink
 */
export interface ReferralLink {
  /**
   *
   * @type {string}
   * @memberof ReferralLink
   */
  code: string
  /**
   *
   * @type {string}
   * @memberof ReferralLink
   */
  url: string
}
/**
 * Serializer for registering/updating an FCM device.
 * @export
 * @interface RegisterFCMDevice
 */
export interface RegisterFCMDevice {
  /**
   * FCM registration token
   * @type {string}
   * @memberof RegisterFCMDevice
   */
  registration_id: string
  /**
   *
   * @type {RegisterFCMDevicePlatformEnum}
   * @memberof RegisterFCMDevice
   */
  platform?: RegisterFCMDevicePlatformEnum
  /**
   * Device model from Capacitor Device.getInfo().model (e.g., \'iPhone13,4\', \'SM-S911B\')
   * @type {string}
   * @memberof RegisterFCMDevice
   */
  device_model?: string
  /**
   * Device manufacturer from Capacitor Device.getInfo().manufacturer (e.g., \'Apple\', \'Samsung\')
   * @type {string}
   * @memberof RegisterFCMDevice
   */
  manufacturer?: string
  /**
   * OS version from Capacitor Device.getInfo().osVersion (e.g., \'17.0\', \'14\')
   * @type {string}
   * @memberof RegisterFCMDevice
   */
  os_version?: string
  /**
   * User-assigned device name from Capacitor Device.getInfo().name (e.g., \'John\'s iPhone\'). Optional.
   * @type {string}
   * @memberof RegisterFCMDevice
   */
  device_name?: string
  /**
   * Whether device is a simulator/emulator from Capacitor Device.getInfo().isVirtual
   * @type {boolean}
   * @memberof RegisterFCMDevice
   */
  is_virtual?: boolean | null
}

/**
 * * `ios` - ios * `android` - android
 * @export
 * @enum {string}
 */

export const RegisterFCMDevicePlatformEnum = {
  Ios: 'ios',
  Android: 'android'
} as const

export type RegisterFCMDevicePlatformEnum =
  (typeof RegisterFCMDevicePlatformEnum)[keyof typeof RegisterFCMDevicePlatformEnum]

/**
 *
 * @export
 * @interface ReorderCalendarGroupsRequest
 */
export interface ReorderCalendarGroupsRequest {
  /**
   *
   * @type {Array<GroupOrder>}
   * @memberof ReorderCalendarGroupsRequest
   */
  group_orders: Array<GroupOrder>
}
/**
 *
 * @export
 * @interface ReorderCalendarsRequest
 */
export interface ReorderCalendarsRequest {
  /**
   *
   * @type {Array<CalendarOrder>}
   * @memberof ReorderCalendarsRequest
   */
  calendar_orders: Array<CalendarOrder>
}
/**
 *
 * @export
 * @interface Rsvp
 */
export interface Rsvp {
  /**
   *
   * @type {RsvpStatusEnum}
   * @memberof Rsvp
   */
  rsvp_status: RsvpStatusEnum
  /**
   * An optional comment for the RSVP.
   * @type {string}
   * @memberof Rsvp
   */
  comment?: string
}

/**
 * * `UNKNOWN` - UNKNOWN * `ACCEPTED` - ACCEPTED * `DECLINED` - DECLINED * `TENTATIVE` - TENTATIVE * `NEEDS_ACTION` - NEEDS_ACTION
 * @export
 * @enum {string}
 */

export const RsvpStatusEnum = {
  Unknown: 'UNKNOWN',
  Accepted: 'ACCEPTED',
  Declined: 'DECLINED',
  Tentative: 'TENTATIVE',
  NeedsAction: 'NEEDS_ACTION'
} as const

export type RsvpStatusEnum = (typeof RsvpStatusEnum)[keyof typeof RsvpStatusEnum]

/**
 *
 * @export
 * @interface SendTestPushRequest
 */
export interface SendTestPushRequest {
  /**
   *
   * @type {string}
   * @memberof SendTestPushRequest
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof SendTestPushRequest
   */
  body?: string
}
/**
 *
 * @export
 * @interface SendTestPushResponse
 */
export interface SendTestPushResponse {
  /**
   *
   * @type {number}
   * @memberof SendTestPushResponse
   */
  sent: number
  /**
   *
   * @type {number}
   * @memberof SendTestPushResponse
   */
  failed: number
  /**
   *
   * @type {string}
   * @memberof SendTestPushResponse
   */
  message: string
}
/**
 *
 * @export
 * @interface SenderTrust
 */
export interface SenderTrust {
  /**
   *
   * @type {LevelEnum}
   * @memberof SenderTrust
   */
  level: LevelEnum
  /**
   *
   * @type {Array<string>}
   * @memberof SenderTrust
   */
  reasons: Array<string>
}

/**
 *
 * @export
 * @interface SignedUrlResponse
 */
export interface SignedUrlResponse {
  /**
   *
   * @type {string}
   * @memberof SignedUrlResponse
   */
  signed_url: string
  /**
   *
   * @type {string}
   * @memberof SignedUrlResponse
   */
  filename: string
}
/**
 * * `MOBILE_ACCESS` - MOBILE_ACCESS * `FULL_ACCESS` - FULL_ACCESS
 * @export
 * @enum {string}
 */

export const SkuEnum = {
  MobileAccess: 'MOBILE_ACCESS',
  FullAccess: 'FULL_ACCESS'
} as const

export type SkuEnum = (typeof SkuEnum)[keyof typeof SkuEnum]

/**
 * * `unknown` - Unknown * `mcp` - MCP * `mobile` - Mobile * `web` - Web
 * @export
 * @enum {string}
 */

export const SourceEnum = {
  Unknown: 'unknown',
  Mcp: 'mcp',
  Mobile: 'mobile',
  Web: 'web'
} as const

export type SourceEnum = (typeof SourceEnum)[keyof typeof SourceEnum]

/**
 *
 * @export
 * @interface SpaceEvent
 */
export interface SpaceEvent {
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  folder: string
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  event_uid: string
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  calendar_id: string
  /**
   *
   * @type {boolean}
   * @memberof SpaceEvent
   */
  is_recurring?: boolean
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  title: string | null
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  next_occurrence: string | null
  /**
   *
   * @type {string}
   * @memberof SpaceEvent
   */
  next_recurrence_id: string | null
}
/**
 *
 * @export
 * @interface SpaceEventCreate
 */
export interface SpaceEventCreate {
  /**
   *
   * @type {string}
   * @memberof SpaceEventCreate
   */
  event_uid: string
  /**
   *
   * @type {string}
   * @memberof SpaceEventCreate
   */
  calendar_id: string
  /**
   *
   * @type {boolean}
   * @memberof SpaceEventCreate
   */
  is_recurring: boolean
}
/**
 *
 * @export
 * @interface SpaceLimit
 */
export interface SpaceLimit {
  /**
   * Maximum number of spaces allowed. null = unlimited.
   * @type {number}
   * @memberof SpaceLimit
   */
  max: number | null
}
/**
 *
 * @export
 * @interface StoreDebug
 */
export interface StoreDebug {
  /**
   *
   * @type {Array<StoreDebugPurchase>}
   * @memberof StoreDebug
   */
  purchases: Array<StoreDebugPurchase>
  /**
   * Every billing cache key for this user (resolved status + per-provider last-known-good) with its current state.
   * @type {Array<StoreDebugCacheEntry>}
   * @memberof StoreDebug
   */
  cache: Array<StoreDebugCacheEntry>
}
/**
 * State of one server-side billing cache key for the requesting user.
 * @export
 * @interface StoreDebugCacheEntry
 */
export interface StoreDebugCacheEntry {
  /**
   *
   * @type {string}
   * @memberof StoreDebugCacheEntry
   */
  key: string
  /**
   *
   * @type {boolean}
   * @memberof StoreDebugCacheEntry
   */
  present: boolean
  /**
   * Cached value verbatim: billing_status is [is_active, is_lifetime]; a store_status_lkg entry is the stored status dict. null when absent.
   * @type {any}
   * @memberof StoreDebugCacheEntry
   */
  value: any | null
  /**
   * Cache-row expiry, or null when unknown/absent.
   * @type {string}
   * @memberof StoreDebugCacheEntry
   */
  expires_at: string | null
}
/**
 * One StorePurchase row plus the raw store payload for its token.  `store_details` is whatever the store adapter\'s get_raw_details returns: for Apple the full subscription-statuses response with decoded JWS transaction/renewal payloads, for Google the subscription resource — or an {\"error\": ...} dict when the store call failed. Deliberately untyped: it is a diagnostic passthrough of a third-party payload.
 * @export
 * @interface StoreDebugPurchase
 */
export interface StoreDebugPurchase {
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  provider: string
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  bundle_id: string
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  product_id: string
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  offer_id: string | null
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  token: string
  /**
   *
   * @type {boolean}
   * @memberof StoreDebugPurchase
   */
  is_sandbox: boolean
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  verification_status: string
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof StoreDebugPurchase
   */
  updated: string
  /**
   *
   * @type {any}
   * @memberof StoreDebugPurchase
   */
  store_details: any
}
/**
 *
 * @export
 * @interface StorePurchase
 */
export interface StorePurchase {
  /**
   *
   * @type {ProviderEnum}
   * @memberof StorePurchase
   */
  provider: ProviderEnum
  /**
   *
   * @type {string}
   * @memberof StorePurchase
   */
  bundle_id: string
  /**
   *
   * @type {string}
   * @memberof StorePurchase
   */
  product_id: string
  /**
   *
   * @type {string}
   * @memberof StorePurchase
   */
  offer_id?: string | null
  /**
   *
   * @type {string}
   * @memberof StorePurchase
   */
  token: string
  /**
   *
   * @type {boolean}
   * @memberof StorePurchase
   */
  is_sandbox?: boolean
}

/**
 *
 * @export
 * @interface Subscription
 */
export interface Subscription {
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  stripe_customer_id: string | null
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  stripe_subscription_id: string | null
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  mobile_iap_product_id: string | null
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  mobile_iap_offer_id: string | null
  /**
   *
   * @type {Entitlement}
   * @memberof Subscription
   */
  entitlements: Entitlement
  /**
   *
   * @type {boolean}
   * @memberof Subscription
   */
  is_active: boolean
  /**
   *
   * @type {boolean}
   * @memberof Subscription
   */
  is_canceled: boolean
  /**
   *
   * @type {boolean}
   * @memberof Subscription
   */
  is_edu: boolean
  /**
   *
   * @type {boolean}
   * @memberof Subscription
   */
  is_lifetime: boolean
  /**
   * True whenever the user holds the permanent free mobile access grant, even while a purchased plan supersedes it. Gate the MOBILE_ACCESS offer on this or a grant holder who bought FULL_ACCESS gets sold it again on downgrade.
   * @type {boolean}
   * @memberof Subscription
   */
  has_free_mobile_grant: boolean
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  trial_ends_at: string
  /**
   *
   * @type {boolean}
   * @memberof Subscription
   */
  had_trial: boolean
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  renewal_period_duration: string
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  current_period_ends_at: string
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  current_period_starts_at: string
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  provider: string | null
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  pending_mobile_iap_product_id: string | null
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  pending_mobile_iap_offer_id: string | null
  /**
   *
   * @type {string}
   * @memberof Subscription
   */
  pending_renewal_period_duration: string | null
  /**
   *
   * @type {OfferCatalog}
   * @memberof Subscription
   */
  offer_catalog?: OfferCatalog
  /**
   *
   * @type {StoreDebug}
   * @memberof Subscription
   */
  store_debug?: StoreDebug
}
/**
 *
 * @export
 * @interface SyncRequest
 */
export interface SyncRequest {
  /**
   *
   * @type {boolean}
   * @memberof SyncRequest
   */
  full_sync: boolean
}
/**
 *
 * @export
 * @interface Task
 */
export interface Task {
  /**
   *
   * @type {string}
   * @memberof Task
   */
  uuid: string
  /**
   *
   * @type {string}
   * @memberof Task
   */
  lineage_id: string
  /**
   *
   * @type {string}
   * @memberof Task
   */
  text?: string
  /**
   *
   * @type {boolean}
   * @memberof Task
   */
  is_completed?: boolean
  /**
   *
   * @type {string}
   * @memberof Task
   */
  reset_period?: string
  /**
   *
   * @type {string}
   * @memberof Task
   */
  modified_at: string
  /**
   *
   * @type {string}
   * @memberof Task
   */
  created_at: string
  /**
   *
   * @type {string}
   * @memberof Task
   */
  note_id: string
  /**
   *
   * @type {string}
   * @memberof Task
   */
  note_title: string
  /**
   *
   * @type {string}
   * @memberof Task
   */
  cascade_to: string | null
}
/**
 * * `0` - GENERAL * `1` - EVENT * `2` - DAILY * `3` - WEEKLY
 * @export
 * @enum {string}
 */

export const TypeEnum = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3
} as const

export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum]

/**
 * * `HIDDEN` - HIDDEN * `ALWAYS_SHOW` - ALWAYS_SHOW * `BACKGROUND` - BACKGROUND
 * @export
 * @enum {string}
 */

export const UiModeEnum = {
  Hidden: 'HIDDEN',
  AlwaysShow: 'ALWAYS_SHOW',
  Background: 'BACKGROUND'
} as const

export type UiModeEnum = (typeof UiModeEnum)[keyof typeof UiModeEnum]

/**
 *
 * @export
 * @interface UnrespondedEvent
 */
export interface UnrespondedEvent {
  /**
   *
   * @type {Event}
   * @memberof UnrespondedEvent
   */
  event: Event
  /**
   *
   * @type {string}
   * @memberof UnrespondedEvent
   */
  next_occurrence: string
  /**
   *
   * @type {Array<Event>}
   * @memberof UnrespondedEvent
   */
  conflicts: Array<Event>
}
/**
 * Request to update pinned notes. Accepts legacy (ordinal) or pin_sort_key/after_id/before_id. Backend keeps ordinal and pin_sort_key in sync.
 * @export
 * @interface UpdatePinsRequest
 */
export interface UpdatePinsRequest {
  /**
   * List of pins: each has note_id and position (ordinal or pin_sort_key/after_id/before_id).
   * @type {Array<PinnedNote>}
   * @memberof UpdatePinsRequest
   */
  pinnedNotes: Array<PinnedNote>
}
/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {number}
   * @memberof User
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof User
   */
  email?: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  first_name?: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  last_name?: string
  /**
   *
   * @type {Preferences}
   * @memberof User
   */
  preferences: Preferences
  /**
   *
   * @type {OnboardingState}
   * @memberof User
   */
  onboarding_state: OnboardingState
  /**
   *
   * @type {Array<CalendarAccount>}
   * @memberof User
   */
  calendar_accounts: Array<CalendarAccount>
}
/**
 * * `DEFAULT` - DEFAULT * `PUBLIC` - PUBLIC * `PRIVATE` - PRIVATE * `CONFIDENTIAL` - CONFIDENTIAL
 * @export
 * @enum {string}
 */

export const VisibilityEnum = {
  Default: 'DEFAULT',
  Public: 'PUBLIC',
  Private: 'PRIVATE',
  Confidential: 'CONFIDENTIAL'
} as const

export type VisibilityEnum = (typeof VisibilityEnum)[keyof typeof VisibilityEnum]

/**
 * * `5` - SATURDAY * `6` - SUNDAY * `0` - MONDAY
 * @export
 * @enum {string}
 */

export const WeekStartEnum = {
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_0: 0
} as const

export type WeekStartEnum = (typeof WeekStartEnum)[keyof typeof WeekStartEnum]

/**
 *
 * @export
 * @interface WorkspaceState
 */
export interface WorkspaceState {
  /**
   *
   * @type {number}
   * @memberof WorkspaceState
   */
  revision: number
  /**
   *
   * @type {string}
   * @memberof WorkspaceState
   */
  changed_at: string
  /**
   *
   * @type {number}
   * @memberof WorkspaceState
   */
  space_revision: number
  /**
   *
   * @type {string}
   * @memberof WorkspaceState
   */
  space_changed_at: string
}

/**
 * AllowlistApi - axios parameter creator
 * @export
 */
export const AllowlistApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {AllowedSender} allowedSender
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistCreate: async (
      allowedSender: AllowedSender,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'allowedSender' is not null or undefined
      assertParamExists('allowlistCreate', 'allowedSender', allowedSender)
      const localVarPath = `/allowlist/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        allowedSender,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/allowlist/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAllowedSender: async (
      value: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'value' is not null or undefined
      assertParamExists('deleteAllowedSender', 'value', value)
      const localVarPath = `/allowlist/{value}/`.replace(
        `{${'value'}}`,
        encodeURIComponent(String(value))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AllowlistApi - functional programming interface
 * @export
 */
export const AllowlistApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AllowlistApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {AllowedSender} allowedSender
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistCreate(
      allowedSender: AllowedSender,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllowedSender>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.allowlistCreate(
        allowedSender,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAllowedSenderList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.allowlistList(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAllowedSender(
      value: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllowedSender(value, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * AllowlistApi - factory interface
 * @export
 */
export const AllowlistApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AllowlistApiFp(configuration)
  return {
    /**
     *
     * @param {AllowlistApiAllowlistCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistCreate(
      requestParameters: AllowlistApiAllowlistCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<AllowedSender> {
      return localVarFp
        .allowlistCreate(requestParameters.allowedSender, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {AllowlistApiAllowlistListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistList(
      requestParameters: AllowlistApiAllowlistListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedAllowedSenderList> {
      return localVarFp
        .allowlistList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {AllowlistApiDeleteAllowedSenderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAllowedSender(
      requestParameters: AllowlistApiDeleteAllowedSenderRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .deleteAllowedSender(requestParameters.value, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for allowlistCreate operation in AllowlistApi.
 * @export
 * @interface AllowlistApiAllowlistCreateRequest
 */
export interface AllowlistApiAllowlistCreateRequest {
  /**
   *
   * @type {AllowedSender}
   * @memberof AllowlistApiAllowlistCreate
   */
  readonly allowedSender: AllowedSender
}

/**
 * Request parameters for allowlistList operation in AllowlistApi.
 * @export
 * @interface AllowlistApiAllowlistListRequest
 */
export interface AllowlistApiAllowlistListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof AllowlistApiAllowlistList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof AllowlistApiAllowlistList
   */
  readonly perPage?: number
}

/**
 * Request parameters for deleteAllowedSender operation in AllowlistApi.
 * @export
 * @interface AllowlistApiDeleteAllowedSenderRequest
 */
export interface AllowlistApiDeleteAllowedSenderRequest {
  /**
   *
   * @type {string}
   * @memberof AllowlistApiDeleteAllowedSender
   */
  readonly value: string
}

/**
 * AllowlistApi - object-oriented interface
 * @export
 * @class AllowlistApi
 * @extends {BaseAPI}
 */
export class AllowlistApi extends BaseAPI {
  /**
   *
   * @param {AllowlistApiAllowlistCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AllowlistApi
   */
  public allowlistCreate(
    requestParameters: AllowlistApiAllowlistCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return AllowlistApiFp(this.configuration)
      .allowlistCreate(requestParameters.allowedSender, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {AllowlistApiAllowlistListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AllowlistApi
   */
  public allowlistList(
    requestParameters: AllowlistApiAllowlistListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return AllowlistApiFp(this.configuration)
      .allowlistList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {AllowlistApiDeleteAllowedSenderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AllowlistApi
   */
  public deleteAllowedSender(
    requestParameters: AllowlistApiDeleteAllowedSenderRequest,
    options?: AxiosRequestConfig
  ) {
    return AllowlistApiFp(this.configuration)
      .deleteAllowedSender(requestParameters.value, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
     * @summary Confirm account deletion with the code
     * @param {AccountDeletionConfirmRequest} accountDeletionConfirmRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authDeleteCreate: async (
      accountDeletionConfirmRequest: AccountDeletionConfirmRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accountDeletionConfirmRequest' is not null or undefined
      assertParamExists(
        'authDeleteCreate',
        'accountDeletionConfirmRequest',
        accountDeletionConfirmRequest
      )
      const localVarPath = `/auth/delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        accountDeletionConfirmRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
     * @summary Request an account deletion confirmation code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authDeleteRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Endpoint for mobile apps to authenticate using serverAuthCode from CapacitorGoogleAuth. Transforms the POST request into a GET request format and reuses GoogleOAuth2CallbackView. Supports both login and connect flows.
     * @param {GoogleAuthHandleCodeRequest} googleAuthHandleCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authGoogleHandleCodeCreate: async (
      googleAuthHandleCodeRequest: GoogleAuthHandleCodeRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'googleAuthHandleCodeRequest' is not null or undefined
      assertParamExists(
        'authGoogleHandleCodeCreate',
        'googleAuthHandleCodeRequest',
        googleAuthHandleCodeRequest
      )
      const localVarPath = `/auth/google/handle-code/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication knoxApiToken required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        googleAuthHandleCodeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Deprecated: Use /me/calendar-accounts/{id}/token/ instead.
     * @param {string} [forceRefresh] Set to \&#39;true\&#39; to force a token refresh from Google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authGoogleTokenRetrieve: async (
      forceRefresh?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/google/token/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (forceRefresh !== undefined) {
        localVarQueryParameter['force_refresh'] = forceRefresh
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authZoomDisconnectCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/zoom/disconnect/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authZoomTokenRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/zoom/token/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
  return {
    /**
     * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
     * @summary Confirm account deletion with the code
     * @param {AccountDeletionConfirmRequest} accountDeletionConfirmRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authDeleteCreate(
      accountDeletionConfirmRequest: AccountDeletionConfirmRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authDeleteCreate(
        accountDeletionConfirmRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
     * @summary Request an account deletion confirmation code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authDeleteRetrieve(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDeletionCodeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authDeleteRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Endpoint for mobile apps to authenticate using serverAuthCode from CapacitorGoogleAuth. Transforms the POST request into a GET request format and reuses GoogleOAuth2CallbackView. Supports both login and connect flows.
     * @param {GoogleAuthHandleCodeRequest} googleAuthHandleCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authGoogleHandleCodeCreate(
      googleAuthHandleCodeRequest: GoogleAuthHandleCodeRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAuthHandleCodeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authGoogleHandleCodeCreate(
        googleAuthHandleCodeRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Deprecated: Use /me/calendar-accounts/{id}/token/ instead.
     * @param {string} [forceRefresh] Set to \&#39;true\&#39; to force a token refresh from Google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authGoogleTokenRetrieve(
      forceRefresh?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationToken>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authGoogleTokenRetrieve(
        forceRefresh,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authZoomDisconnectCreate(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authZoomDisconnectCreate(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authZoomTokenRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationToken>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authZoomTokenRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthApiFp(configuration)
  return {
    /**
     * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
     * @summary Confirm account deletion with the code
     * @param {AuthApiAuthDeleteCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authDeleteCreate(
      requestParameters: AuthApiAuthDeleteCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .authDeleteCreate(requestParameters.accountDeletionConfirmRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
     * @summary Request an account deletion confirmation code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authDeleteRetrieve(options?: AxiosRequestConfig): AxiosPromise<AccountDeletionCodeResponse> {
      return localVarFp.authDeleteRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     * Endpoint for mobile apps to authenticate using serverAuthCode from CapacitorGoogleAuth. Transforms the POST request into a GET request format and reuses GoogleOAuth2CallbackView. Supports both login and connect flows.
     * @param {AuthApiAuthGoogleHandleCodeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authGoogleHandleCodeCreate(
      requestParameters: AuthApiAuthGoogleHandleCodeCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<GoogleAuthHandleCodeResponse> {
      return localVarFp
        .authGoogleHandleCodeCreate(requestParameters.googleAuthHandleCodeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deprecated: Use /me/calendar-accounts/{id}/token/ instead.
     * @param {AuthApiAuthGoogleTokenRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authGoogleTokenRetrieve(
      requestParameters: AuthApiAuthGoogleTokenRetrieveRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<IntegrationToken> {
      return localVarFp
        .authGoogleTokenRetrieve(requestParameters.forceRefresh, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authZoomDisconnectCreate(options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .authZoomDisconnectCreate(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authZoomTokenRetrieve(options?: AxiosRequestConfig): AxiosPromise<IntegrationToken> {
      return localVarFp.authZoomTokenRetrieve(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for authDeleteCreate operation in AuthApi.
 * @export
 * @interface AuthApiAuthDeleteCreateRequest
 */
export interface AuthApiAuthDeleteCreateRequest {
  /**
   *
   * @type {AccountDeletionConfirmRequest}
   * @memberof AuthApiAuthDeleteCreate
   */
  readonly accountDeletionConfirmRequest: AccountDeletionConfirmRequest
}

/**
 * Request parameters for authGoogleHandleCodeCreate operation in AuthApi.
 * @export
 * @interface AuthApiAuthGoogleHandleCodeCreateRequest
 */
export interface AuthApiAuthGoogleHandleCodeCreateRequest {
  /**
   *
   * @type {GoogleAuthHandleCodeRequest}
   * @memberof AuthApiAuthGoogleHandleCodeCreate
   */
  readonly googleAuthHandleCodeRequest: GoogleAuthHandleCodeRequest
}

/**
 * Request parameters for authGoogleTokenRetrieve operation in AuthApi.
 * @export
 * @interface AuthApiAuthGoogleTokenRetrieveRequest
 */
export interface AuthApiAuthGoogleTokenRetrieveRequest {
  /**
   * Set to \&#39;true\&#39; to force a token refresh from Google
   * @type {string}
   * @memberof AuthApiAuthGoogleTokenRetrieve
   */
  readonly forceRefresh?: string
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
  /**
   * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
   * @summary Confirm account deletion with the code
   * @param {AuthApiAuthDeleteCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authDeleteCreate(
    requestParameters: AuthApiAuthDeleteCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authDeleteCreate(requestParameters.accountDeletionConfirmRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * GET  /auth/delete/  — issue an 8-digit confirmation code (expires in 10 min) POST /auth/delete/  — confirm with { \"code\": \"XXXXXXXX\" } to delete the account
   * @summary Request an account deletion confirmation code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authDeleteRetrieve(options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authDeleteRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Endpoint for mobile apps to authenticate using serverAuthCode from CapacitorGoogleAuth. Transforms the POST request into a GET request format and reuses GoogleOAuth2CallbackView. Supports both login and connect flows.
   * @param {AuthApiAuthGoogleHandleCodeCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authGoogleHandleCodeCreate(
    requestParameters: AuthApiAuthGoogleHandleCodeCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authGoogleHandleCodeCreate(requestParameters.googleAuthHandleCodeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deprecated: Use /me/calendar-accounts/{id}/token/ instead.
   * @param {AuthApiAuthGoogleTokenRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authGoogleTokenRetrieve(
    requestParameters: AuthApiAuthGoogleTokenRetrieveRequest = {},
    options?: AxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authGoogleTokenRetrieve(requestParameters.forceRefresh, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authZoomDisconnectCreate(options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authZoomDisconnectCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authZoomTokenRetrieve(options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authZoomTokenRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Complete the embedded checkout process
     * @param {CompleteEmbeddedCheckout} completeEmbeddedCheckout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingCheckoutCompleteEmbeddedCreate: async (
      completeEmbeddedCheckout: CompleteEmbeddedCheckout,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'completeEmbeddedCheckout' is not null or undefined
      assertParamExists(
        'billingCheckoutCompleteEmbeddedCreate',
        'completeEmbeddedCheckout',
        completeEmbeddedCheckout
      )
      const localVarPath = `/billing/checkout/complete-embedded/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        completeEmbeddedCheckout,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {Checkout} checkout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingCheckoutCreate: async (
      checkout: Checkout,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'checkout' is not null or undefined
      assertParamExists('billingCheckoutCreate', 'checkout', checkout)
      const localVarPath = `/billing/checkout/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkout,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Clear the requesting user\'s billing caches (resolved status + per-provider last-known-good). Developer/debug affordance: the next subscription read recomputes from live sources. Returns the keys deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingDebugCacheClear: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/billing/debug/cache/clear/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a Stripe Billing Portal session and return the URL
     * @param {string} [portalConfigId] Optional portal configuration ID. If not provided, falls back to legacy behavior based on subscription interval.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingPortalRetrieve: async (
      portalConfigId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/billing/portal/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (portalConfigId !== undefined) {
        localVarQueryParameter['portal_config_id'] = portalConfigId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {StorePurchase} storePurchase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingStorePurchaseCreate: async (
      storePurchase: StorePurchase,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'storePurchase' is not null or undefined
      assertParamExists('billingStorePurchaseCreate', 'storePurchase', storePurchase)
      const localVarPath = `/billing/store/purchase/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        storePurchase,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {BillingSubscriptionRetrievePlatformEnum} [platform] Filters the listings under each offer_catalog offer to one store. Omit to receive every store\&#39;s listings. Unrecognised values are ignored.
     * @param {BillingSubscriptionRetrieveDebugEnum} [debug] Pass 1 or true to include store_debug: the user\&#39;s raw Apple/Google store data per purchase, for diagnosing status mismatches from the developer settings screen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingSubscriptionRetrieve: async (
      platform?: BillingSubscriptionRetrievePlatformEnum,
      debug?: BillingSubscriptionRetrieveDebugEnum,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/billing/subscription/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (platform !== undefined) {
        localVarQueryParameter['platform'] = platform
      }

      if (debug !== undefined) {
        localVarQueryParameter['debug'] = debug
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
  return {
    /**
     * Complete the embedded checkout process
     * @param {CompleteEmbeddedCheckout} completeEmbeddedCheckout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingCheckoutCompleteEmbeddedCreate(
      completeEmbeddedCheckout: CompleteEmbeddedCheckout,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.billingCheckoutCompleteEmbeddedCreate(
          completeEmbeddedCheckout,
          options
        )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {Checkout} checkout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingCheckoutCreate(
      checkout: Checkout,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingCheckoutCreate200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.billingCheckoutCreate(
        checkout,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Clear the requesting user\'s billing caches (resolved status + per-provider last-known-good). Developer/debug affordance: the next subscription read recomputes from live sources. Returns the keys deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingDebugCacheClear(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingCacheClearResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.billingDebugCacheClear(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Create a Stripe Billing Portal session and return the URL
     * @param {string} [portalConfigId] Optional portal configuration ID. If not provided, falls back to legacy behavior based on subscription interval.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingPortalRetrieve(
      portalConfigId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingPortalUrl>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.billingPortalRetrieve(
        portalConfigId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {StorePurchase} storePurchase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingStorePurchaseCreate(
      storePurchase: StorePurchase,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.billingStorePurchaseCreate(
        storePurchase,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {BillingSubscriptionRetrievePlatformEnum} [platform] Filters the listings under each offer_catalog offer to one store. Omit to receive every store\&#39;s listings. Unrecognised values are ignored.
     * @param {BillingSubscriptionRetrieveDebugEnum} [debug] Pass 1 or true to include store_debug: the user\&#39;s raw Apple/Google store data per purchase, for diagnosing status mismatches from the developer settings screen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingSubscriptionRetrieve(
      platform?: BillingSubscriptionRetrievePlatformEnum,
      debug?: BillingSubscriptionRetrieveDebugEnum,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.billingSubscriptionRetrieve(
        platform,
        debug,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BillingApiFp(configuration)
  return {
    /**
     * Complete the embedded checkout process
     * @param {BillingApiBillingCheckoutCompleteEmbeddedCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingCheckoutCompleteEmbeddedCreate(
      requestParameters: BillingApiBillingCheckoutCompleteEmbeddedCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .billingCheckoutCompleteEmbeddedCreate(requestParameters.completeEmbeddedCheckout, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {BillingApiBillingCheckoutCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingCheckoutCreate(
      requestParameters: BillingApiBillingCheckoutCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<BillingCheckoutCreate200Response> {
      return localVarFp
        .billingCheckoutCreate(requestParameters.checkout, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Clear the requesting user\'s billing caches (resolved status + per-provider last-known-good). Developer/debug affordance: the next subscription read recomputes from live sources. Returns the keys deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingDebugCacheClear(options?: AxiosRequestConfig): AxiosPromise<BillingCacheClearResponse> {
      return localVarFp.billingDebugCacheClear(options).then((request) => request(axios, basePath))
    },
    /**
     * Create a Stripe Billing Portal session and return the URL
     * @param {BillingApiBillingPortalRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingPortalRetrieve(
      requestParameters: BillingApiBillingPortalRetrieveRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<BillingPortalUrl> {
      return localVarFp
        .billingPortalRetrieve(requestParameters.portalConfigId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {BillingApiBillingStorePurchaseCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingStorePurchaseCreate(
      requestParameters: BillingApiBillingStorePurchaseCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .billingStorePurchaseCreate(requestParameters.storePurchase, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {BillingApiBillingSubscriptionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingSubscriptionRetrieve(
      requestParameters: BillingApiBillingSubscriptionRetrieveRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .billingSubscriptionRetrieve(requestParameters.platform, requestParameters.debug, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for billingCheckoutCompleteEmbeddedCreate operation in BillingApi.
 * @export
 * @interface BillingApiBillingCheckoutCompleteEmbeddedCreateRequest
 */
export interface BillingApiBillingCheckoutCompleteEmbeddedCreateRequest {
  /**
   *
   * @type {CompleteEmbeddedCheckout}
   * @memberof BillingApiBillingCheckoutCompleteEmbeddedCreate
   */
  readonly completeEmbeddedCheckout: CompleteEmbeddedCheckout
}

/**
 * Request parameters for billingCheckoutCreate operation in BillingApi.
 * @export
 * @interface BillingApiBillingCheckoutCreateRequest
 */
export interface BillingApiBillingCheckoutCreateRequest {
  /**
   *
   * @type {Checkout}
   * @memberof BillingApiBillingCheckoutCreate
   */
  readonly checkout: Checkout
}

/**
 * Request parameters for billingPortalRetrieve operation in BillingApi.
 * @export
 * @interface BillingApiBillingPortalRetrieveRequest
 */
export interface BillingApiBillingPortalRetrieveRequest {
  /**
   * Optional portal configuration ID. If not provided, falls back to legacy behavior based on subscription interval.
   * @type {string}
   * @memberof BillingApiBillingPortalRetrieve
   */
  readonly portalConfigId?: string
}

/**
 * Request parameters for billingStorePurchaseCreate operation in BillingApi.
 * @export
 * @interface BillingApiBillingStorePurchaseCreateRequest
 */
export interface BillingApiBillingStorePurchaseCreateRequest {
  /**
   *
   * @type {StorePurchase}
   * @memberof BillingApiBillingStorePurchaseCreate
   */
  readonly storePurchase: StorePurchase
}

/**
 * Request parameters for billingSubscriptionRetrieve operation in BillingApi.
 * @export
 * @interface BillingApiBillingSubscriptionRetrieveRequest
 */
export interface BillingApiBillingSubscriptionRetrieveRequest {
  /**
   * Filters the listings under each offer_catalog offer to one store. Omit to receive every store\&#39;s listings. Unrecognised values are ignored.
   * @type {'android' | 'ios'}
   * @memberof BillingApiBillingSubscriptionRetrieve
   */
  readonly platform?: BillingSubscriptionRetrievePlatformEnum

  /**
   * Pass 1 or true to include store_debug: the user\&#39;s raw Apple/Google store data per purchase, for diagnosing status mismatches from the developer settings screen.
   * @type {'1' | 'true'}
   * @memberof BillingApiBillingSubscriptionRetrieve
   */
  readonly debug?: BillingSubscriptionRetrieveDebugEnum
}

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
  /**
   * Complete the embedded checkout process
   * @param {BillingApiBillingCheckoutCompleteEmbeddedCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingCheckoutCompleteEmbeddedCreate(
    requestParameters: BillingApiBillingCheckoutCompleteEmbeddedCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingCheckoutCompleteEmbeddedCreate(requestParameters.completeEmbeddedCheckout, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {BillingApiBillingCheckoutCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingCheckoutCreate(
    requestParameters: BillingApiBillingCheckoutCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingCheckoutCreate(requestParameters.checkout, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Clear the requesting user\'s billing caches (resolved status + per-provider last-known-good). Developer/debug affordance: the next subscription read recomputes from live sources. Returns the keys deleted.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingDebugCacheClear(options?: AxiosRequestConfig) {
    return BillingApiFp(this.configuration)
      .billingDebugCacheClear(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a Stripe Billing Portal session and return the URL
   * @param {BillingApiBillingPortalRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingPortalRetrieve(
    requestParameters: BillingApiBillingPortalRetrieveRequest = {},
    options?: AxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingPortalRetrieve(requestParameters.portalConfigId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {BillingApiBillingStorePurchaseCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingStorePurchaseCreate(
    requestParameters: BillingApiBillingStorePurchaseCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingStorePurchaseCreate(requestParameters.storePurchase, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {BillingApiBillingSubscriptionRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingSubscriptionRetrieve(
    requestParameters: BillingApiBillingSubscriptionRetrieveRequest = {},
    options?: AxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingSubscriptionRetrieve(requestParameters.platform, requestParameters.debug, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const BillingSubscriptionRetrievePlatformEnum = {
  Android: 'android',
  Ios: 'ios'
} as const
export type BillingSubscriptionRetrievePlatformEnum =
  (typeof BillingSubscriptionRetrievePlatformEnum)[keyof typeof BillingSubscriptionRetrievePlatformEnum]
/**
 * @export
 */
export const BillingSubscriptionRetrieveDebugEnum = {
  _1: '1',
  True: 'true'
} as const
export type BillingSubscriptionRetrieveDebugEnum =
  (typeof BillingSubscriptionRetrieveDebugEnum)[keyof typeof BillingSubscriptionRetrieveDebugEnum]

/**
 * BlocklistApi - axios parameter creator
 * @export
 */
export const BlocklistApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {BlockedSender} blockedSender
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blocklistCreate: async (
      blockedSender: BlockedSender,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'blockedSender' is not null or undefined
      assertParamExists('blocklistCreate', 'blockedSender', blockedSender)
      const localVarPath = `/blocklist/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        blockedSender,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blocklistList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/blocklist/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBlockedSender: async (
      value: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'value' is not null or undefined
      assertParamExists('deleteBlockedSender', 'value', value)
      const localVarPath = `/blocklist/{value}/`.replace(
        `{${'value'}}`,
        encodeURIComponent(String(value))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * BlocklistApi - functional programming interface
 * @export
 */
export const BlocklistApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BlocklistApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {BlockedSender} blockedSender
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async blocklistCreate(
      blockedSender: BlockedSender,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedSender>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.blocklistCreate(
        blockedSender,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async blocklistList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBlockedSenderList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.blocklistList(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteBlockedSender(
      value: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBlockedSender(value, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * BlocklistApi - factory interface
 * @export
 */
export const BlocklistApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BlocklistApiFp(configuration)
  return {
    /**
     *
     * @param {BlocklistApiBlocklistCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blocklistCreate(
      requestParameters: BlocklistApiBlocklistCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<BlockedSender> {
      return localVarFp
        .blocklistCreate(requestParameters.blockedSender, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {BlocklistApiBlocklistListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blocklistList(
      requestParameters: BlocklistApiBlocklistListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedBlockedSenderList> {
      return localVarFp
        .blocklistList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {BlocklistApiDeleteBlockedSenderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBlockedSender(
      requestParameters: BlocklistApiDeleteBlockedSenderRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .deleteBlockedSender(requestParameters.value, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for blocklistCreate operation in BlocklistApi.
 * @export
 * @interface BlocklistApiBlocklistCreateRequest
 */
export interface BlocklistApiBlocklistCreateRequest {
  /**
   *
   * @type {BlockedSender}
   * @memberof BlocklistApiBlocklistCreate
   */
  readonly blockedSender: BlockedSender
}

/**
 * Request parameters for blocklistList operation in BlocklistApi.
 * @export
 * @interface BlocklistApiBlocklistListRequest
 */
export interface BlocklistApiBlocklistListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof BlocklistApiBlocklistList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof BlocklistApiBlocklistList
   */
  readonly perPage?: number
}

/**
 * Request parameters for deleteBlockedSender operation in BlocklistApi.
 * @export
 * @interface BlocklistApiDeleteBlockedSenderRequest
 */
export interface BlocklistApiDeleteBlockedSenderRequest {
  /**
   *
   * @type {string}
   * @memberof BlocklistApiDeleteBlockedSender
   */
  readonly value: string
}

/**
 * BlocklistApi - object-oriented interface
 * @export
 * @class BlocklistApi
 * @extends {BaseAPI}
 */
export class BlocklistApi extends BaseAPI {
  /**
   *
   * @param {BlocklistApiBlocklistCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BlocklistApi
   */
  public blocklistCreate(
    requestParameters: BlocklistApiBlocklistCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return BlocklistApiFp(this.configuration)
      .blocklistCreate(requestParameters.blockedSender, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {BlocklistApiBlocklistListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BlocklistApi
   */
  public blocklistList(
    requestParameters: BlocklistApiBlocklistListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return BlocklistApiFp(this.configuration)
      .blocklistList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {BlocklistApiDeleteBlockedSenderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BlocklistApi
   */
  public deleteBlockedSender(
    requestParameters: BlocklistApiDeleteBlockedSenderRequest,
    options?: AxiosRequestConfig
  ) {
    return BlocklistApiFp(this.configuration)
      .deleteBlockedSender(requestParameters.value, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CalendarGroupsApi - axios parameter creator
 * @export
 */
export const CalendarGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Add a calendar to a calendar group
     * @param {string} groupId
     * @param {AddCalendarToGroupRequest} addCalendarToGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCalendarToGroup: async (
      groupId: string,
      addCalendarToGroupRequest: AddCalendarToGroupRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('addCalendarToGroup', 'groupId', groupId)
      // verify required parameter 'addCalendarToGroupRequest' is not null or undefined
      assertParamExists(
        'addCalendarToGroup',
        'addCalendarToGroupRequest',
        addCalendarToGroupRequest
      )
      const localVarPath = `/calendar-groups/{group_id}/calendars/`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addCalendarToGroupRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsCalendarsDestroy: async (
      groupId: string,
      remoteAddress: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('calendarGroupsCalendarsDestroy', 'groupId', groupId)
      // verify required parameter 'remoteAddress' is not null or undefined
      assertParamExists('calendarGroupsCalendarsDestroy', 'remoteAddress', remoteAddress)
      const localVarPath = `/calendar-groups/{group_id}/calendars/{remote_address}/`
        .replace(`{${'group_id'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'remote_address'}}`, encodeURIComponent(String(remoteAddress)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsCalendarsRetrieve: async (
      groupId: string,
      remoteAddress: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('calendarGroupsCalendarsRetrieve', 'groupId', groupId)
      // verify required parameter 'remoteAddress' is not null or undefined
      assertParamExists('calendarGroupsCalendarsRetrieve', 'remoteAddress', remoteAddress)
      const localVarPath = `/calendar-groups/{group_id}/calendars/{remote_address}/`
        .replace(`{${'group_id'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'remote_address'}}`, encodeURIComponent(String(remoteAddress)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {CalendarGroupMembership} calendarGroupMembership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsCalendarsUpdate: async (
      groupId: string,
      remoteAddress: string,
      calendarGroupMembership: CalendarGroupMembership,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('calendarGroupsCalendarsUpdate', 'groupId', groupId)
      // verify required parameter 'remoteAddress' is not null or undefined
      assertParamExists('calendarGroupsCalendarsUpdate', 'remoteAddress', remoteAddress)
      // verify required parameter 'calendarGroupMembership' is not null or undefined
      assertParamExists(
        'calendarGroupsCalendarsUpdate',
        'calendarGroupMembership',
        calendarGroupMembership
      )
      const localVarPath = `/calendar-groups/{group_id}/calendars/{remote_address}/`
        .replace(`{${'group_id'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'remote_address'}}`, encodeURIComponent(String(remoteAddress)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        calendarGroupMembership,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsDestroy: async (
      groupId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('calendarGroupsDestroy', 'groupId', groupId)
      const localVarPath = `/calendar-groups/{group_id}/`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List all calendar groups or create a new one
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendar-groups/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {PatchedCalendarGroup} [patchedCalendarGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsPartialUpdate: async (
      groupId: string,
      patchedCalendarGroup?: PatchedCalendarGroup,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('calendarGroupsPartialUpdate', 'groupId', groupId)
      const localVarPath = `/calendar-groups/{group_id}/`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedCalendarGroup,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsRetrieve: async (
      groupId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('calendarGroupsRetrieve', 'groupId', groupId)
      const localVarPath = `/calendar-groups/{group_id}/`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {CalendarGroup} [calendarGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsUpdate: async (
      groupId: string,
      calendarGroup?: CalendarGroup,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('calendarGroupsUpdate', 'groupId', groupId)
      const localVarPath = `/calendar-groups/{group_id}/`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        calendarGroup,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List all calendar groups or create a new one
     * @param {CreateCalendarGroupRequest} [createCalendarGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCalendarGroup: async (
      createCalendarGroupRequest?: CreateCalendarGroupRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendar-groups/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCalendarGroupRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Reorder calendar groups
     * @param {ReorderCalendarGroupsRequest} reorderCalendarGroupsRequest
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reorderCalendarGroups: async (
      reorderCalendarGroupsRequest: ReorderCalendarGroupsRequest,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'reorderCalendarGroupsRequest' is not null or undefined
      assertParamExists(
        'reorderCalendarGroups',
        'reorderCalendarGroupsRequest',
        reorderCalendarGroupsRequest
      )
      const localVarPath = `/calendar-groups/reorder/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        reorderCalendarGroupsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Reorder calendars within a calendar group
     * @param {string} groupId
     * @param {ReorderCalendarsRequest} reorderCalendarsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reorderCalendarsInGroup: async (
      groupId: string,
      reorderCalendarsRequest: ReorderCalendarsRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('reorderCalendarsInGroup', 'groupId', groupId)
      // verify required parameter 'reorderCalendarsRequest' is not null or undefined
      assertParamExists(
        'reorderCalendarsInGroup',
        'reorderCalendarsRequest',
        reorderCalendarsRequest
      )
      const localVarPath = `/calendar-groups/{group_id}/calendars/reorder/`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        reorderCalendarsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {PatchedUpdateMembershipRequest} [patchedUpdateMembershipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCalendarMembership: async (
      groupId: string,
      remoteAddress: string,
      patchedUpdateMembershipRequest?: PatchedUpdateMembershipRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('updateCalendarMembership', 'groupId', groupId)
      // verify required parameter 'remoteAddress' is not null or undefined
      assertParamExists('updateCalendarMembership', 'remoteAddress', remoteAddress)
      const localVarPath = `/calendar-groups/{group_id}/calendars/{remote_address}/`
        .replace(`{${'group_id'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'remote_address'}}`, encodeURIComponent(String(remoteAddress)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedUpdateMembershipRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * CalendarGroupsApi - functional programming interface
 * @export
 */
export const CalendarGroupsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CalendarGroupsApiAxiosParamCreator(configuration)
  return {
    /**
     * Add a calendar to a calendar group
     * @param {string} groupId
     * @param {AddCalendarToGroupRequest} addCalendarToGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addCalendarToGroup(
      groupId: string,
      addCalendarToGroupRequest: AddCalendarToGroupRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroupMembership>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addCalendarToGroup(
        groupId,
        addCalendarToGroupRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsCalendarsDestroy(
      groupId: string,
      remoteAddress: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsCalendarsDestroy(
        groupId,
        remoteAddress,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsCalendarsRetrieve(
      groupId: string,
      remoteAddress: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroupMembership>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsCalendarsRetrieve(
        groupId,
        remoteAddress,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {CalendarGroupMembership} calendarGroupMembership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsCalendarsUpdate(
      groupId: string,
      remoteAddress: string,
      calendarGroupMembership: CalendarGroupMembership,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroupMembership>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsCalendarsUpdate(
        groupId,
        remoteAddress,
        calendarGroupMembership,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsDestroy(
      groupId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsDestroy(
        groupId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List all calendar groups or create a new one
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCalendarGroupList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsList(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {PatchedCalendarGroup} [patchedCalendarGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsPartialUpdate(
      groupId: string,
      patchedCalendarGroup?: PatchedCalendarGroup,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsPartialUpdate(
        groupId,
        patchedCalendarGroup,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsRetrieve(
      groupId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsRetrieve(
        groupId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {string} groupId
     * @param {CalendarGroup} [calendarGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarGroupsUpdate(
      groupId: string,
      calendarGroup?: CalendarGroup,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarGroupsUpdate(
        groupId,
        calendarGroup,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List all calendar groups or create a new one
     * @param {CreateCalendarGroupRequest} [createCalendarGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCalendarGroup(
      createCalendarGroupRequest?: CreateCalendarGroupRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarGroup(
        createCalendarGroupRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Reorder calendar groups
     * @param {ReorderCalendarGroupsRequest} reorderCalendarGroupsRequest
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reorderCalendarGroups(
      reorderCalendarGroupsRequest: ReorderCalendarGroupsRequest,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCalendarGroupList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reorderCalendarGroups(
        reorderCalendarGroupsRequest,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Reorder calendars within a calendar group
     * @param {string} groupId
     * @param {ReorderCalendarsRequest} reorderCalendarsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reorderCalendarsInGroup(
      groupId: string,
      reorderCalendarsRequest: ReorderCalendarsRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reorderCalendarsInGroup(
        groupId,
        reorderCalendarsRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {string} groupId
     * @param {string} remoteAddress
     * @param {PatchedUpdateMembershipRequest} [patchedUpdateMembershipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCalendarMembership(
      groupId: string,
      remoteAddress: string,
      patchedUpdateMembershipRequest?: PatchedUpdateMembershipRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGroupMembership>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarMembership(
        groupId,
        remoteAddress,
        patchedUpdateMembershipRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * CalendarGroupsApi - factory interface
 * @export
 */
export const CalendarGroupsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CalendarGroupsApiFp(configuration)
  return {
    /**
     * Add a calendar to a calendar group
     * @param {CalendarGroupsApiAddCalendarToGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCalendarToGroup(
      requestParameters: CalendarGroupsApiAddCalendarToGroupRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroupMembership> {
      return localVarFp
        .addCalendarToGroup(
          requestParameters.groupId,
          requestParameters.addCalendarToGroupRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {CalendarGroupsApiCalendarGroupsCalendarsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsCalendarsDestroy(
      requestParameters: CalendarGroupsApiCalendarGroupsCalendarsDestroyRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .calendarGroupsCalendarsDestroy(
          requestParameters.groupId,
          requestParameters.remoteAddress,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {CalendarGroupsApiCalendarGroupsCalendarsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsCalendarsRetrieve(
      requestParameters: CalendarGroupsApiCalendarGroupsCalendarsRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroupMembership> {
      return localVarFp
        .calendarGroupsCalendarsRetrieve(
          requestParameters.groupId,
          requestParameters.remoteAddress,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {CalendarGroupsApiCalendarGroupsCalendarsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsCalendarsUpdate(
      requestParameters: CalendarGroupsApiCalendarGroupsCalendarsUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroupMembership> {
      return localVarFp
        .calendarGroupsCalendarsUpdate(
          requestParameters.groupId,
          requestParameters.remoteAddress,
          requestParameters.calendarGroupMembership,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {CalendarGroupsApiCalendarGroupsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsDestroy(
      requestParameters: CalendarGroupsApiCalendarGroupsDestroyRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .calendarGroupsDestroy(requestParameters.groupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List all calendar groups or create a new one
     * @param {CalendarGroupsApiCalendarGroupsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsList(
      requestParameters: CalendarGroupsApiCalendarGroupsListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedCalendarGroupList> {
      return localVarFp
        .calendarGroupsList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {CalendarGroupsApiCalendarGroupsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsPartialUpdate(
      requestParameters: CalendarGroupsApiCalendarGroupsPartialUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroup> {
      return localVarFp
        .calendarGroupsPartialUpdate(
          requestParameters.groupId,
          requestParameters.patchedCalendarGroup,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {CalendarGroupsApiCalendarGroupsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsRetrieve(
      requestParameters: CalendarGroupsApiCalendarGroupsRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroup> {
      return localVarFp
        .calendarGroupsRetrieve(requestParameters.groupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve, update, or delete a calendar group
     * @param {CalendarGroupsApiCalendarGroupsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarGroupsUpdate(
      requestParameters: CalendarGroupsApiCalendarGroupsUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroup> {
      return localVarFp
        .calendarGroupsUpdate(requestParameters.groupId, requestParameters.calendarGroup, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List all calendar groups or create a new one
     * @param {CalendarGroupsApiCreateCalendarGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCalendarGroup(
      requestParameters: CalendarGroupsApiCreateCalendarGroupRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroup> {
      return localVarFp
        .createCalendarGroup(requestParameters.createCalendarGroupRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Reorder calendar groups
     * @param {CalendarGroupsApiReorderCalendarGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reorderCalendarGroups(
      requestParameters: CalendarGroupsApiReorderCalendarGroupsRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedCalendarGroupList> {
      return localVarFp
        .reorderCalendarGroups(
          requestParameters.reorderCalendarGroupsRequest,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Reorder calendars within a calendar group
     * @param {CalendarGroupsApiReorderCalendarsInGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reorderCalendarsInGroup(
      requestParameters: CalendarGroupsApiReorderCalendarsInGroupRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroup> {
      return localVarFp
        .reorderCalendarsInGroup(
          requestParameters.groupId,
          requestParameters.reorderCalendarsRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get, update, or remove a calendar membership in a group
     * @param {CalendarGroupsApiUpdateCalendarMembershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCalendarMembership(
      requestParameters: CalendarGroupsApiUpdateCalendarMembershipRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarGroupMembership> {
      return localVarFp
        .updateCalendarMembership(
          requestParameters.groupId,
          requestParameters.remoteAddress,
          requestParameters.patchedUpdateMembershipRequest,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for addCalendarToGroup operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiAddCalendarToGroupRequest
 */
export interface CalendarGroupsApiAddCalendarToGroupRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiAddCalendarToGroup
   */
  readonly groupId: string

  /**
   *
   * @type {AddCalendarToGroupRequest}
   * @memberof CalendarGroupsApiAddCalendarToGroup
   */
  readonly addCalendarToGroupRequest: AddCalendarToGroupRequest
}

/**
 * Request parameters for calendarGroupsCalendarsDestroy operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsCalendarsDestroyRequest
 */
export interface CalendarGroupsApiCalendarGroupsCalendarsDestroyRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsCalendarsDestroy
   */
  readonly groupId: string

  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsCalendarsDestroy
   */
  readonly remoteAddress: string
}

/**
 * Request parameters for calendarGroupsCalendarsRetrieve operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsCalendarsRetrieveRequest
 */
export interface CalendarGroupsApiCalendarGroupsCalendarsRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsCalendarsRetrieve
   */
  readonly groupId: string

  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsCalendarsRetrieve
   */
  readonly remoteAddress: string
}

/**
 * Request parameters for calendarGroupsCalendarsUpdate operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsCalendarsUpdateRequest
 */
export interface CalendarGroupsApiCalendarGroupsCalendarsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsCalendarsUpdate
   */
  readonly groupId: string

  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsCalendarsUpdate
   */
  readonly remoteAddress: string

  /**
   *
   * @type {CalendarGroupMembership}
   * @memberof CalendarGroupsApiCalendarGroupsCalendarsUpdate
   */
  readonly calendarGroupMembership: CalendarGroupMembership
}

/**
 * Request parameters for calendarGroupsDestroy operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsDestroyRequest
 */
export interface CalendarGroupsApiCalendarGroupsDestroyRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsDestroy
   */
  readonly groupId: string
}

/**
 * Request parameters for calendarGroupsList operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsListRequest
 */
export interface CalendarGroupsApiCalendarGroupsListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarGroupsApiCalendarGroupsList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarGroupsApiCalendarGroupsList
   */
  readonly perPage?: number
}

/**
 * Request parameters for calendarGroupsPartialUpdate operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsPartialUpdateRequest
 */
export interface CalendarGroupsApiCalendarGroupsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsPartialUpdate
   */
  readonly groupId: string

  /**
   *
   * @type {PatchedCalendarGroup}
   * @memberof CalendarGroupsApiCalendarGroupsPartialUpdate
   */
  readonly patchedCalendarGroup?: PatchedCalendarGroup
}

/**
 * Request parameters for calendarGroupsRetrieve operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsRetrieveRequest
 */
export interface CalendarGroupsApiCalendarGroupsRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsRetrieve
   */
  readonly groupId: string
}

/**
 * Request parameters for calendarGroupsUpdate operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCalendarGroupsUpdateRequest
 */
export interface CalendarGroupsApiCalendarGroupsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiCalendarGroupsUpdate
   */
  readonly groupId: string

  /**
   *
   * @type {CalendarGroup}
   * @memberof CalendarGroupsApiCalendarGroupsUpdate
   */
  readonly calendarGroup?: CalendarGroup
}

/**
 * Request parameters for createCalendarGroup operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiCreateCalendarGroupRequest
 */
export interface CalendarGroupsApiCreateCalendarGroupRequest {
  /**
   *
   * @type {CreateCalendarGroupRequest}
   * @memberof CalendarGroupsApiCreateCalendarGroup
   */
  readonly createCalendarGroupRequest?: CreateCalendarGroupRequest
}

/**
 * Request parameters for reorderCalendarGroups operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiReorderCalendarGroupsRequest
 */
export interface CalendarGroupsApiReorderCalendarGroupsRequest {
  /**
   *
   * @type {ReorderCalendarGroupsRequest}
   * @memberof CalendarGroupsApiReorderCalendarGroups
   */
  readonly reorderCalendarGroupsRequest: ReorderCalendarGroupsRequest

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarGroupsApiReorderCalendarGroups
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarGroupsApiReorderCalendarGroups
   */
  readonly perPage?: number
}

/**
 * Request parameters for reorderCalendarsInGroup operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiReorderCalendarsInGroupRequest
 */
export interface CalendarGroupsApiReorderCalendarsInGroupRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiReorderCalendarsInGroup
   */
  readonly groupId: string

  /**
   *
   * @type {ReorderCalendarsRequest}
   * @memberof CalendarGroupsApiReorderCalendarsInGroup
   */
  readonly reorderCalendarsRequest: ReorderCalendarsRequest
}

/**
 * Request parameters for updateCalendarMembership operation in CalendarGroupsApi.
 * @export
 * @interface CalendarGroupsApiUpdateCalendarMembershipRequest
 */
export interface CalendarGroupsApiUpdateCalendarMembershipRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiUpdateCalendarMembership
   */
  readonly groupId: string

  /**
   *
   * @type {string}
   * @memberof CalendarGroupsApiUpdateCalendarMembership
   */
  readonly remoteAddress: string

  /**
   *
   * @type {PatchedUpdateMembershipRequest}
   * @memberof CalendarGroupsApiUpdateCalendarMembership
   */
  readonly patchedUpdateMembershipRequest?: PatchedUpdateMembershipRequest
}

/**
 * CalendarGroupsApi - object-oriented interface
 * @export
 * @class CalendarGroupsApi
 * @extends {BaseAPI}
 */
export class CalendarGroupsApi extends BaseAPI {
  /**
   * Add a calendar to a calendar group
   * @param {CalendarGroupsApiAddCalendarToGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public addCalendarToGroup(
    requestParameters: CalendarGroupsApiAddCalendarToGroupRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .addCalendarToGroup(
        requestParameters.groupId,
        requestParameters.addCalendarToGroupRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get, update, or remove a calendar membership in a group
   * @param {CalendarGroupsApiCalendarGroupsCalendarsDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsCalendarsDestroy(
    requestParameters: CalendarGroupsApiCalendarGroupsCalendarsDestroyRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsCalendarsDestroy(
        requestParameters.groupId,
        requestParameters.remoteAddress,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get, update, or remove a calendar membership in a group
   * @param {CalendarGroupsApiCalendarGroupsCalendarsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsCalendarsRetrieve(
    requestParameters: CalendarGroupsApiCalendarGroupsCalendarsRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsCalendarsRetrieve(
        requestParameters.groupId,
        requestParameters.remoteAddress,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get, update, or remove a calendar membership in a group
   * @param {CalendarGroupsApiCalendarGroupsCalendarsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsCalendarsUpdate(
    requestParameters: CalendarGroupsApiCalendarGroupsCalendarsUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsCalendarsUpdate(
        requestParameters.groupId,
        requestParameters.remoteAddress,
        requestParameters.calendarGroupMembership,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve, update, or delete a calendar group
   * @param {CalendarGroupsApiCalendarGroupsDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsDestroy(
    requestParameters: CalendarGroupsApiCalendarGroupsDestroyRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsDestroy(requestParameters.groupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List all calendar groups or create a new one
   * @param {CalendarGroupsApiCalendarGroupsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsList(
    requestParameters: CalendarGroupsApiCalendarGroupsListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve, update, or delete a calendar group
   * @param {CalendarGroupsApiCalendarGroupsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsPartialUpdate(
    requestParameters: CalendarGroupsApiCalendarGroupsPartialUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsPartialUpdate(
        requestParameters.groupId,
        requestParameters.patchedCalendarGroup,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve, update, or delete a calendar group
   * @param {CalendarGroupsApiCalendarGroupsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsRetrieve(
    requestParameters: CalendarGroupsApiCalendarGroupsRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsRetrieve(requestParameters.groupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve, update, or delete a calendar group
   * @param {CalendarGroupsApiCalendarGroupsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public calendarGroupsUpdate(
    requestParameters: CalendarGroupsApiCalendarGroupsUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .calendarGroupsUpdate(requestParameters.groupId, requestParameters.calendarGroup, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List all calendar groups or create a new one
   * @param {CalendarGroupsApiCreateCalendarGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public createCalendarGroup(
    requestParameters: CalendarGroupsApiCreateCalendarGroupRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .createCalendarGroup(requestParameters.createCalendarGroupRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Reorder calendar groups
   * @param {CalendarGroupsApiReorderCalendarGroupsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public reorderCalendarGroups(
    requestParameters: CalendarGroupsApiReorderCalendarGroupsRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .reorderCalendarGroups(
        requestParameters.reorderCalendarGroupsRequest,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Reorder calendars within a calendar group
   * @param {CalendarGroupsApiReorderCalendarsInGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public reorderCalendarsInGroup(
    requestParameters: CalendarGroupsApiReorderCalendarsInGroupRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .reorderCalendarsInGroup(
        requestParameters.groupId,
        requestParameters.reorderCalendarsRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get, update, or remove a calendar membership in a group
   * @param {CalendarGroupsApiUpdateCalendarMembershipRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarGroupsApi
   */
  public updateCalendarMembership(
    requestParameters: CalendarGroupsApiUpdateCalendarMembershipRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarGroupsApiFp(this.configuration)
      .updateCalendarMembership(
        requestParameters.groupId,
        requestParameters.remoteAddress,
        requestParameters.patchedUpdateMembershipRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CalendarListApi - axios parameter creator
 * @export
 */
export const CalendarListApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarListRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/calendar-list/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {Array<Calendar>} calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCalendars: async (
      calendar: Array<Calendar>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendar' is not null or undefined
      assertParamExists('updateCalendars', 'calendar', calendar)
      const localVarPath = `/calendar-list/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        calendar,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * CalendarListApi - functional programming interface
 * @export
 */
export const CalendarListApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CalendarListApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarListRetrieve(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupedCalendarsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarListRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {Array<Calendar>} calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCalendars(
      calendar: Array<Calendar>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendars(calendar, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * CalendarListApi - factory interface
 * @export
 */
export const CalendarListApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CalendarListApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarListRetrieve(options?: AxiosRequestConfig): AxiosPromise<GroupedCalendarsResponse> {
      return localVarFp.calendarListRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarListApiUpdateCalendarsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCalendars(
      requestParameters: CalendarListApiUpdateCalendarsRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .updateCalendars(requestParameters.calendar, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for updateCalendars operation in CalendarListApi.
 * @export
 * @interface CalendarListApiUpdateCalendarsRequest
 */
export interface CalendarListApiUpdateCalendarsRequest {
  /**
   *
   * @type {Array<Calendar>}
   * @memberof CalendarListApiUpdateCalendars
   */
  readonly calendar: Array<Calendar>
}

/**
 * CalendarListApi - object-oriented interface
 * @export
 * @class CalendarListApi
 * @extends {BaseAPI}
 */
export class CalendarListApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarListApi
   */
  public calendarListRetrieve(options?: AxiosRequestConfig) {
    return CalendarListApiFp(this.configuration)
      .calendarListRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarListApiUpdateCalendarsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarListApi
   */
  public updateCalendars(
    requestParameters: CalendarListApiUpdateCalendarsRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarListApiFp(this.configuration)
      .updateCalendars(requestParameters.calendar, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CalendarsApi - axios parameter creator
 * @export
 */
export const CalendarsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} calendarId
     * @param {EventParams} eventParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEvent: async (
      calendarId: string,
      eventParams: EventParams,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('createEvent', 'calendarId', calendarId)
      // verify required parameter 'eventParams' is not null or undefined
      assertParamExists('createEvent', 'eventParams', eventParams)
      const localVarPath = `/calendars/{calendar_id}/events/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        eventParams,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {EventParams} eventParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEventOnPrimary: async (
      eventParams: EventParams,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventParams' is not null or undefined
      assertParamExists('createEventOnPrimary', 'eventParams', eventParams)
      const localVarPath = `/calendars/primary/events/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        eventParams,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} calendarId
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCalendar: async (
      calendarId: string,
      calendarAccount?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('getCalendar', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (calendarAccount !== undefined) {
        localVarQueryParameter['calendar_account'] = calendarAccount
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrimaryCalendar: async (
      calendarAccount?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (calendarAccount !== undefined) {
        localVarQueryParameter['calendar_account'] = calendarAccount
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Initialize or reinitialize the primary calendar. Creates the calendar if it doesn\'t exist, sets up the default calendar group, and subscribes to notifications.
     * @param {Calendar} calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initializePrimaryCalendar: async (
      calendar: Calendar,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendar' is not null or undefined
      assertParamExists('initializePrimaryCalendar', 'calendar', calendar)
      const localVarPath = `/calendars/primary/initialize/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        calendar,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list1on1s: async (
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('list1on1s', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/one-on-ones/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list1on1sOnPrimary: async (
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/one-on-ones/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCalendars: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEvents: async (
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('listEvents', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/events/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEventsOnPrimary: async (
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/events/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listExternal: async (
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('listExternal', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/external/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listExternalOnPrimary: async (
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/external/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInternal: async (
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('listInternal', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/internal/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInternalOnPrimary: async (
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/internal/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listNotable: async (
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('listNotable', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/notable/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listNotableOnPrimary: async (
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/notable/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of recurring events for the current user.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRecurring: async (
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('listRecurring', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/recurring/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns a list of recurring events for the current user.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRecurringOnPrimary: async (
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/recurring/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSchedule: async (
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('listSchedule', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/schedule/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listScheduleOnPrimary: async (
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/schedule/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (rsvpStatus !== undefined) {
        localVarQueryParameter['rsvp_status'] = rsvpStatus
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get events that need RSVP responses from the current user
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUnrespondedRsvps: async (
      calendarId: string,
      after?: string,
      before?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('listUnrespondedRsvps', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/unresponded-rsvps/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get events that need RSVP responses from the current user
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUnrespondedRsvpsOnPrimary: async (
      after?: string,
      before?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/unresponded-rsvps/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (after !== undefined) {
        localVarQueryParameter['after'] =
          (after as any) instanceof Date ? (after as any).toISOString() : after
      }

      if (before !== undefined) {
        localVarQueryParameter['before'] =
          (before as any) instanceof Date ? (before as any).toISOString() : before
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} calendarId
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {PatchedCalendar} [patchedCalendar]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCalendar: async (
      calendarId: string,
      calendarAccount?: string,
      patchedCalendar?: PatchedCalendar,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('patchCalendar', 'calendarId', calendarId)
      const localVarPath = `/calendars/{calendar_id}/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (calendarAccount !== undefined) {
        localVarQueryParameter['calendar_account'] = calendarAccount
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedCalendar,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {PatchedCalendar} [patchedCalendar]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPrimaryCalendar: async (
      calendarAccount?: string,
      patchedCalendar?: PatchedCalendar,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/primary/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (calendarAccount !== undefined) {
        localVarQueryParameter['calendar_account'] = calendarAccount
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedCalendar,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeToCalendar: async (
      body?: object,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/calendars/subscribe/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} calendarId
     * @param {SyncRequest} syncRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncCalendar: async (
      calendarId: string,
      syncRequest: SyncRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('syncCalendar', 'calendarId', calendarId)
      // verify required parameter 'syncRequest' is not null or undefined
      assertParamExists('syncCalendar', 'syncRequest', syncRequest)
      const localVarPath = `/calendars/{calendar_id}/sync/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        syncRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {SyncRequest} syncRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncPrimaryCalendar: async (
      syncRequest: SyncRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'syncRequest' is not null or undefined
      assertParamExists('syncPrimaryCalendar', 'syncRequest', syncRequest)
      const localVarPath = `/calendars/primary/sync/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        syncRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} calendarId
     * @param {Calendar} calendar
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCalendar: async (
      calendarId: string,
      calendar: Calendar,
      calendarAccount?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarId' is not null or undefined
      assertParamExists('updateCalendar', 'calendarId', calendarId)
      // verify required parameter 'calendar' is not null or undefined
      assertParamExists('updateCalendar', 'calendar', calendar)
      const localVarPath = `/calendars/{calendar_id}/`.replace(
        `{${'calendar_id'}}`,
        encodeURIComponent(String(calendarId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (calendarAccount !== undefined) {
        localVarQueryParameter['calendar_account'] = calendarAccount
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        calendar,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {Calendar} calendar
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePrimaryCalendar: async (
      calendar: Calendar,
      calendarAccount?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendar' is not null or undefined
      assertParamExists('updatePrimaryCalendar', 'calendar', calendar)
      const localVarPath = `/calendars/primary/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (calendarAccount !== undefined) {
        localVarQueryParameter['calendar_account'] = calendarAccount
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        calendar,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * CalendarsApi - functional programming interface
 * @export
 */
export const CalendarsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CalendarsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} calendarId
     * @param {EventParams} eventParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEvent(
      calendarId: string,
      eventParams: EventParams,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createEvent(
        calendarId,
        eventParams,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {EventParams} eventParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEventOnPrimary(
      eventParams: EventParams,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createEventOnPrimary(
        eventParams,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} calendarId
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCalendar(
      calendarId: string,
      calendarAccount?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calendar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendar(
        calendarId,
        calendarAccount,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPrimaryCalendar(
      calendarAccount?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calendar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryCalendar(
        calendarAccount,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Initialize or reinitialize the primary calendar. Creates the calendar if it doesn\'t exist, sets up the default calendar group, and subscribes to notifications.
     * @param {Calendar} calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initializePrimaryCalendar(
      calendar: Calendar,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calendar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initializePrimaryCalendar(
        calendar,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async list1on1s(
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOneOnOneEventList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.list1on1s(
        calendarId,
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async list1on1sOnPrimary(
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOneOnOneEventList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.list1on1sOnPrimary(
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCalendars(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCalendarList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCalendars(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listEvents(
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listEvents(
        calendarId,
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listEventsOnPrimary(
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listEventsOnPrimary(
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listExternal(
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listExternal(
        calendarId,
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listExternalOnPrimary(
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listExternalOnPrimary(
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listInternal(
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listInternal(
        calendarId,
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listInternalOnPrimary(
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listInternalOnPrimary(
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listNotable(
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNotableEventList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listNotable(
        calendarId,
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listNotableOnPrimary(
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNotableEventList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listNotableOnPrimary(
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of recurring events for the current user.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listRecurring(
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRecurringMeetingList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listRecurring(
        calendarId,
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Returns a list of recurring events for the current user.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listRecurringOnPrimary(
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRecurringMeetingList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listRecurringOnPrimary(
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listSchedule(
      calendarId: string,
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listSchedule(
        calendarId,
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [rsvpStatus] The current users RSVP status on the events.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listScheduleOnPrimary(
      after?: string,
      before?: string,
      rsvpStatus?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listScheduleOnPrimary(
        after,
        before,
        rsvpStatus,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get events that need RSVP responses from the current user
     * @param {string} calendarId
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUnrespondedRsvps(
      calendarId: string,
      after?: string,
      before?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnrespondedEventList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listUnrespondedRsvps(
        calendarId,
        after,
        before,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get events that need RSVP responses from the current user
     * @param {string} [after] The lower bound of the search.
     * @param {string} [before] The upper bound of the search.
     * @param {string} [orderBy] The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUnrespondedRsvpsOnPrimary(
      after?: string,
      before?: string,
      orderBy?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnrespondedEventList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listUnrespondedRsvpsOnPrimary(
        after,
        before,
        orderBy,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} calendarId
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {PatchedCalendar} [patchedCalendar]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchCalendar(
      calendarId: string,
      calendarAccount?: string,
      patchedCalendar?: PatchedCalendar,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calendar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchCalendar(
        calendarId,
        calendarAccount,
        patchedCalendar,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {PatchedCalendar} [patchedCalendar]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchPrimaryCalendar(
      calendarAccount?: string,
      patchedCalendar?: PatchedCalendar,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calendar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchPrimaryCalendar(
        calendarAccount,
        patchedCalendar,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscribeToCalendar(
      body?: object,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarChannel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeToCalendar(body, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} calendarId
     * @param {SyncRequest} syncRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async syncCalendar(
      calendarId: string,
      syncRequest: SyncRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.syncCalendar(
        calendarId,
        syncRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {SyncRequest} syncRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async syncPrimaryCalendar(
      syncRequest: SyncRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.syncPrimaryCalendar(
        syncRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} calendarId
     * @param {Calendar} calendar
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCalendar(
      calendarId: string,
      calendar: Calendar,
      calendarAccount?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calendar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendar(
        calendarId,
        calendar,
        calendarAccount,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {Calendar} calendar
     * @param {string} [calendarAccount] Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePrimaryCalendar(
      calendar: Calendar,
      calendarAccount?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calendar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrimaryCalendar(
        calendar,
        calendarAccount,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * CalendarsApi - factory interface
 * @export
 */
export const CalendarsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CalendarsApiFp(configuration)
  return {
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {CalendarsApiCreateEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEvent(
      requestParameters: CalendarsApiCreateEventRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Event> {
      return localVarFp
        .createEvent(requestParameters.calendarId, requestParameters.eventParams, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {CalendarsApiCreateEventOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEventOnPrimary(
      requestParameters: CalendarsApiCreateEventOnPrimaryRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Event> {
      return localVarFp
        .createEventOnPrimary(requestParameters.eventParams, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiGetCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCalendar(
      requestParameters: CalendarsApiGetCalendarRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Calendar> {
      return localVarFp
        .getCalendar(requestParameters.calendarId, requestParameters.calendarAccount, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiGetPrimaryCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrimaryCalendar(
      requestParameters: CalendarsApiGetPrimaryCalendarRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<Calendar> {
      return localVarFp
        .getPrimaryCalendar(requestParameters.calendarAccount, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Initialize or reinitialize the primary calendar. Creates the calendar if it doesn\'t exist, sets up the default calendar group, and subscribes to notifications.
     * @param {CalendarsApiInitializePrimaryCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initializePrimaryCalendar(
      requestParameters: CalendarsApiInitializePrimaryCalendarRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Calendar> {
      return localVarFp
        .initializePrimaryCalendar(requestParameters.calendar, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
     * @param {CalendarsApiList1on1sRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list1on1s(
      requestParameters: CalendarsApiList1on1sRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedOneOnOneEventList> {
      return localVarFp
        .list1on1s(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
     * @param {CalendarsApiList1on1sOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list1on1sOnPrimary(
      requestParameters: CalendarsApiList1on1sOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedOneOnOneEventList> {
      return localVarFp
        .list1on1sOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiListCalendarsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCalendars(
      requestParameters: CalendarsApiListCalendarsRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedCalendarList> {
      return localVarFp
        .listCalendars(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {CalendarsApiListEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEvents(
      requestParameters: CalendarsApiListEventsRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listEvents(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {CalendarsApiListEventsOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEventsOnPrimary(
      requestParameters: CalendarsApiListEventsOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listEventsOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {CalendarsApiListExternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listExternal(
      requestParameters: CalendarsApiListExternalRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listExternal(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {CalendarsApiListExternalOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listExternalOnPrimary(
      requestParameters: CalendarsApiListExternalOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listExternalOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {CalendarsApiListInternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInternal(
      requestParameters: CalendarsApiListInternalRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listInternal(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
     * @param {CalendarsApiListInternalOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInternalOnPrimary(
      requestParameters: CalendarsApiListInternalOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listInternalOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
     * @param {CalendarsApiListNotableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listNotable(
      requestParameters: CalendarsApiListNotableRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNotableEventList> {
      return localVarFp
        .listNotable(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
     * @param {CalendarsApiListNotableOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listNotableOnPrimary(
      requestParameters: CalendarsApiListNotableOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNotableEventList> {
      return localVarFp
        .listNotableOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of recurring events for the current user.
     * @param {CalendarsApiListRecurringRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRecurring(
      requestParameters: CalendarsApiListRecurringRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedRecurringMeetingList> {
      return localVarFp
        .listRecurring(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a list of recurring events for the current user.
     * @param {CalendarsApiListRecurringOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRecurringOnPrimary(
      requestParameters: CalendarsApiListRecurringOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedRecurringMeetingList> {
      return localVarFp
        .listRecurringOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {CalendarsApiListScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSchedule(
      requestParameters: CalendarsApiListScheduleRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listSchedule(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract class that provides the base functionality for listing events.
     * @param {CalendarsApiListScheduleOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listScheduleOnPrimary(
      requestParameters: CalendarsApiListScheduleOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventList> {
      return localVarFp
        .listScheduleOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.rsvpStatus,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get events that need RSVP responses from the current user
     * @param {CalendarsApiListUnrespondedRsvpsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUnrespondedRsvps(
      requestParameters: CalendarsApiListUnrespondedRsvpsRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedUnrespondedEventList> {
      return localVarFp
        .listUnrespondedRsvps(
          requestParameters.calendarId,
          requestParameters.after,
          requestParameters.before,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get events that need RSVP responses from the current user
     * @param {CalendarsApiListUnrespondedRsvpsOnPrimaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUnrespondedRsvpsOnPrimary(
      requestParameters: CalendarsApiListUnrespondedRsvpsOnPrimaryRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedUnrespondedEventList> {
      return localVarFp
        .listUnrespondedRsvpsOnPrimary(
          requestParameters.after,
          requestParameters.before,
          requestParameters.orderBy,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiPatchCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCalendar(
      requestParameters: CalendarsApiPatchCalendarRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Calendar> {
      return localVarFp
        .patchCalendar(
          requestParameters.calendarId,
          requestParameters.calendarAccount,
          requestParameters.patchedCalendar,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiPatchPrimaryCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPrimaryCalendar(
      requestParameters: CalendarsApiPatchPrimaryCalendarRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<Calendar> {
      return localVarFp
        .patchPrimaryCalendar(
          requestParameters.calendarAccount,
          requestParameters.patchedCalendar,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiSubscribeToCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeToCalendar(
      requestParameters: CalendarsApiSubscribeToCalendarRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<CalendarChannel> {
      return localVarFp
        .subscribeToCalendar(requestParameters.body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiSyncCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncCalendar(
      requestParameters: CalendarsApiSyncCalendarRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .syncCalendar(requestParameters.calendarId, requestParameters.syncRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiSyncPrimaryCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncPrimaryCalendar(
      requestParameters: CalendarsApiSyncPrimaryCalendarRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .syncPrimaryCalendar(requestParameters.syncRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiUpdateCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCalendar(
      requestParameters: CalendarsApiUpdateCalendarRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Calendar> {
      return localVarFp
        .updateCalendar(
          requestParameters.calendarId,
          requestParameters.calendar,
          requestParameters.calendarAccount,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {CalendarsApiUpdatePrimaryCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePrimaryCalendar(
      requestParameters: CalendarsApiUpdatePrimaryCalendarRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Calendar> {
      return localVarFp
        .updatePrimaryCalendar(
          requestParameters.calendar,
          requestParameters.calendarAccount,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for createEvent operation in CalendarsApi.
 * @export
 * @interface CalendarsApiCreateEventRequest
 */
export interface CalendarsApiCreateEventRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiCreateEvent
   */
  readonly calendarId: string

  /**
   *
   * @type {EventParams}
   * @memberof CalendarsApiCreateEvent
   */
  readonly eventParams: EventParams
}

/**
 * Request parameters for createEventOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiCreateEventOnPrimaryRequest
 */
export interface CalendarsApiCreateEventOnPrimaryRequest {
  /**
   *
   * @type {EventParams}
   * @memberof CalendarsApiCreateEventOnPrimary
   */
  readonly eventParams: EventParams
}

/**
 * Request parameters for getCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiGetCalendarRequest
 */
export interface CalendarsApiGetCalendarRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiGetCalendar
   */
  readonly calendarId: string

  /**
   * Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
   * @type {string}
   * @memberof CalendarsApiGetCalendar
   */
  readonly calendarAccount?: string
}

/**
 * Request parameters for getPrimaryCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiGetPrimaryCalendarRequest
 */
export interface CalendarsApiGetPrimaryCalendarRequest {
  /**
   * Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
   * @type {string}
   * @memberof CalendarsApiGetPrimaryCalendar
   */
  readonly calendarAccount?: string
}

/**
 * Request parameters for initializePrimaryCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiInitializePrimaryCalendarRequest
 */
export interface CalendarsApiInitializePrimaryCalendarRequest {
  /**
   *
   * @type {Calendar}
   * @memberof CalendarsApiInitializePrimaryCalendar
   */
  readonly calendar: Calendar
}

/**
 * Request parameters for list1on1s operation in CalendarsApi.
 * @export
 * @interface CalendarsApiList1on1sRequest
 */
export interface CalendarsApiList1on1sRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiList1on1s
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiList1on1s
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiList1on1s
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiList1on1s
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiList1on1s
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiList1on1s
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiList1on1s
   */
  readonly perPage?: number
}

/**
 * Request parameters for list1on1sOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiList1on1sOnPrimaryRequest
 */
export interface CalendarsApiList1on1sOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiList1on1sOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiList1on1sOnPrimary
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiList1on1sOnPrimary
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiList1on1sOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiList1on1sOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiList1on1sOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for listCalendars operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListCalendarsRequest
 */
export interface CalendarsApiListCalendarsRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListCalendars
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListCalendars
   */
  readonly perPage?: number
}

/**
 * Request parameters for listEvents operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListEventsRequest
 */
export interface CalendarsApiListEventsRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiListEvents
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListEvents
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListEvents
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListEvents
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListEvents
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListEvents
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListEvents
   */
  readonly perPage?: number
}

/**
 * Request parameters for listEventsOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListEventsOnPrimaryRequest
 */
export interface CalendarsApiListEventsOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListEventsOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListEventsOnPrimary
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListEventsOnPrimary
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListEventsOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListEventsOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListEventsOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for listExternal operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListExternalRequest
 */
export interface CalendarsApiListExternalRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiListExternal
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListExternal
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListExternal
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListExternal
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListExternal
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListExternal
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListExternal
   */
  readonly perPage?: number
}

/**
 * Request parameters for listExternalOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListExternalOnPrimaryRequest
 */
export interface CalendarsApiListExternalOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListExternalOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListExternalOnPrimary
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListExternalOnPrimary
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListExternalOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListExternalOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListExternalOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for listInternal operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListInternalRequest
 */
export interface CalendarsApiListInternalRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiListInternal
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListInternal
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListInternal
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListInternal
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListInternal
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListInternal
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListInternal
   */
  readonly perPage?: number
}

/**
 * Request parameters for listInternalOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListInternalOnPrimaryRequest
 */
export interface CalendarsApiListInternalOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListInternalOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListInternalOnPrimary
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListInternalOnPrimary
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListInternalOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListInternalOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListInternalOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for listNotable operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListNotableRequest
 */
export interface CalendarsApiListNotableRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiListNotable
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListNotable
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListNotable
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListNotable
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListNotable
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListNotable
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListNotable
   */
  readonly perPage?: number
}

/**
 * Request parameters for listNotableOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListNotableOnPrimaryRequest
 */
export interface CalendarsApiListNotableOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListNotableOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListNotableOnPrimary
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListNotableOnPrimary
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListNotableOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListNotableOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListNotableOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for listRecurring operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListRecurringRequest
 */
export interface CalendarsApiListRecurringRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiListRecurring
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListRecurring
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListRecurring
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListRecurring
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListRecurring
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListRecurring
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListRecurring
   */
  readonly perPage?: number
}

/**
 * Request parameters for listRecurringOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListRecurringOnPrimaryRequest
 */
export interface CalendarsApiListRecurringOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListRecurringOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListRecurringOnPrimary
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListRecurringOnPrimary
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListRecurringOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListRecurringOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListRecurringOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for listSchedule operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListScheduleRequest
 */
export interface CalendarsApiListScheduleRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiListSchedule
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListSchedule
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListSchedule
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListSchedule
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListSchedule
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListSchedule
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListSchedule
   */
  readonly perPage?: number
}

/**
 * Request parameters for listScheduleOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListScheduleOnPrimaryRequest
 */
export interface CalendarsApiListScheduleOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListScheduleOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListScheduleOnPrimary
   */
  readonly before?: string

  /**
   * The current users RSVP status on the events.
   * @type {string}
   * @memberof CalendarsApiListScheduleOnPrimary
   */
  readonly rsvpStatus?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListScheduleOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListScheduleOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListScheduleOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for listUnrespondedRsvps operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListUnrespondedRsvpsRequest
 */
export interface CalendarsApiListUnrespondedRsvpsRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiListUnrespondedRsvps
   */
  readonly calendarId: string

  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListUnrespondedRsvps
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListUnrespondedRsvps
   */
  readonly before?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListUnrespondedRsvps
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListUnrespondedRsvps
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListUnrespondedRsvps
   */
  readonly perPage?: number
}

/**
 * Request parameters for listUnrespondedRsvpsOnPrimary operation in CalendarsApi.
 * @export
 * @interface CalendarsApiListUnrespondedRsvpsOnPrimaryRequest
 */
export interface CalendarsApiListUnrespondedRsvpsOnPrimaryRequest {
  /**
   * The lower bound of the search.
   * @type {string}
   * @memberof CalendarsApiListUnrespondedRsvpsOnPrimary
   */
  readonly after?: string

  /**
   * The upper bound of the search.
   * @type {string}
   * @memberof CalendarsApiListUnrespondedRsvpsOnPrimary
   */
  readonly before?: string

  /**
   * The order to return events. Must be either &#x60;created_at&#x60; or &#x60;updated_at&#x60;.
   * @type {string}
   * @memberof CalendarsApiListUnrespondedRsvpsOnPrimary
   */
  readonly orderBy?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof CalendarsApiListUnrespondedRsvpsOnPrimary
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof CalendarsApiListUnrespondedRsvpsOnPrimary
   */
  readonly perPage?: number
}

/**
 * Request parameters for patchCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiPatchCalendarRequest
 */
export interface CalendarsApiPatchCalendarRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiPatchCalendar
   */
  readonly calendarId: string

  /**
   * Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
   * @type {string}
   * @memberof CalendarsApiPatchCalendar
   */
  readonly calendarAccount?: string

  /**
   *
   * @type {PatchedCalendar}
   * @memberof CalendarsApiPatchCalendar
   */
  readonly patchedCalendar?: PatchedCalendar
}

/**
 * Request parameters for patchPrimaryCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiPatchPrimaryCalendarRequest
 */
export interface CalendarsApiPatchPrimaryCalendarRequest {
  /**
   * Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
   * @type {string}
   * @memberof CalendarsApiPatchPrimaryCalendar
   */
  readonly calendarAccount?: string

  /**
   *
   * @type {PatchedCalendar}
   * @memberof CalendarsApiPatchPrimaryCalendar
   */
  readonly patchedCalendar?: PatchedCalendar
}

/**
 * Request parameters for subscribeToCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiSubscribeToCalendarRequest
 */
export interface CalendarsApiSubscribeToCalendarRequest {
  /**
   *
   * @type {object}
   * @memberof CalendarsApiSubscribeToCalendar
   */
  readonly body?: object
}

/**
 * Request parameters for syncCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiSyncCalendarRequest
 */
export interface CalendarsApiSyncCalendarRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiSyncCalendar
   */
  readonly calendarId: string

  /**
   *
   * @type {SyncRequest}
   * @memberof CalendarsApiSyncCalendar
   */
  readonly syncRequest: SyncRequest
}

/**
 * Request parameters for syncPrimaryCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiSyncPrimaryCalendarRequest
 */
export interface CalendarsApiSyncPrimaryCalendarRequest {
  /**
   *
   * @type {SyncRequest}
   * @memberof CalendarsApiSyncPrimaryCalendar
   */
  readonly syncRequest: SyncRequest
}

/**
 * Request parameters for updateCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiUpdateCalendarRequest
 */
export interface CalendarsApiUpdateCalendarRequest {
  /**
   *
   * @type {string}
   * @memberof CalendarsApiUpdateCalendar
   */
  readonly calendarId: string

  /**
   *
   * @type {Calendar}
   * @memberof CalendarsApiUpdateCalendar
   */
  readonly calendar: Calendar

  /**
   * Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
   * @type {string}
   * @memberof CalendarsApiUpdateCalendar
   */
  readonly calendarAccount?: string
}

/**
 * Request parameters for updatePrimaryCalendar operation in CalendarsApi.
 * @export
 * @interface CalendarsApiUpdatePrimaryCalendarRequest
 */
export interface CalendarsApiUpdatePrimaryCalendarRequest {
  /**
   *
   * @type {Calendar}
   * @memberof CalendarsApiUpdatePrimaryCalendar
   */
  readonly calendar: Calendar

  /**
   * Optional calendar account ID to filter by when the same remote_address exists in multiple accounts.
   * @type {string}
   * @memberof CalendarsApiUpdatePrimaryCalendar
   */
  readonly calendarAccount?: string
}

/**
 * CalendarsApi - object-oriented interface
 * @export
 * @class CalendarsApi
 * @extends {BaseAPI}
 */
export class CalendarsApi extends BaseAPI {
  /**
   * Abstract class that provides the base functionality for listing events.
   * @param {CalendarsApiCreateEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public createEvent(
    requestParameters: CalendarsApiCreateEventRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .createEvent(requestParameters.calendarId, requestParameters.eventParams, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract class that provides the base functionality for listing events.
   * @param {CalendarsApiCreateEventOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public createEventOnPrimary(
    requestParameters: CalendarsApiCreateEventOnPrimaryRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .createEventOnPrimary(requestParameters.eventParams, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiGetCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public getCalendar(
    requestParameters: CalendarsApiGetCalendarRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .getCalendar(requestParameters.calendarId, requestParameters.calendarAccount, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiGetPrimaryCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public getPrimaryCalendar(
    requestParameters: CalendarsApiGetPrimaryCalendarRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .getPrimaryCalendar(requestParameters.calendarAccount, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Initialize or reinitialize the primary calendar. Creates the calendar if it doesn\'t exist, sets up the default calendar group, and subscribes to notifications.
   * @param {CalendarsApiInitializePrimaryCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public initializePrimaryCalendar(
    requestParameters: CalendarsApiInitializePrimaryCalendarRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .initializePrimaryCalendar(requestParameters.calendar, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
   * @param {CalendarsApiList1on1sRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public list1on1s(requestParameters: CalendarsApiList1on1sRequest, options?: AxiosRequestConfig) {
    return CalendarsApiFp(this.configuration)
      .list1on1s(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of one-on-one events for the current user. One-on-one events are events that are recurring, and have a recurrence frequency of less than monthly.
   * @param {CalendarsApiList1on1sOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public list1on1sOnPrimary(
    requestParameters: CalendarsApiList1on1sOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .list1on1sOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiListCalendarsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listCalendars(
    requestParameters: CalendarsApiListCalendarsRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listCalendars(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract class that provides the base functionality for listing events.
   * @param {CalendarsApiListEventsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listEvents(
    requestParameters: CalendarsApiListEventsRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listEvents(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract class that provides the base functionality for listing events.
   * @param {CalendarsApiListEventsOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listEventsOnPrimary(
    requestParameters: CalendarsApiListEventsOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listEventsOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
   * @param {CalendarsApiListExternalRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listExternal(
    requestParameters: CalendarsApiListExternalRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listExternal(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of external meetings for the current user. External meetings contain at least one attendee from a different domain than the current user. This is an expanded view of events, which expands recurring events into individual instances.
   * @param {CalendarsApiListExternalOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listExternalOnPrimary(
    requestParameters: CalendarsApiListExternalOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listExternalOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
   * @param {CalendarsApiListInternalRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listInternal(
    requestParameters: CalendarsApiListInternalRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listInternal(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of internal meetings for the current user. Internal meetings contain only attendees from the same domain as the current user. This is an expanded view of events, which expands recurring events into individual instances.
   * @param {CalendarsApiListInternalOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listInternalOnPrimary(
    requestParameters: CalendarsApiListInternalOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listInternalOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
   * @param {CalendarsApiListNotableRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listNotable(
    requestParameters: CalendarsApiListNotableRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listNotable(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of notable meetings for the current user. Notable meetings are algorithmically determined to be important to the user, using criteria such as: - If it contains meeting guests the user hasn\'t met with in a while - If it\'s external (at least one attendee is from a different domain than the current user) - If it\'s rarely recurring (less than once a month)
   * @param {CalendarsApiListNotableOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listNotableOnPrimary(
    requestParameters: CalendarsApiListNotableOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listNotableOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of recurring events for the current user.
   * @param {CalendarsApiListRecurringRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listRecurring(
    requestParameters: CalendarsApiListRecurringRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listRecurring(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a list of recurring events for the current user.
   * @param {CalendarsApiListRecurringOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listRecurringOnPrimary(
    requestParameters: CalendarsApiListRecurringOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listRecurringOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract class that provides the base functionality for listing events.
   * @param {CalendarsApiListScheduleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listSchedule(
    requestParameters: CalendarsApiListScheduleRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listSchedule(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract class that provides the base functionality for listing events.
   * @param {CalendarsApiListScheduleOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listScheduleOnPrimary(
    requestParameters: CalendarsApiListScheduleOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listScheduleOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.rsvpStatus,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get events that need RSVP responses from the current user
   * @param {CalendarsApiListUnrespondedRsvpsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listUnrespondedRsvps(
    requestParameters: CalendarsApiListUnrespondedRsvpsRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listUnrespondedRsvps(
        requestParameters.calendarId,
        requestParameters.after,
        requestParameters.before,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get events that need RSVP responses from the current user
   * @param {CalendarsApiListUnrespondedRsvpsOnPrimaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public listUnrespondedRsvpsOnPrimary(
    requestParameters: CalendarsApiListUnrespondedRsvpsOnPrimaryRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .listUnrespondedRsvpsOnPrimary(
        requestParameters.after,
        requestParameters.before,
        requestParameters.orderBy,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiPatchCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public patchCalendar(
    requestParameters: CalendarsApiPatchCalendarRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .patchCalendar(
        requestParameters.calendarId,
        requestParameters.calendarAccount,
        requestParameters.patchedCalendar,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiPatchPrimaryCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public patchPrimaryCalendar(
    requestParameters: CalendarsApiPatchPrimaryCalendarRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .patchPrimaryCalendar(
        requestParameters.calendarAccount,
        requestParameters.patchedCalendar,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiSubscribeToCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public subscribeToCalendar(
    requestParameters: CalendarsApiSubscribeToCalendarRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .subscribeToCalendar(requestParameters.body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiSyncCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public syncCalendar(
    requestParameters: CalendarsApiSyncCalendarRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .syncCalendar(requestParameters.calendarId, requestParameters.syncRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiSyncPrimaryCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public syncPrimaryCalendar(
    requestParameters: CalendarsApiSyncPrimaryCalendarRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .syncPrimaryCalendar(requestParameters.syncRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiUpdateCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public updateCalendar(
    requestParameters: CalendarsApiUpdateCalendarRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .updateCalendar(
        requestParameters.calendarId,
        requestParameters.calendar,
        requestParameters.calendarAccount,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CalendarsApiUpdatePrimaryCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarsApi
   */
  public updatePrimaryCalendar(
    requestParameters: CalendarsApiUpdatePrimaryCalendarRequest,
    options?: AxiosRequestConfig
  ) {
    return CalendarsApiFp(this.configuration)
      .updatePrimaryCalendar(requestParameters.calendar, requestParameters.calendarAccount, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} eventId
     * @param {AddLabels} [addLabels]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLabelsToEvent: async (
      eventId: string,
      addLabels?: AddLabels,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('addLabelsToEvent', 'eventId', eventId)
      const localVarPath = `/events/{event_id}/labels/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addLabels,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Remove a specific event
     * @summary Delete an event
     * @param {string} eventId
     * @param {boolean} [notify] Whether to send the provider\&#39;s normal notification to the other people on this event about the delete (the attendees when you are the organizer; the organizer when you are an attendee removing an invite). Pass false to suppress it, so removing a suspicious invite never signals its organizer that the mailbox is live. Defaults to true (the provider\&#39;s normal notification behavior).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEvent: async (
      eventId: string,
      notify?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('deleteEvent', 'eventId', eventId)
      const localVarPath = `/events/{event_id}/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (notify !== undefined) {
        localVarQueryParameter['notify'] = notify
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} eventId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEventLabel: async (
      eventId: string,
      labelId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('deleteEventLabel', 'eventId', eventId)
      // verify required parameter 'labelId' is not null or undefined
      assertParamExists('deleteEventLabel', 'labelId', labelId)
      const localVarPath = `/events/{event_id}/labels/{label_id}/`
        .replace(`{${'event_id'}}`, encodeURIComponent(String(eventId)))
        .replace(`{${'label_id'}}`, encodeURIComponent(String(labelId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Generate a signed URL for uploading audio files to Google Cloud Storage
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsAudioUploadUrlCreate: async (
      eventId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('eventsAudioUploadUrlCreate', 'eventId', eventId)
      const localVarPath = `/events/{event_id}/audio-upload-url/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} eventId
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsLabelsList: async (
      eventId: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('eventsLabelsList', 'eventId', eventId)
      const localVarPath = `/events/{event_id}/labels/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get details of a specific event
     * @summary Retrieve a single event
     * @param {string} eventId
     * @param {string} [eventId2] Event ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvent: async (
      eventId: string,
      eventId2?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('getEvent', 'eventId', eventId)
      const localVarPath = `/events/{event_id}/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (eventId2 !== undefined) {
        localVarQueryParameter['event_id'] = eventId2
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get details of multiple events
     * @summary Get events in bulk
     * @param {EventBatchGetRequest} eventBatchGetRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEventsInBulk: async (
      eventBatchGetRequest: EventBatchGetRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventBatchGetRequest' is not null or undefined
      assertParamExists('getEventsInBulk', 'eventBatchGetRequest', eventBatchGetRequest)
      const localVarPath = `/events/batch-get/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        eventBatchGetRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update specific fields of an event
     * @summary Partially update an event
     * @param {string} eventId
     * @param {PatchedEventParams} [patchedEventParams]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvent: async (
      eventId: string,
      patchedEventParams?: PatchedEventParams,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('patchEvent', 'eventId', eventId)
      const localVarPath = `/events/{event_id}/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedEventParams,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * RSVP to a specific event
     * @summary RSVP to an event
     * @param {string} eventId
     * @param {Rsvp} rsvp
     * @param {string} [eventId2] Event ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rsvpToEvent: async (
      eventId: string,
      rsvp: Rsvp,
      eventId2?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('rsvpToEvent', 'eventId', eventId)
      // verify required parameter 'rsvp' is not null or undefined
      assertParamExists('rsvpToEvent', 'rsvp', rsvp)
      const localVarPath = `/events/{event_id}/rsvp/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (eventId2 !== undefined) {
        localVarQueryParameter['event_id'] = eventId2
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rsvp,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update details of a specific event
     * @summary Update an event
     * @param {string} eventId
     * @param {EventParams} eventParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvent: async (
      eventId: string,
      eventParams: EventParams,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventId' is not null or undefined
      assertParamExists('updateEvent', 'eventId', eventId)
      // verify required parameter 'eventParams' is not null or undefined
      assertParamExists('updateEvent', 'eventParams', eventParams)
      const localVarPath = `/events/{event_id}/`.replace(
        `{${'event_id'}}`,
        encodeURIComponent(String(eventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        eventParams,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} eventId
     * @param {AddLabels} [addLabels]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addLabelsToEvent(
      eventId: string,
      addLabels?: AddLabels,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addLabelsToEvent(
        eventId,
        addLabels,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Remove a specific event
     * @summary Delete an event
     * @param {string} eventId
     * @param {boolean} [notify] Whether to send the provider\&#39;s normal notification to the other people on this event about the delete (the attendees when you are the organizer; the organizer when you are an attendee removing an invite). Pass false to suppress it, so removing a suspicious invite never signals its organizer that the mailbox is live. Defaults to true (the provider\&#39;s normal notification behavior).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteEvent(
      eventId: string,
      notify?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvent(
        eventId,
        notify,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} eventId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteEventLabel(
      eventId: string,
      labelId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventLabel(
        eventId,
        labelId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Generate a signed URL for uploading audio files to Google Cloud Storage
     * @param {string} eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsAudioUploadUrlCreate(
      eventId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignedUrlResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsAudioUploadUrlCreate(
        eventId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} eventId
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsLabelsList(
      eventId: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventLabelList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsLabelsList(
        eventId,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get details of a specific event
     * @summary Retrieve a single event
     * @param {string} eventId
     * @param {string} [eventId2] Event ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvent(
      eventId: string,
      eventId2?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEvent(eventId, eventId2, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get details of multiple events
     * @summary Get events in bulk
     * @param {EventBatchGetRequest} eventBatchGetRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEventsInBulk(
      eventBatchGetRequest: EventBatchGetRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventBatchGetResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsInBulk(
        eventBatchGetRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Update specific fields of an event
     * @summary Partially update an event
     * @param {string} eventId
     * @param {PatchedEventParams} [patchedEventParams]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchEvent(
      eventId: string,
      patchedEventParams?: PatchedEventParams,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchEvent(
        eventId,
        patchedEventParams,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * RSVP to a specific event
     * @summary RSVP to an event
     * @param {string} eventId
     * @param {Rsvp} rsvp
     * @param {string} [eventId2] Event ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rsvpToEvent(
      eventId: string,
      rsvp: Rsvp,
      eventId2?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rsvpToEvent(
        eventId,
        rsvp,
        eventId2,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Update details of a specific event
     * @summary Update an event
     * @param {string} eventId
     * @param {EventParams} eventParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEvent(
      eventId: string,
      eventParams: EventParams,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvent(
        eventId,
        eventParams,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EventsApiFp(configuration)
  return {
    /**
     *
     * @param {EventsApiAddLabelsToEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLabelsToEvent(
      requestParameters: EventsApiAddLabelsToEventRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Event> {
      return localVarFp
        .addLabelsToEvent(requestParameters.eventId, requestParameters.addLabels, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Remove a specific event
     * @summary Delete an event
     * @param {EventsApiDeleteEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEvent(
      requestParameters: EventsApiDeleteEventRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .deleteEvent(requestParameters.eventId, requestParameters.notify, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {EventsApiDeleteEventLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEventLabel(
      requestParameters: EventsApiDeleteEventLabelRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .deleteEventLabel(requestParameters.eventId, requestParameters.labelId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Generate a signed URL for uploading audio files to Google Cloud Storage
     * @param {EventsApiEventsAudioUploadUrlCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsAudioUploadUrlCreate(
      requestParameters: EventsApiEventsAudioUploadUrlCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SignedUrlResponse> {
      return localVarFp
        .eventsAudioUploadUrlCreate(requestParameters.eventId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {EventsApiEventsLabelsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsLabelsList(
      requestParameters: EventsApiEventsLabelsListRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedEventLabelList> {
      return localVarFp
        .eventsLabelsList(
          requestParameters.eventId,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get details of a specific event
     * @summary Retrieve a single event
     * @param {EventsApiGetEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvent(
      requestParameters: EventsApiGetEventRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Event> {
      return localVarFp
        .getEvent(requestParameters.eventId, requestParameters.eventId2, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get details of multiple events
     * @summary Get events in bulk
     * @param {EventsApiGetEventsInBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEventsInBulk(
      requestParameters: EventsApiGetEventsInBulkRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<EventBatchGetResponse> {
      return localVarFp
        .getEventsInBulk(requestParameters.eventBatchGetRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update specific fields of an event
     * @summary Partially update an event
     * @param {EventsApiPatchEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvent(
      requestParameters: EventsApiPatchEventRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Event> {
      return localVarFp
        .patchEvent(requestParameters.eventId, requestParameters.patchedEventParams, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * RSVP to a specific event
     * @summary RSVP to an event
     * @param {EventsApiRsvpToEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rsvpToEvent(
      requestParameters: EventsApiRsvpToEventRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .rsvpToEvent(
          requestParameters.eventId,
          requestParameters.rsvp,
          requestParameters.eventId2,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Update details of a specific event
     * @summary Update an event
     * @param {EventsApiUpdateEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvent(
      requestParameters: EventsApiUpdateEventRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Event> {
      return localVarFp
        .updateEvent(requestParameters.eventId, requestParameters.eventParams, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for addLabelsToEvent operation in EventsApi.
 * @export
 * @interface EventsApiAddLabelsToEventRequest
 */
export interface EventsApiAddLabelsToEventRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiAddLabelsToEvent
   */
  readonly eventId: string

  /**
   *
   * @type {AddLabels}
   * @memberof EventsApiAddLabelsToEvent
   */
  readonly addLabels?: AddLabels
}

/**
 * Request parameters for deleteEvent operation in EventsApi.
 * @export
 * @interface EventsApiDeleteEventRequest
 */
export interface EventsApiDeleteEventRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiDeleteEvent
   */
  readonly eventId: string

  /**
   * Whether to send the provider\&#39;s normal notification to the other people on this event about the delete (the attendees when you are the organizer; the organizer when you are an attendee removing an invite). Pass false to suppress it, so removing a suspicious invite never signals its organizer that the mailbox is live. Defaults to true (the provider\&#39;s normal notification behavior).
   * @type {boolean}
   * @memberof EventsApiDeleteEvent
   */
  readonly notify?: boolean
}

/**
 * Request parameters for deleteEventLabel operation in EventsApi.
 * @export
 * @interface EventsApiDeleteEventLabelRequest
 */
export interface EventsApiDeleteEventLabelRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiDeleteEventLabel
   */
  readonly eventId: string

  /**
   *
   * @type {string}
   * @memberof EventsApiDeleteEventLabel
   */
  readonly labelId: string
}

/**
 * Request parameters for eventsAudioUploadUrlCreate operation in EventsApi.
 * @export
 * @interface EventsApiEventsAudioUploadUrlCreateRequest
 */
export interface EventsApiEventsAudioUploadUrlCreateRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiEventsAudioUploadUrlCreate
   */
  readonly eventId: string
}

/**
 * Request parameters for eventsLabelsList operation in EventsApi.
 * @export
 * @interface EventsApiEventsLabelsListRequest
 */
export interface EventsApiEventsLabelsListRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiEventsLabelsList
   */
  readonly eventId: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof EventsApiEventsLabelsList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof EventsApiEventsLabelsList
   */
  readonly perPage?: number
}

/**
 * Request parameters for getEvent operation in EventsApi.
 * @export
 * @interface EventsApiGetEventRequest
 */
export interface EventsApiGetEventRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiGetEvent
   */
  readonly eventId: string

  /**
   * Event ID
   * @type {string}
   * @memberof EventsApiGetEvent
   */
  readonly eventId2?: string
}

/**
 * Request parameters for getEventsInBulk operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsInBulkRequest
 */
export interface EventsApiGetEventsInBulkRequest {
  /**
   *
   * @type {EventBatchGetRequest}
   * @memberof EventsApiGetEventsInBulk
   */
  readonly eventBatchGetRequest: EventBatchGetRequest
}

/**
 * Request parameters for patchEvent operation in EventsApi.
 * @export
 * @interface EventsApiPatchEventRequest
 */
export interface EventsApiPatchEventRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiPatchEvent
   */
  readonly eventId: string

  /**
   *
   * @type {PatchedEventParams}
   * @memberof EventsApiPatchEvent
   */
  readonly patchedEventParams?: PatchedEventParams
}

/**
 * Request parameters for rsvpToEvent operation in EventsApi.
 * @export
 * @interface EventsApiRsvpToEventRequest
 */
export interface EventsApiRsvpToEventRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiRsvpToEvent
   */
  readonly eventId: string

  /**
   *
   * @type {Rsvp}
   * @memberof EventsApiRsvpToEvent
   */
  readonly rsvp: Rsvp

  /**
   * Event ID
   * @type {string}
   * @memberof EventsApiRsvpToEvent
   */
  readonly eventId2?: string
}

/**
 * Request parameters for updateEvent operation in EventsApi.
 * @export
 * @interface EventsApiUpdateEventRequest
 */
export interface EventsApiUpdateEventRequest {
  /**
   *
   * @type {string}
   * @memberof EventsApiUpdateEvent
   */
  readonly eventId: string

  /**
   *
   * @type {EventParams}
   * @memberof EventsApiUpdateEvent
   */
  readonly eventParams: EventParams
}

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
  /**
   *
   * @param {EventsApiAddLabelsToEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public addLabelsToEvent(
    requestParameters: EventsApiAddLabelsToEventRequest,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .addLabelsToEvent(requestParameters.eventId, requestParameters.addLabels, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Remove a specific event
   * @summary Delete an event
   * @param {EventsApiDeleteEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public deleteEvent(requestParameters: EventsApiDeleteEventRequest, options?: AxiosRequestConfig) {
    return EventsApiFp(this.configuration)
      .deleteEvent(requestParameters.eventId, requestParameters.notify, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {EventsApiDeleteEventLabelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public deleteEventLabel(
    requestParameters: EventsApiDeleteEventLabelRequest,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .deleteEventLabel(requestParameters.eventId, requestParameters.labelId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Generate a signed URL for uploading audio files to Google Cloud Storage
   * @param {EventsApiEventsAudioUploadUrlCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsAudioUploadUrlCreate(
    requestParameters: EventsApiEventsAudioUploadUrlCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .eventsAudioUploadUrlCreate(requestParameters.eventId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {EventsApiEventsLabelsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsLabelsList(
    requestParameters: EventsApiEventsLabelsListRequest,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .eventsLabelsList(
        requestParameters.eventId,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get details of a specific event
   * @summary Retrieve a single event
   * @param {EventsApiGetEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public getEvent(requestParameters: EventsApiGetEventRequest, options?: AxiosRequestConfig) {
    return EventsApiFp(this.configuration)
      .getEvent(requestParameters.eventId, requestParameters.eventId2, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get details of multiple events
   * @summary Get events in bulk
   * @param {EventsApiGetEventsInBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public getEventsInBulk(
    requestParameters: EventsApiGetEventsInBulkRequest,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .getEventsInBulk(requestParameters.eventBatchGetRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update specific fields of an event
   * @summary Partially update an event
   * @param {EventsApiPatchEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public patchEvent(requestParameters: EventsApiPatchEventRequest, options?: AxiosRequestConfig) {
    return EventsApiFp(this.configuration)
      .patchEvent(requestParameters.eventId, requestParameters.patchedEventParams, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * RSVP to a specific event
   * @summary RSVP to an event
   * @param {EventsApiRsvpToEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public rsvpToEvent(requestParameters: EventsApiRsvpToEventRequest, options?: AxiosRequestConfig) {
    return EventsApiFp(this.configuration)
      .rsvpToEvent(
        requestParameters.eventId,
        requestParameters.rsvp,
        requestParameters.eventId2,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update details of a specific event
   * @summary Update an event
   * @param {EventsApiUpdateEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public updateEvent(requestParameters: EventsApiUpdateEventRequest, options?: AxiosRequestConfig) {
    return EventsApiFp(this.configuration)
      .updateEvent(requestParameters.eventId, requestParameters.eventParams, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FoldersApi - axios parameter creator
 * @export
 */
export const FoldersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {FolderCreate} folderCreate
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersCreate: async (
      folderCreate: FolderCreate,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'folderCreate' is not null or undefined
      assertParamExists('foldersCreate', 'folderCreate', folderCreate)
      const localVarPath = `/folders/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        folderCreate,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Soft delete folder. Default contents_action=delete soft-deletes folder and all contents; contents_action=unassign moves notes to unfiled.
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {string} [contentsAction] What to do with folder contents: \&#39;delete\&#39; (default) soft-deletes the folder and all its contents (notes and subfolders). \&#39;unassign\&#39; soft-deletes the folder and moves all notes to unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersDestroy: async (
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      contentsAction?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersDestroy', 'id', id)
      const localVarPath = `/folders/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      if (contentsAction !== undefined) {
        localVarQueryParameter['contents_action'] = contentsAction
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersList: async (
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/folders/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List notes in this folder (paginated).
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersNotesList: async (
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersNotesList', 'id', id)
      const localVarPath = `/folders/{id}/notes/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {PatchedFolder} [patchedFolder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersPartialUpdate: async (
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      patchedFolder?: PatchedFolder,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersPartialUpdate', 'id', id)
      const localVarPath = `/folders/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedFolder,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Repair a space folder whose space note is missing. Idempotent: no-op when the space note is already present; otherwise restores a soft-deleted space note (recovering its content) or creates a fresh one. Lets a stranded space self-heal instead of showing \'still syncing\' forever.
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersRepairCreate: async (
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersRepairCreate', 'id', id)
      const localVarPath = `/folders/{id}/repair/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Restore a soft-deleted folder.
     * @param {string} id
     * @param {Folder} folder
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersRestoreCreate: async (
      id: string,
      folder: Folder,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersRestoreCreate', 'id', id)
      // verify required parameter 'folder' is not null or undefined
      assertParamExists('foldersRestoreCreate', 'folder', folder)
      const localVarPath = `/folders/{id}/restore/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        folder,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersRetrieve: async (
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersRetrieve', 'id', id)
      const localVarPath = `/folders/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Scaffold the PARA folder structure: four root folders (Projects, Areas, Resources, Archives). Idempotent: only creates folders that do not already exist at root with these names. Creates a readme note in each folder and a top-level overview note with note mentions to each readme. Sets folder.purpose on create (user-editable). Returns folders, folder_ids, readme_note_ids, and top_level_readme_note_id.
     * @param {Folder} folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersScaffoldParaCreate: async (
      folder: Folder,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'folder' is not null or undefined
      assertParamExists('foldersScaffoldParaCreate', 'folder', folder)
      const localVarPath = `/folders/scaffold/para/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        folder,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Scaffold WLCS (Work, Life, Resources): three root folders, Start Here and How WLCS works unfiled at top, local templates inside Work/Life folders, default meeting folder Work/Meetings. Idempotent.
     * @param {Folder} folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersScaffoldWlcsCreate: async (
      folder: Folder,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'folder' is not null or undefined
      assertParamExists('foldersScaffoldWlcsCreate', 'folder', folder)
      const localVarPath = `/folders/scaffold/wlcs/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        folder,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Link a calendar event to this space. Max 8 per space.
     * @param {string} folderId
     * @param {SpaceEventCreate} spaceEventCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceEventsCreate: async (
      folderId: string,
      spaceEventCreate: SpaceEventCreate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'folderId' is not null or undefined
      assertParamExists('foldersSpaceEventsCreate', 'folderId', folderId)
      // verify required parameter 'spaceEventCreate' is not null or undefined
      assertParamExists('foldersSpaceEventsCreate', 'spaceEventCreate', spaceEventCreate)
      const localVarPath = `/folders/{folder_id}/space-events/`.replace(
        `{${'folder_id'}}`,
        encodeURIComponent(String(folderId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        spaceEventCreate,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Unlink a calendar event from this space.
     * @param {string} folderId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceEventsDestroy: async (
      folderId: string,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'folderId' is not null or undefined
      assertParamExists('foldersSpaceEventsDestroy', 'folderId', folderId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersSpaceEventsDestroy', 'id', id)
      const localVarPath = `/folders/{folder_id}/space-events/{id}/`
        .replace(`{${'folder_id'}}`, encodeURIComponent(String(folderId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List calendar events linked to this space, with next_occurrence computed from future EventInstances.
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceEventsList: async (
      folderId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'folderId' is not null or undefined
      assertParamExists('foldersSpaceEventsList', 'folderId', folderId)
      const localVarPath = `/folders/{folder_id}/space-events/`.replace(
        `{${'folder_id'}}`,
        encodeURIComponent(String(folderId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceStateRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/folders/space-state/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List deduplicated incomplete tasks for a folder tree.
     * @param {string} folderId
     * @param {number} [limit] Max number of tasks to return (default 10, max 50).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersTasksList: async (
      folderId: string,
      limit?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'folderId' is not null or undefined
      assertParamExists('foldersTasksList', 'folderId', folderId)
      const localVarPath = `/folders/{folder_id}/tasks/`.replace(
        `{${'folder_id'}}`,
        encodeURIComponent(String(folderId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List soft-deleted folders (trash). GET /folders/trash/ only lists.  Trash is intentionally NOT routed through ``apply_space_limit`` — soft- deleted spaces should still surface as spaces so the user can restore them with the same identity they had before deletion.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersTrashList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/folders/trash/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {Folder} folder
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersUpdate: async (
      id: string,
      folder: Folder,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('foldersUpdate', 'id', id)
      // verify required parameter 'folder' is not null or undefined
      assertParamExists('foldersUpdate', 'folder', folder)
      const localVarPath = `/folders/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (flat !== undefined) {
        localVarQueryParameter['flat'] = flat
      }

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeNotes !== undefined) {
        localVarQueryParameter['include_notes'] = includeNotes
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        folder,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersWorkspaceStateRetrieve: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/folders/workspace-state/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FoldersApi - functional programming interface
 * @export
 */
export const FoldersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FoldersApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {FolderCreate} folderCreate
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersCreate(
      folderCreate: FolderCreate,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersCreate(
        folderCreate,
        flat,
        includeTrash,
        includeNotes,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Soft delete folder. Default contents_action=delete soft-deletes folder and all contents; contents_action=unassign moves notes to unfiled.
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {string} [contentsAction] What to do with folder contents: \&#39;delete\&#39; (default) soft-deletes the folder and all its contents (notes and subfolders). \&#39;unassign\&#39; soft-deletes the folder and moves all notes to unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersDestroy(
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      contentsAction?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersDestroy(
        id,
        flat,
        includeTrash,
        includeNotes,
        contentsAction,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersList(
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFolderList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersList(
        flat,
        includeTrash,
        includeNotes,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List notes in this folder (paginated).
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersNotesList(
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNoteItemList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersNotesList(
        id,
        flat,
        includeTrash,
        includeNotes,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {PatchedFolder} [patchedFolder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersPartialUpdate(
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      patchedFolder?: PatchedFolder,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersPartialUpdate(
        id,
        flat,
        includeTrash,
        includeNotes,
        patchedFolder,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Repair a space folder whose space note is missing. Idempotent: no-op when the space note is already present; otherwise restores a soft-deleted space note (recovering its content) or creates a fresh one. Lets a stranded space self-heal instead of showing \'still syncing\' forever.
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersRepairCreate(
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersRepairCreate(
        id,
        flat,
        includeTrash,
        includeNotes,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Restore a soft-deleted folder.
     * @param {string} id
     * @param {Folder} folder
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersRestoreCreate(
      id: string,
      folder: Folder,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersRestoreCreate(
        id,
        folder,
        flat,
        includeTrash,
        includeNotes,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersRetrieve(
      id: string,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersRetrieve(
        id,
        flat,
        includeTrash,
        includeNotes,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Scaffold the PARA folder structure: four root folders (Projects, Areas, Resources, Archives). Idempotent: only creates folders that do not already exist at root with these names. Creates a readme note in each folder and a top-level overview note with note mentions to each readme. Sets folder.purpose on create (user-editable). Returns folders, folder_ids, readme_note_ids, and top_level_readme_note_id.
     * @param {Folder} folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersScaffoldParaCreate(
      folder: Folder,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FoldersScaffoldParaCreate201Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersScaffoldParaCreate(
        folder,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Scaffold WLCS (Work, Life, Resources): three root folders, Start Here and How WLCS works unfiled at top, local templates inside Work/Life folders, default meeting folder Work/Meetings. Idempotent.
     * @param {Folder} folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersScaffoldWlcsCreate(
      folder: Folder,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FoldersScaffoldParaCreate201Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersScaffoldWlcsCreate(
        folder,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Link a calendar event to this space. Max 8 per space.
     * @param {string} folderId
     * @param {SpaceEventCreate} spaceEventCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersSpaceEventsCreate(
      folderId: string,
      spaceEventCreate: SpaceEventCreate,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpaceEvent>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersSpaceEventsCreate(
        folderId,
        spaceEventCreate,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Unlink a calendar event from this space.
     * @param {string} folderId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersSpaceEventsDestroy(
      folderId: string,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersSpaceEventsDestroy(
        folderId,
        id,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List calendar events linked to this space, with next_occurrence computed from future EventInstances.
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersSpaceEventsList(
      folderId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpaceEvent>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersSpaceEventsList(
        folderId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersSpaceStateRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceState>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersSpaceStateRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List deduplicated incomplete tasks for a folder tree.
     * @param {string} folderId
     * @param {number} [limit] Max number of tasks to return (default 10, max 50).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersTasksList(
      folderId: string,
      limit?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Task>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersTasksList(
        folderId,
        limit,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List soft-deleted folders (trash). GET /folders/trash/ only lists.  Trash is intentionally NOT routed through ``apply_space_limit`` — soft- deleted spaces should still surface as spaces so the user can restore them with the same identity they had before deletion.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersTrashList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFolderList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersTrashList(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {Folder} folder
     * @param {boolean} [flat] If true, return flat list with parent_id instead of nested tree.
     * @param {boolean} [includeTrash] If true, include soft-deleted folders (e.g. for trash list).
     * @param {boolean} [includeNotes] If true (nested tree only), include notes in each folder node for full-structure load/sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersUpdate(
      id: string,
      folder: Folder,
      flat?: boolean,
      includeTrash?: boolean,
      includeNotes?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersUpdate(
        id,
        folder,
        flat,
        includeTrash,
        includeNotes,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersWorkspaceStateRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceState>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.foldersWorkspaceStateRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * FoldersApi - factory interface
 * @export
 */
export const FoldersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FoldersApiFp(configuration)
  return {
    /**
     *
     * @param {FoldersApiFoldersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersCreate(
      requestParameters: FoldersApiFoldersCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersCreate(
          requestParameters.folderCreate,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Soft delete folder. Default contents_action=delete soft-deletes folder and all contents; contents_action=unassign moves notes to unfiled.
     * @param {FoldersApiFoldersDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersDestroy(
      requestParameters: FoldersApiFoldersDestroyRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .foldersDestroy(
          requestParameters.id,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          requestParameters.contentsAction,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {FoldersApiFoldersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersList(
      requestParameters: FoldersApiFoldersListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedFolderList> {
      return localVarFp
        .foldersList(
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List notes in this folder (paginated).
     * @param {FoldersApiFoldersNotesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersNotesList(
      requestParameters: FoldersApiFoldersNotesListRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNoteItemList> {
      return localVarFp
        .foldersNotesList(
          requestParameters.id,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {FoldersApiFoldersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersPartialUpdate(
      requestParameters: FoldersApiFoldersPartialUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersPartialUpdate(
          requestParameters.id,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          requestParameters.patchedFolder,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Repair a space folder whose space note is missing. Idempotent: no-op when the space note is already present; otherwise restores a soft-deleted space note (recovering its content) or creates a fresh one. Lets a stranded space self-heal instead of showing \'still syncing\' forever.
     * @param {FoldersApiFoldersRepairCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersRepairCreate(
      requestParameters: FoldersApiFoldersRepairCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersRepairCreate(
          requestParameters.id,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Restore a soft-deleted folder.
     * @param {FoldersApiFoldersRestoreCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersRestoreCreate(
      requestParameters: FoldersApiFoldersRestoreCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersRestoreCreate(
          requestParameters.id,
          requestParameters.folder,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {FoldersApiFoldersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersRetrieve(
      requestParameters: FoldersApiFoldersRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersRetrieve(
          requestParameters.id,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Scaffold the PARA folder structure: four root folders (Projects, Areas, Resources, Archives). Idempotent: only creates folders that do not already exist at root with these names. Creates a readme note in each folder and a top-level overview note with note mentions to each readme. Sets folder.purpose on create (user-editable). Returns folders, folder_ids, readme_note_ids, and top_level_readme_note_id.
     * @param {FoldersApiFoldersScaffoldParaCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersScaffoldParaCreate(
      requestParameters: FoldersApiFoldersScaffoldParaCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FoldersScaffoldParaCreate201Response> {
      return localVarFp
        .foldersScaffoldParaCreate(requestParameters.folder, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Scaffold WLCS (Work, Life, Resources): three root folders, Start Here and How WLCS works unfiled at top, local templates inside Work/Life folders, default meeting folder Work/Meetings. Idempotent.
     * @param {FoldersApiFoldersScaffoldWlcsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersScaffoldWlcsCreate(
      requestParameters: FoldersApiFoldersScaffoldWlcsCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FoldersScaffoldParaCreate201Response> {
      return localVarFp
        .foldersScaffoldWlcsCreate(requestParameters.folder, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Link a calendar event to this space. Max 8 per space.
     * @param {FoldersApiFoldersSpaceEventsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceEventsCreate(
      requestParameters: FoldersApiFoldersSpaceEventsCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<SpaceEvent> {
      return localVarFp
        .foldersSpaceEventsCreate(
          requestParameters.folderId,
          requestParameters.spaceEventCreate,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Unlink a calendar event from this space.
     * @param {FoldersApiFoldersSpaceEventsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceEventsDestroy(
      requestParameters: FoldersApiFoldersSpaceEventsDestroyRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .foldersSpaceEventsDestroy(requestParameters.folderId, requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List calendar events linked to this space, with next_occurrence computed from future EventInstances.
     * @param {FoldersApiFoldersSpaceEventsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceEventsList(
      requestParameters: FoldersApiFoldersSpaceEventsListRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<SpaceEvent>> {
      return localVarFp
        .foldersSpaceEventsList(requestParameters.folderId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersSpaceStateRetrieve(options?: AxiosRequestConfig): AxiosPromise<WorkspaceState> {
      return localVarFp
        .foldersSpaceStateRetrieve(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List deduplicated incomplete tasks for a folder tree.
     * @param {FoldersApiFoldersTasksListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersTasksList(
      requestParameters: FoldersApiFoldersTasksListRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<Task>> {
      return localVarFp
        .foldersTasksList(requestParameters.folderId, requestParameters.limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List soft-deleted folders (trash). GET /folders/trash/ only lists.  Trash is intentionally NOT routed through ``apply_space_limit`` — soft- deleted spaces should still surface as spaces so the user can restore them with the same identity they had before deletion.
     * @param {FoldersApiFoldersTrashListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersTrashList(
      requestParameters: FoldersApiFoldersTrashListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedFolderList> {
      return localVarFp
        .foldersTrashList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {FoldersApiFoldersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersUpdate(
      requestParameters: FoldersApiFoldersUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersUpdate(
          requestParameters.id,
          requestParameters.folder,
          requestParameters.flat,
          requestParameters.includeTrash,
          requestParameters.includeNotes,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersWorkspaceStateRetrieve(options?: AxiosRequestConfig): AxiosPromise<WorkspaceState> {
      return localVarFp
        .foldersWorkspaceStateRetrieve(options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for foldersCreate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersCreateRequest
 */
export interface FoldersApiFoldersCreateRequest {
  /**
   *
   * @type {FolderCreate}
   * @memberof FoldersApiFoldersCreate
   */
  readonly folderCreate: FolderCreate

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersCreate
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersCreate
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersCreate
   */
  readonly includeNotes?: boolean
}

/**
 * Request parameters for foldersDestroy operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersDestroyRequest
 */
export interface FoldersApiFoldersDestroyRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersDestroy
   */
  readonly id: string

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersDestroy
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersDestroy
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersDestroy
   */
  readonly includeNotes?: boolean

  /**
   * What to do with folder contents: \&#39;delete\&#39; (default) soft-deletes the folder and all its contents (notes and subfolders). \&#39;unassign\&#39; soft-deletes the folder and moves all notes to unfiled.
   * @type {string}
   * @memberof FoldersApiFoldersDestroy
   */
  readonly contentsAction?: string
}

/**
 * Request parameters for foldersList operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersListRequest
 */
export interface FoldersApiFoldersListRequest {
  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersList
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersList
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersList
   */
  readonly includeNotes?: boolean

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof FoldersApiFoldersList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof FoldersApiFoldersList
   */
  readonly perPage?: number
}

/**
 * Request parameters for foldersNotesList operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersNotesListRequest
 */
export interface FoldersApiFoldersNotesListRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersNotesList
   */
  readonly id: string

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersNotesList
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersNotesList
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersNotesList
   */
  readonly includeNotes?: boolean

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof FoldersApiFoldersNotesList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof FoldersApiFoldersNotesList
   */
  readonly perPage?: number
}

/**
 * Request parameters for foldersPartialUpdate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersPartialUpdateRequest
 */
export interface FoldersApiFoldersPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersPartialUpdate
   */
  readonly id: string

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersPartialUpdate
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersPartialUpdate
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersPartialUpdate
   */
  readonly includeNotes?: boolean

  /**
   *
   * @type {PatchedFolder}
   * @memberof FoldersApiFoldersPartialUpdate
   */
  readonly patchedFolder?: PatchedFolder
}

/**
 * Request parameters for foldersRepairCreate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersRepairCreateRequest
 */
export interface FoldersApiFoldersRepairCreateRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersRepairCreate
   */
  readonly id: string

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersRepairCreate
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersRepairCreate
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersRepairCreate
   */
  readonly includeNotes?: boolean
}

/**
 * Request parameters for foldersRestoreCreate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersRestoreCreateRequest
 */
export interface FoldersApiFoldersRestoreCreateRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersRestoreCreate
   */
  readonly id: string

  /**
   *
   * @type {Folder}
   * @memberof FoldersApiFoldersRestoreCreate
   */
  readonly folder: Folder

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersRestoreCreate
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersRestoreCreate
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersRestoreCreate
   */
  readonly includeNotes?: boolean
}

/**
 * Request parameters for foldersRetrieve operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersRetrieveRequest
 */
export interface FoldersApiFoldersRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersRetrieve
   */
  readonly id: string

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersRetrieve
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersRetrieve
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersRetrieve
   */
  readonly includeNotes?: boolean
}

/**
 * Request parameters for foldersScaffoldParaCreate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersScaffoldParaCreateRequest
 */
export interface FoldersApiFoldersScaffoldParaCreateRequest {
  /**
   *
   * @type {Folder}
   * @memberof FoldersApiFoldersScaffoldParaCreate
   */
  readonly folder: Folder
}

/**
 * Request parameters for foldersScaffoldWlcsCreate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersScaffoldWlcsCreateRequest
 */
export interface FoldersApiFoldersScaffoldWlcsCreateRequest {
  /**
   *
   * @type {Folder}
   * @memberof FoldersApiFoldersScaffoldWlcsCreate
   */
  readonly folder: Folder
}

/**
 * Request parameters for foldersSpaceEventsCreate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersSpaceEventsCreateRequest
 */
export interface FoldersApiFoldersSpaceEventsCreateRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersSpaceEventsCreate
   */
  readonly folderId: string

  /**
   *
   * @type {SpaceEventCreate}
   * @memberof FoldersApiFoldersSpaceEventsCreate
   */
  readonly spaceEventCreate: SpaceEventCreate
}

/**
 * Request parameters for foldersSpaceEventsDestroy operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersSpaceEventsDestroyRequest
 */
export interface FoldersApiFoldersSpaceEventsDestroyRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersSpaceEventsDestroy
   */
  readonly folderId: string

  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersSpaceEventsDestroy
   */
  readonly id: string
}

/**
 * Request parameters for foldersSpaceEventsList operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersSpaceEventsListRequest
 */
export interface FoldersApiFoldersSpaceEventsListRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersSpaceEventsList
   */
  readonly folderId: string
}

/**
 * Request parameters for foldersTasksList operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersTasksListRequest
 */
export interface FoldersApiFoldersTasksListRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersTasksList
   */
  readonly folderId: string

  /**
   * Max number of tasks to return (default 10, max 50).
   * @type {number}
   * @memberof FoldersApiFoldersTasksList
   */
  readonly limit?: number
}

/**
 * Request parameters for foldersTrashList operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersTrashListRequest
 */
export interface FoldersApiFoldersTrashListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof FoldersApiFoldersTrashList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof FoldersApiFoldersTrashList
   */
  readonly perPage?: number
}

/**
 * Request parameters for foldersUpdate operation in FoldersApi.
 * @export
 * @interface FoldersApiFoldersUpdateRequest
 */
export interface FoldersApiFoldersUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof FoldersApiFoldersUpdate
   */
  readonly id: string

  /**
   *
   * @type {Folder}
   * @memberof FoldersApiFoldersUpdate
   */
  readonly folder: Folder

  /**
   * If true, return flat list with parent_id instead of nested tree.
   * @type {boolean}
   * @memberof FoldersApiFoldersUpdate
   */
  readonly flat?: boolean

  /**
   * If true, include soft-deleted folders (e.g. for trash list).
   * @type {boolean}
   * @memberof FoldersApiFoldersUpdate
   */
  readonly includeTrash?: boolean

  /**
   * If true (nested tree only), include notes in each folder node for full-structure load/sync.
   * @type {boolean}
   * @memberof FoldersApiFoldersUpdate
   */
  readonly includeNotes?: boolean
}

/**
 * FoldersApi - object-oriented interface
 * @export
 * @class FoldersApi
 * @extends {BaseAPI}
 */
export class FoldersApi extends BaseAPI {
  /**
   *
   * @param {FoldersApiFoldersCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersCreate(
    requestParameters: FoldersApiFoldersCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersCreate(
        requestParameters.folderCreate,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Soft delete folder. Default contents_action=delete soft-deletes folder and all contents; contents_action=unassign moves notes to unfiled.
   * @param {FoldersApiFoldersDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersDestroy(
    requestParameters: FoldersApiFoldersDestroyRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersDestroy(
        requestParameters.id,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        requestParameters.contentsAction,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {FoldersApiFoldersListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersList(
    requestParameters: FoldersApiFoldersListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersList(
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List notes in this folder (paginated).
   * @param {FoldersApiFoldersNotesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersNotesList(
    requestParameters: FoldersApiFoldersNotesListRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersNotesList(
        requestParameters.id,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {FoldersApiFoldersPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersPartialUpdate(
    requestParameters: FoldersApiFoldersPartialUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersPartialUpdate(
        requestParameters.id,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        requestParameters.patchedFolder,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Repair a space folder whose space note is missing. Idempotent: no-op when the space note is already present; otherwise restores a soft-deleted space note (recovering its content) or creates a fresh one. Lets a stranded space self-heal instead of showing \'still syncing\' forever.
   * @param {FoldersApiFoldersRepairCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersRepairCreate(
    requestParameters: FoldersApiFoldersRepairCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersRepairCreate(
        requestParameters.id,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Restore a soft-deleted folder.
   * @param {FoldersApiFoldersRestoreCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersRestoreCreate(
    requestParameters: FoldersApiFoldersRestoreCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersRestoreCreate(
        requestParameters.id,
        requestParameters.folder,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {FoldersApiFoldersRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersRetrieve(
    requestParameters: FoldersApiFoldersRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersRetrieve(
        requestParameters.id,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Scaffold the PARA folder structure: four root folders (Projects, Areas, Resources, Archives). Idempotent: only creates folders that do not already exist at root with these names. Creates a readme note in each folder and a top-level overview note with note mentions to each readme. Sets folder.purpose on create (user-editable). Returns folders, folder_ids, readme_note_ids, and top_level_readme_note_id.
   * @param {FoldersApiFoldersScaffoldParaCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersScaffoldParaCreate(
    requestParameters: FoldersApiFoldersScaffoldParaCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersScaffoldParaCreate(requestParameters.folder, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Scaffold WLCS (Work, Life, Resources): three root folders, Start Here and How WLCS works unfiled at top, local templates inside Work/Life folders, default meeting folder Work/Meetings. Idempotent.
   * @param {FoldersApiFoldersScaffoldWlcsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersScaffoldWlcsCreate(
    requestParameters: FoldersApiFoldersScaffoldWlcsCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersScaffoldWlcsCreate(requestParameters.folder, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Link a calendar event to this space. Max 8 per space.
   * @param {FoldersApiFoldersSpaceEventsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersSpaceEventsCreate(
    requestParameters: FoldersApiFoldersSpaceEventsCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersSpaceEventsCreate(
        requestParameters.folderId,
        requestParameters.spaceEventCreate,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Unlink a calendar event from this space.
   * @param {FoldersApiFoldersSpaceEventsDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersSpaceEventsDestroy(
    requestParameters: FoldersApiFoldersSpaceEventsDestroyRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersSpaceEventsDestroy(requestParameters.folderId, requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List calendar events linked to this space, with next_occurrence computed from future EventInstances.
   * @param {FoldersApiFoldersSpaceEventsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersSpaceEventsList(
    requestParameters: FoldersApiFoldersSpaceEventsListRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersSpaceEventsList(requestParameters.folderId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersSpaceStateRetrieve(options?: AxiosRequestConfig) {
    return FoldersApiFp(this.configuration)
      .foldersSpaceStateRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List deduplicated incomplete tasks for a folder tree.
   * @param {FoldersApiFoldersTasksListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersTasksList(
    requestParameters: FoldersApiFoldersTasksListRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersTasksList(requestParameters.folderId, requestParameters.limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List soft-deleted folders (trash). GET /folders/trash/ only lists.  Trash is intentionally NOT routed through ``apply_space_limit`` — soft- deleted spaces should still surface as spaces so the user can restore them with the same identity they had before deletion.
   * @param {FoldersApiFoldersTrashListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersTrashList(
    requestParameters: FoldersApiFoldersTrashListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersTrashList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {FoldersApiFoldersUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersUpdate(
    requestParameters: FoldersApiFoldersUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return FoldersApiFp(this.configuration)
      .foldersUpdate(
        requestParameters.id,
        requestParameters.folder,
        requestParameters.flat,
        requestParameters.includeTrash,
        requestParameters.includeNotes,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FoldersApi
   */
  public foldersWorkspaceStateRetrieve(options?: AxiosRequestConfig) {
    return FoldersApiFp(this.configuration)
      .foldersWorkspaceStateRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * LabelsApi - axios parameter creator
 * @export
 */
export const LabelsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    labelsList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/labels/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * LabelsApi - functional programming interface
 * @export
 */
export const LabelsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LabelsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async labelsList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLabelList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.labelsList(page, perPage, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * LabelsApi - factory interface
 * @export
 */
export const LabelsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = LabelsApiFp(configuration)
  return {
    /**
     *
     * @param {LabelsApiLabelsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    labelsList(
      requestParameters: LabelsApiLabelsListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedLabelList> {
      return localVarFp
        .labelsList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for labelsList operation in LabelsApi.
 * @export
 * @interface LabelsApiLabelsListRequest
 */
export interface LabelsApiLabelsListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof LabelsApiLabelsList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof LabelsApiLabelsList
   */
  readonly perPage?: number
}

/**
 * LabelsApi - object-oriented interface
 * @export
 * @class LabelsApi
 * @extends {BaseAPI}
 */
export class LabelsApi extends BaseAPI {
  /**
   *
   * @param {LabelsApiLabelsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelsApi
   */
  public labelsList(
    requestParameters: LabelsApiLabelsListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return LabelsApiFp(this.configuration)
      .labelsList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Disconnect a connected account
     * @param {DisconnectRequest} disconnectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectCalendarAccount: async (
      disconnectRequest: DisconnectRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'disconnectRequest' is not null or undefined
      assertParamExists('disconnectCalendarAccount', 'disconnectRequest', disconnectRequest)
      const localVarPath = `/me/calendar-accounts/disconnect/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        disconnectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get access token for a specific connected account
     * @param {string} calendarAccountId
     * @param {string} [forceRefresh] Set to \&#39;true\&#39; to force a token refresh from the provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCalendarAccountToken: async (
      calendarAccountId: string,
      forceRefresh?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'calendarAccountId' is not null or undefined
      assertParamExists('getCalendarAccountToken', 'calendarAccountId', calendarAccountId)
      const localVarPath = `/me/calendar-accounts/{calendar_account_id}/token/`.replace(
        `{${'calendar_account_id'}}`,
        encodeURIComponent(String(calendarAccountId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (forceRefresh !== undefined) {
        localVarQueryParameter['force_refresh'] = forceRefresh
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List all connected accounts (Google, Microsoft, etc.)
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCalendarAccounts: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/calendar-accounts/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Return copy-paste-ready MCP config for a specified AI client.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meMcpConnectionsSetupRetrieve: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/mcp-connections/setup/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Return personalized starter prompts based on real user data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meMcpConnectionsStarterPromptsRetrieve: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/mcp-connections/starter-prompts/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOauthAppsList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/oauth-apps/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} applicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOauthAppsRevokeCreate: async (
      applicationId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'applicationId' is not null or undefined
      assertParamExists('meOauthAppsRevokeCreate', 'applicationId', applicationId)
      const localVarPath = `/me/oauth-apps/{application_id}/revoke/`.replace(
        `{${'application_id'}}`,
        encodeURIComponent(String(applicationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {PatchedOnboardingState} [patchedOnboardingState]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOnboardingPartialUpdate: async (
      patchedOnboardingState?: PatchedOnboardingState,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/onboarding/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedOnboardingState,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOnboardingRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/onboarding/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {OnboardingState} [onboardingState]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOnboardingUpdate: async (
      onboardingState?: OnboardingState,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/onboarding/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        onboardingState,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {PatchedPreferences} [patchedPreferences]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePreferencesPartialUpdate: async (
      patchedPreferences?: PatchedPreferences,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/preferences/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedPreferences,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePreferencesRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/preferences/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {Preferences} preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePreferencesUpdate: async (
      preferences: Preferences,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'preferences' is not null or undefined
      assertParamExists('mePreferencesUpdate', 'preferences', preferences)
      const localVarPath = `/me/preferences/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        preferences,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meReferralLinkRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/referral-link/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} [kind] Token kind. Only &#x60;mcp&#x60; is currently supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTokensDefaultRetrieve: async (
      kind?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/tokens/default/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (kind !== undefined) {
        localVarQueryParameter['kind'] = kind
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} [kind] Token kind. Only &#x60;mcp&#x60; is currently supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTokensDefaultRotateCreate: async (
      kind?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/tokens/default/rotate/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (kind !== undefined) {
        localVarQueryParameter['kind'] = kind
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} [kind] Token kind. Only &#x60;mcp&#x60; is currently supported.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTokensList: async (
      kind?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me/tokens/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (kind !== undefined) {
        localVarQueryParameter['kind'] = kind
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration)
  return {
    /**
     * Disconnect a connected account
     * @param {DisconnectRequest} disconnectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disconnectCalendarAccount(
      disconnectRequest: DisconnectRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectCalendarAccount(
        disconnectRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Get access token for a specific connected account
     * @param {string} calendarAccountId
     * @param {string} [forceRefresh] Set to \&#39;true\&#39; to force a token refresh from the provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCalendarAccountToken(
      calendarAccountId: string,
      forceRefresh?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationToken>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarAccountToken(
        calendarAccountId,
        forceRefresh,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List all connected accounts (Google, Microsoft, etc.)
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCalendarAccounts(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCalendarAccountList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCalendarAccounts(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Return copy-paste-ready MCP config for a specified AI client.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meMcpConnectionsSetupRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.meMcpConnectionsSetupRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Return personalized starter prompts based on real user data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meMcpConnectionsStarterPromptsRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.meMcpConnectionsStarterPromptsRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meOauthAppsList(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectedOAuthApp>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meOauthAppsList(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} applicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meOauthAppsRevokeCreate(
      applicationId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meOauthAppsRevokeCreate(
        applicationId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {PatchedOnboardingState} [patchedOnboardingState]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meOnboardingPartialUpdate(
      patchedOnboardingState?: PatchedOnboardingState,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingState>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meOnboardingPartialUpdate(
        patchedOnboardingState,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meOnboardingRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingState>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meOnboardingRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {OnboardingState} [onboardingState]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meOnboardingUpdate(
      onboardingState?: OnboardingState,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingState>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meOnboardingUpdate(
        onboardingState,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {PatchedPreferences} [patchedPreferences]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePreferencesPartialUpdate(
      patchedPreferences?: PatchedPreferences,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Preferences>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePreferencesPartialUpdate(
        patchedPreferences,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePreferencesRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Preferences>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePreferencesRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {Preferences} preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePreferencesUpdate(
      preferences: Preferences,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Preferences>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePreferencesUpdate(
        preferences,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meReferralLinkRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralLink>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meReferralLinkRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} [kind] Token kind. Only &#x60;mcp&#x60; is currently supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meTokensDefaultRetrieve(
      kind?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiToken>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meTokensDefaultRetrieve(
        kind,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} [kind] Token kind. Only &#x60;mcp&#x60; is currently supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meTokensDefaultRotateCreate(
      kind?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiToken>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meTokensDefaultRotateCreate(
        kind,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} [kind] Token kind. Only &#x60;mcp&#x60; is currently supported.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meTokensList(
      kind?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedApiTokenList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meTokensList(
        kind,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MeApiFp(configuration)
  return {
    /**
     * Disconnect a connected account
     * @param {MeApiDisconnectCalendarAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectCalendarAccount(
      requestParameters: MeApiDisconnectCalendarAccountRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .disconnectCalendarAccount(requestParameters.disconnectRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get access token for a specific connected account
     * @param {MeApiGetCalendarAccountTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCalendarAccountToken(
      requestParameters: MeApiGetCalendarAccountTokenRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<IntegrationToken> {
      return localVarFp
        .getCalendarAccountToken(
          requestParameters.calendarAccountId,
          requestParameters.forceRefresh,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List all connected accounts (Google, Microsoft, etc.)
     * @param {MeApiListCalendarAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCalendarAccounts(
      requestParameters: MeApiListCalendarAccountsRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedCalendarAccountList> {
      return localVarFp
        .listCalendarAccounts(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Return copy-paste-ready MCP config for a specified AI client.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meMcpConnectionsSetupRetrieve(
      options?: AxiosRequestConfig
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .meMcpConnectionsSetupRetrieve(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Return personalized starter prompts based on real user data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meMcpConnectionsStarterPromptsRetrieve(
      options?: AxiosRequestConfig
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .meMcpConnectionsStarterPromptsRetrieve(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOauthAppsList(options?: AxiosRequestConfig): AxiosPromise<Array<ConnectedOAuthApp>> {
      return localVarFp.meOauthAppsList(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMeOauthAppsRevokeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOauthAppsRevokeCreate(
      requestParameters: MeApiMeOauthAppsRevokeCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .meOauthAppsRevokeCreate(requestParameters.applicationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMeOnboardingPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOnboardingPartialUpdate(
      requestParameters: MeApiMeOnboardingPartialUpdateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OnboardingState> {
      return localVarFp
        .meOnboardingPartialUpdate(requestParameters.patchedOnboardingState, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOnboardingRetrieve(options?: AxiosRequestConfig): AxiosPromise<OnboardingState> {
      return localVarFp.meOnboardingRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMeOnboardingUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meOnboardingUpdate(
      requestParameters: MeApiMeOnboardingUpdateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<OnboardingState> {
      return localVarFp
        .meOnboardingUpdate(requestParameters.onboardingState, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMePreferencesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePreferencesPartialUpdate(
      requestParameters: MeApiMePreferencesPartialUpdateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<Preferences> {
      return localVarFp
        .mePreferencesPartialUpdate(requestParameters.patchedPreferences, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePreferencesRetrieve(options?: AxiosRequestConfig): AxiosPromise<Preferences> {
      return localVarFp.mePreferencesRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMePreferencesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePreferencesUpdate(
      requestParameters: MeApiMePreferencesUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Preferences> {
      return localVarFp
        .mePreferencesUpdate(requestParameters.preferences, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meReferralLinkRetrieve(options?: AxiosRequestConfig): AxiosPromise<ReferralLink> {
      return localVarFp.meReferralLinkRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meRetrieve(options?: AxiosRequestConfig): AxiosPromise<User> {
      return localVarFp.meRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMeTokensDefaultRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTokensDefaultRetrieve(
      requestParameters: MeApiMeTokensDefaultRetrieveRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<ApiToken> {
      return localVarFp
        .meTokensDefaultRetrieve(requestParameters.kind, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMeTokensDefaultRotateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTokensDefaultRotateCreate(
      requestParameters: MeApiMeTokensDefaultRotateCreateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<ApiToken> {
      return localVarFp
        .meTokensDefaultRotateCreate(requestParameters.kind, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {MeApiMeTokensListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTokensList(
      requestParameters: MeApiMeTokensListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedApiTokenList> {
      return localVarFp
        .meTokensList(
          requestParameters.kind,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for disconnectCalendarAccount operation in MeApi.
 * @export
 * @interface MeApiDisconnectCalendarAccountRequest
 */
export interface MeApiDisconnectCalendarAccountRequest {
  /**
   *
   * @type {DisconnectRequest}
   * @memberof MeApiDisconnectCalendarAccount
   */
  readonly disconnectRequest: DisconnectRequest
}

/**
 * Request parameters for getCalendarAccountToken operation in MeApi.
 * @export
 * @interface MeApiGetCalendarAccountTokenRequest
 */
export interface MeApiGetCalendarAccountTokenRequest {
  /**
   *
   * @type {string}
   * @memberof MeApiGetCalendarAccountToken
   */
  readonly calendarAccountId: string

  /**
   * Set to \&#39;true\&#39; to force a token refresh from the provider
   * @type {string}
   * @memberof MeApiGetCalendarAccountToken
   */
  readonly forceRefresh?: string
}

/**
 * Request parameters for listCalendarAccounts operation in MeApi.
 * @export
 * @interface MeApiListCalendarAccountsRequest
 */
export interface MeApiListCalendarAccountsRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof MeApiListCalendarAccounts
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof MeApiListCalendarAccounts
   */
  readonly perPage?: number
}

/**
 * Request parameters for meOauthAppsRevokeCreate operation in MeApi.
 * @export
 * @interface MeApiMeOauthAppsRevokeCreateRequest
 */
export interface MeApiMeOauthAppsRevokeCreateRequest {
  /**
   *
   * @type {string}
   * @memberof MeApiMeOauthAppsRevokeCreate
   */
  readonly applicationId: string
}

/**
 * Request parameters for meOnboardingPartialUpdate operation in MeApi.
 * @export
 * @interface MeApiMeOnboardingPartialUpdateRequest
 */
export interface MeApiMeOnboardingPartialUpdateRequest {
  /**
   *
   * @type {PatchedOnboardingState}
   * @memberof MeApiMeOnboardingPartialUpdate
   */
  readonly patchedOnboardingState?: PatchedOnboardingState
}

/**
 * Request parameters for meOnboardingUpdate operation in MeApi.
 * @export
 * @interface MeApiMeOnboardingUpdateRequest
 */
export interface MeApiMeOnboardingUpdateRequest {
  /**
   *
   * @type {OnboardingState}
   * @memberof MeApiMeOnboardingUpdate
   */
  readonly onboardingState?: OnboardingState
}

/**
 * Request parameters for mePreferencesPartialUpdate operation in MeApi.
 * @export
 * @interface MeApiMePreferencesPartialUpdateRequest
 */
export interface MeApiMePreferencesPartialUpdateRequest {
  /**
   *
   * @type {PatchedPreferences}
   * @memberof MeApiMePreferencesPartialUpdate
   */
  readonly patchedPreferences?: PatchedPreferences
}

/**
 * Request parameters for mePreferencesUpdate operation in MeApi.
 * @export
 * @interface MeApiMePreferencesUpdateRequest
 */
export interface MeApiMePreferencesUpdateRequest {
  /**
   *
   * @type {Preferences}
   * @memberof MeApiMePreferencesUpdate
   */
  readonly preferences: Preferences
}

/**
 * Request parameters for meTokensDefaultRetrieve operation in MeApi.
 * @export
 * @interface MeApiMeTokensDefaultRetrieveRequest
 */
export interface MeApiMeTokensDefaultRetrieveRequest {
  /**
   * Token kind. Only &#x60;mcp&#x60; is currently supported.
   * @type {string}
   * @memberof MeApiMeTokensDefaultRetrieve
   */
  readonly kind?: string
}

/**
 * Request parameters for meTokensDefaultRotateCreate operation in MeApi.
 * @export
 * @interface MeApiMeTokensDefaultRotateCreateRequest
 */
export interface MeApiMeTokensDefaultRotateCreateRequest {
  /**
   * Token kind. Only &#x60;mcp&#x60; is currently supported.
   * @type {string}
   * @memberof MeApiMeTokensDefaultRotateCreate
   */
  readonly kind?: string
}

/**
 * Request parameters for meTokensList operation in MeApi.
 * @export
 * @interface MeApiMeTokensListRequest
 */
export interface MeApiMeTokensListRequest {
  /**
   * Token kind. Only &#x60;mcp&#x60; is currently supported.
   * @type {string}
   * @memberof MeApiMeTokensList
   */
  readonly kind?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof MeApiMeTokensList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof MeApiMeTokensList
   */
  readonly perPage?: number
}

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
  /**
   * Disconnect a connected account
   * @param {MeApiDisconnectCalendarAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public disconnectCalendarAccount(
    requestParameters: MeApiDisconnectCalendarAccountRequest,
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .disconnectCalendarAccount(requestParameters.disconnectRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get access token for a specific connected account
   * @param {MeApiGetCalendarAccountTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public getCalendarAccountToken(
    requestParameters: MeApiGetCalendarAccountTokenRequest,
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .getCalendarAccountToken(
        requestParameters.calendarAccountId,
        requestParameters.forceRefresh,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List all connected accounts (Google, Microsoft, etc.)
   * @param {MeApiListCalendarAccountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public listCalendarAccounts(
    requestParameters: MeApiListCalendarAccountsRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .listCalendarAccounts(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Return copy-paste-ready MCP config for a specified AI client.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meMcpConnectionsSetupRetrieve(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meMcpConnectionsSetupRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Return personalized starter prompts based on real user data.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meMcpConnectionsStarterPromptsRetrieve(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meMcpConnectionsStarterPromptsRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meOauthAppsList(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meOauthAppsList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMeOauthAppsRevokeCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meOauthAppsRevokeCreate(
    requestParameters: MeApiMeOauthAppsRevokeCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .meOauthAppsRevokeCreate(requestParameters.applicationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMeOnboardingPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meOnboardingPartialUpdate(
    requestParameters: MeApiMeOnboardingPartialUpdateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .meOnboardingPartialUpdate(requestParameters.patchedOnboardingState, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meOnboardingRetrieve(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meOnboardingRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMeOnboardingUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meOnboardingUpdate(
    requestParameters: MeApiMeOnboardingUpdateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .meOnboardingUpdate(requestParameters.onboardingState, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMePreferencesPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public mePreferencesPartialUpdate(
    requestParameters: MeApiMePreferencesPartialUpdateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .mePreferencesPartialUpdate(requestParameters.patchedPreferences, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public mePreferencesRetrieve(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .mePreferencesRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMePreferencesUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public mePreferencesUpdate(
    requestParameters: MeApiMePreferencesUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .mePreferencesUpdate(requestParameters.preferences, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meReferralLinkRetrieve(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meReferralLinkRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meRetrieve(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMeTokensDefaultRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meTokensDefaultRetrieve(
    requestParameters: MeApiMeTokensDefaultRetrieveRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .meTokensDefaultRetrieve(requestParameters.kind, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMeTokensDefaultRotateCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meTokensDefaultRotateCreate(
    requestParameters: MeApiMeTokensDefaultRotateCreateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .meTokensDefaultRotateCreate(requestParameters.kind, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {MeApiMeTokensListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meTokensList(
    requestParameters: MeApiMeTokensListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MeApiFp(this.configuration)
      .meTokensList(
        requestParameters.kind,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MoveApi - axios parameter creator
 * @export
 */
export const MoveApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * POST /move/ Body: { \"folder_moves\": [ { \"id\", \"parent_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ], \"note_moves\": [ { \"id\", \"folder_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ] } Position: at most one of sort_key, after_id, or before_id per item (validated by serializer). Rebalances when keys get too long.
     * @param {MoveRequest} [moveRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moveCreate: async (
      moveRequest?: MoveRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/move/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        moveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MoveApi - functional programming interface
 * @export
 */
export const MoveApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MoveApiAxiosParamCreator(configuration)
  return {
    /**
     * POST /move/ Body: { \"folder_moves\": [ { \"id\", \"parent_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ], \"note_moves\": [ { \"id\", \"folder_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ] } Position: at most one of sort_key, after_id, or before_id per item (validated by serializer). Rebalances when keys get too long.
     * @param {MoveRequest} [moveRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async moveCreate(
      moveRequest?: MoveRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoveCreate200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.moveCreate(moveRequest, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * MoveApi - factory interface
 * @export
 */
export const MoveApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MoveApiFp(configuration)
  return {
    /**
     * POST /move/ Body: { \"folder_moves\": [ { \"id\", \"parent_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ], \"note_moves\": [ { \"id\", \"folder_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ] } Position: at most one of sort_key, after_id, or before_id per item (validated by serializer). Rebalances when keys get too long.
     * @param {MoveApiMoveCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moveCreate(
      requestParameters: MoveApiMoveCreateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<MoveCreate200Response> {
      return localVarFp
        .moveCreate(requestParameters.moveRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for moveCreate operation in MoveApi.
 * @export
 * @interface MoveApiMoveCreateRequest
 */
export interface MoveApiMoveCreateRequest {
  /**
   *
   * @type {MoveRequest}
   * @memberof MoveApiMoveCreate
   */
  readonly moveRequest?: MoveRequest
}

/**
 * MoveApi - object-oriented interface
 * @export
 * @class MoveApi
 * @extends {BaseAPI}
 */
export class MoveApi extends BaseAPI {
  /**
   * POST /move/ Body: { \"folder_moves\": [ { \"id\", \"parent_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ], \"note_moves\": [ { \"id\", \"folder_id\"?, \"sort_key\"?, \"after_id\"?, \"before_id\"? } ] } Position: at most one of sort_key, after_id, or before_id per item (validated by serializer). Rebalances when keys get too long.
   * @param {MoveApiMoveCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MoveApi
   */
  public moveCreate(
    requestParameters: MoveApiMoveCreateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return MoveApiFp(this.configuration)
      .moveCreate(requestParameters.moveRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NotesApi - axios parameter creator
 * @export
 */
export const NotesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Remove junk notes (empty or &lt; 10 chars). dry_run=true to preview only. ignore_note_ids=IDs to keep.
     * @param {NotesCleanCreateRequest} [notesCleanCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesCleanCreate: async (
      notesCleanCreateRequest?: NotesCleanCreateRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/notes/clean/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        notesCleanCreateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {NotesCreateRequest} [notesCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesCreate: async (
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      notesCreateRequest?: NotesCreateRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/notes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeAbandoned !== undefined) {
        localVarQueryParameter['include_abandoned'] = includeAbandoned
      }

      if (week !== undefined) {
        localVarQueryParameter['week'] = week
      }

      if (folderId !== undefined) {
        localVarQueryParameter['folder_id'] = folderId
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        notesCreateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} dateStr
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesDRetrieve: async (
      dateStr: string,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dateStr' is not null or undefined
      assertParamExists('notesDRetrieve', 'dateStr', dateStr)
      const localVarPath = `/notes/d:{date_str}/`.replace(
        `{${'date_str'}}`,
        encodeURIComponent(String(dateStr))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (createIfNotFound !== undefined) {
        localVarQueryParameter['create_if_not_found'] = createIfNotFound
      }

      if (redirect !== undefined) {
        localVarQueryParameter['redirect'] = redirect
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} dateStr
     * @param {Note} note
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesDUpdate: async (
      dateStr: string,
      note: Note,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dateStr' is not null or undefined
      assertParamExists('notesDUpdate', 'dateStr', dateStr)
      // verify required parameter 'note' is not null or undefined
      assertParamExists('notesDUpdate', 'note', note)
      const localVarPath = `/notes/d:{date_str}/`.replace(
        `{${'date_str'}}`,
        encodeURIComponent(String(dateStr))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (createIfNotFound !== undefined) {
        localVarQueryParameter['create_if_not_found'] = createIfNotFound
      }

      if (redirect !== undefined) {
        localVarQueryParameter['redirect'] = redirect
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        note,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Move a note to trash
     * @param {string} id
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesDestroy: async (
      id: string,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('notesDestroy', 'id', id)
      const localVarPath = `/notes/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeAbandoned !== undefined) {
        localVarQueryParameter['include_abandoned'] = includeAbandoned
      }

      if (week !== undefined) {
        localVarQueryParameter['week'] = week
      }

      if (folderId !== undefined) {
        localVarQueryParameter['folder_id'] = folderId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} encodedEventId
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {string} [associatedEventCalendar] Calendar ID where the associated event can be found. Required for non-primary calendar events.
     * @param {string} [associatedEventTitle] Title of the associated event to use as default title when creating a new note.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesERetrieve: async (
      encodedEventId: string,
      createIfNotFound?: boolean,
      redirect?: boolean,
      associatedEventCalendar?: string,
      associatedEventTitle?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedEventId' is not null or undefined
      assertParamExists('notesERetrieve', 'encodedEventId', encodedEventId)
      const localVarPath = `/notes/e:{encoded_event_id}/`.replace(
        `{${'encoded_event_id'}}`,
        encodeURIComponent(String(encodedEventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (createIfNotFound !== undefined) {
        localVarQueryParameter['create_if_not_found'] = createIfNotFound
      }

      if (redirect !== undefined) {
        localVarQueryParameter['redirect'] = redirect
      }

      if (associatedEventCalendar !== undefined) {
        localVarQueryParameter['associated_event_calendar'] = associatedEventCalendar
      }

      if (associatedEventTitle !== undefined) {
        localVarQueryParameter['associated_event_title'] = associatedEventTitle
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} encodedEventId
     * @param {Note} note
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {string} [associatedEventCalendar] Calendar ID where the associated event can be found. Required for non-primary calendar events.
     * @param {string} [associatedEventTitle] Title of the associated event to use as default title when creating a new note.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesEUpdate: async (
      encodedEventId: string,
      note: Note,
      createIfNotFound?: boolean,
      redirect?: boolean,
      associatedEventCalendar?: string,
      associatedEventTitle?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedEventId' is not null or undefined
      assertParamExists('notesEUpdate', 'encodedEventId', encodedEventId)
      // verify required parameter 'note' is not null or undefined
      assertParamExists('notesEUpdate', 'note', note)
      const localVarPath = `/notes/e:{encoded_event_id}/`.replace(
        `{${'encoded_event_id'}}`,
        encodeURIComponent(String(encodedEventId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (createIfNotFound !== undefined) {
        localVarQueryParameter['create_if_not_found'] = createIfNotFound
      }

      if (redirect !== undefined) {
        localVarQueryParameter['redirect'] = redirect
      }

      if (associatedEventCalendar !== undefined) {
        localVarQueryParameter['associated_event_calendar'] = associatedEventCalendar
      }

      if (associatedEventTitle !== undefined) {
        localVarQueryParameter['associated_event_title'] = associatedEventTitle
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        note,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Initialize demo notes for a new user
     * @param {NotesInitializeDemoNotesCreateRequest} [notesInitializeDemoNotesCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesInitializeDemoNotesCreate: async (
      notesInitializeDemoNotesCreateRequest?: NotesInitializeDemoNotesCreateRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/notes/initialize-demo-notes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        notesInitializeDemoNotesCreateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesList: async (
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/notes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeAbandoned !== undefined) {
        localVarQueryParameter['include_abandoned'] = includeAbandoned
      }

      if (week !== undefined) {
        localVarQueryParameter['week'] = week
      }

      if (folderId !== undefined) {
        localVarQueryParameter['folder_id'] = folderId
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {PatchedNote} [patchedNote]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesPartialUpdate: async (
      id: string,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      patchedNote?: PatchedNote,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('notesPartialUpdate', 'id', id)
      const localVarPath = `/notes/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeAbandoned !== undefined) {
        localVarQueryParameter['include_abandoned'] = includeAbandoned
      }

      if (week !== undefined) {
        localVarQueryParameter['week'] = week
      }

      if (folderId !== undefined) {
        localVarQueryParameter['folder_id'] = folderId
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedNote,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {UpdatePinsRequest} updatePinsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesPinsUpdate: async (
      updatePinsRequest: UpdatePinsRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'updatePinsRequest' is not null or undefined
      assertParamExists('notesPinsUpdate', 'updatePinsRequest', updatePinsRequest)
      const localVarPath = `/notes/pins/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePinsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesRecentList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/notes/recent/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesRetrieve: async (
      id: string,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('notesRetrieve', 'id', id)
      const localVarPath = `/notes/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeAbandoned !== undefined) {
        localVarQueryParameter['include_abandoned'] = includeAbandoned
      }

      if (week !== undefined) {
        localVarQueryParameter['week'] = week
      }

      if (folderId !== undefined) {
        localVarQueryParameter['folder_id'] = folderId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} q Search query string
     * @param {boolean} [hideMarks] If true, remove &lt;mark&gt; tags from title/content snippets.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesSearchList: async (
      q: string,
      hideMarks?: boolean,
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'q' is not null or undefined
      assertParamExists('notesSearchList', 'q', q)
      const localVarPath = `/notes/search/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (q !== undefined) {
        localVarQueryParameter['q'] = q
      }

      if (hideMarks !== undefined) {
        localVarQueryParameter['hide_marks'] = hideMarks
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {NoteItem} noteItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesTrashCreate: async (
      noteItem: NoteItem,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteItem' is not null or undefined
      assertParamExists('notesTrashCreate', 'noteItem', noteItem)
      const localVarPath = `/notes/trash/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        noteItem,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesTrashDestroy: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/notes/trash/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesTrashList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/notes/trash/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {Note} note
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesUpdate: async (
      id: string,
      note: Note,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('notesUpdate', 'id', id)
      // verify required parameter 'note' is not null or undefined
      assertParamExists('notesUpdate', 'note', note)
      const localVarPath = `/notes/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (includeTrash !== undefined) {
        localVarQueryParameter['include_trash'] = includeTrash
      }

      if (includeAbandoned !== undefined) {
        localVarQueryParameter['include_abandoned'] = includeAbandoned
      }

      if (week !== undefined) {
        localVarQueryParameter['week'] = week
      }

      if (folderId !== undefined) {
        localVarQueryParameter['folder_id'] = folderId
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        note,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} weekStr
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesWRetrieve: async (
      weekStr: string,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'weekStr' is not null or undefined
      assertParamExists('notesWRetrieve', 'weekStr', weekStr)
      const localVarPath = `/notes/w:{week_str}/`.replace(
        `{${'week_str'}}`,
        encodeURIComponent(String(weekStr))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (createIfNotFound !== undefined) {
        localVarQueryParameter['create_if_not_found'] = createIfNotFound
      }

      if (redirect !== undefined) {
        localVarQueryParameter['redirect'] = redirect
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} weekStr
     * @param {Note} note
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesWUpdate: async (
      weekStr: string,
      note: Note,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'weekStr' is not null or undefined
      assertParamExists('notesWUpdate', 'weekStr', weekStr)
      // verify required parameter 'note' is not null or undefined
      assertParamExists('notesWUpdate', 'note', note)
      const localVarPath = `/notes/w:{week_str}/`.replace(
        `{${'week_str'}}`,
        encodeURIComponent(String(weekStr))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (createIfNotFound !== undefined) {
        localVarQueryParameter['create_if_not_found'] = createIfNotFound
      }

      if (redirect !== undefined) {
        localVarQueryParameter['redirect'] = redirect
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        note,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * NotesApi - functional programming interface
 * @export
 */
export const NotesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NotesApiAxiosParamCreator(configuration)
  return {
    /**
     * Remove junk notes (empty or &lt; 10 chars). dry_run=true to preview only. ignore_note_ids=IDs to keep.
     * @param {NotesCleanCreateRequest} [notesCleanCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesCleanCreate(
      notesCleanCreateRequest?: NotesCleanCreateRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesCleanCreate200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesCleanCreate(
        notesCleanCreateRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {NotesCreateRequest} [notesCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesCreate(
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      notesCreateRequest?: NotesCreateRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesCreate(
        includeTrash,
        includeAbandoned,
        week,
        folderId,
        notesCreateRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} dateStr
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesDRetrieve(
      dateStr: string,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesDRetrieve(
        dateStr,
        createIfNotFound,
        redirect,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} dateStr
     * @param {Note} note
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesDUpdate(
      dateStr: string,
      note: Note,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesDUpdate(
        dateStr,
        note,
        createIfNotFound,
        redirect,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Move a note to trash
     * @param {string} id
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesDestroy(
      id: string,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesDestroy(
        id,
        includeTrash,
        includeAbandoned,
        week,
        folderId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} encodedEventId
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {string} [associatedEventCalendar] Calendar ID where the associated event can be found. Required for non-primary calendar events.
     * @param {string} [associatedEventTitle] Title of the associated event to use as default title when creating a new note.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesERetrieve(
      encodedEventId: string,
      createIfNotFound?: boolean,
      redirect?: boolean,
      associatedEventCalendar?: string,
      associatedEventTitle?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesERetrieve(
        encodedEventId,
        createIfNotFound,
        redirect,
        associatedEventCalendar,
        associatedEventTitle,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} encodedEventId
     * @param {Note} note
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {string} [associatedEventCalendar] Calendar ID where the associated event can be found. Required for non-primary calendar events.
     * @param {string} [associatedEventTitle] Title of the associated event to use as default title when creating a new note.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesEUpdate(
      encodedEventId: string,
      note: Note,
      createIfNotFound?: boolean,
      redirect?: boolean,
      associatedEventCalendar?: string,
      associatedEventTitle?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesEUpdate(
        encodedEventId,
        note,
        createIfNotFound,
        redirect,
        associatedEventCalendar,
        associatedEventTitle,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Initialize demo notes for a new user
     * @param {NotesInitializeDemoNotesCreateRequest} [notesInitializeDemoNotesCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesInitializeDemoNotesCreate(
      notesInitializeDemoNotesCreateRequest?: NotesInitializeDemoNotesCreateRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<NotesInitializeDemoNotesCreate200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesInitializeDemoNotesCreate(
        notesInitializeDemoNotesCreateRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesList(
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNoteItemList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesList(
        includeTrash,
        includeAbandoned,
        week,
        folderId,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {PatchedNote} [patchedNote]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesPartialUpdate(
      id: string,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      patchedNote?: PatchedNote,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesPartialUpdate(
        id,
        includeTrash,
        includeAbandoned,
        week,
        folderId,
        patchedNote,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {UpdatePinsRequest} updatePinsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesPinsUpdate(
      updatePinsRequest: UpdatePinsRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatePinsRequest>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesPinsUpdate(
        updatePinsRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesRecentList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNoteItemList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesRecentList(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesRetrieve(
      id: string,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesRetrieve(
        id,
        includeTrash,
        includeAbandoned,
        week,
        folderId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} q Search query string
     * @param {boolean} [hideMarks] If true, remove &lt;mark&gt; tags from title/content snippets.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesSearchList(
      q: string,
      hideMarks?: boolean,
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNoteSearchResultList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesSearchList(
        q,
        hideMarks,
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {NoteItem} noteItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesTrashCreate(
      noteItem: NoteItem,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesTrashCreate(noteItem, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesTrashDestroy(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesTrashDestroy(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesTrashList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNoteItemList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesTrashList(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {Note} note
     * @param {boolean} [includeTrash] If true, include soft-deleted notes in the list (consistent with folders).
     * @param {boolean} [includeAbandoned] Includes abandoned notes in the response.
     * @param {string} [week] Filters notes by week.
     * @param {string} [folderId] Filter notes by folder (char id). Use empty string for unfiled.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesUpdate(
      id: string,
      note: Note,
      includeTrash?: boolean,
      includeAbandoned?: boolean,
      week?: string,
      folderId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesUpdate(
        id,
        note,
        includeTrash,
        includeAbandoned,
        week,
        folderId,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} weekStr
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesWRetrieve(
      weekStr: string,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesWRetrieve(
        weekStr,
        createIfNotFound,
        redirect,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} weekStr
     * @param {Note} note
     * @param {boolean} [createIfNotFound] Creates the associated note if it does not exist, instead of returning a 404.
     * @param {boolean} [redirect] When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notesWUpdate(
      weekStr: string,
      note: Note,
      createIfNotFound?: boolean,
      redirect?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notesWUpdate(
        weekStr,
        note,
        createIfNotFound,
        redirect,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * NotesApi - factory interface
 * @export
 */
export const NotesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NotesApiFp(configuration)
  return {
    /**
     * Remove junk notes (empty or &lt; 10 chars). dry_run=true to preview only. ignore_note_ids=IDs to keep.
     * @param {NotesApiNotesCleanCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesCleanCreate(
      requestParameters: NotesApiNotesCleanCreateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<NotesCleanCreate200Response> {
      return localVarFp
        .notesCleanCreate(requestParameters.notesCleanCreateRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesCreate(
      requestParameters: NotesApiNotesCreateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesCreate(
          requestParameters.includeTrash,
          requestParameters.includeAbandoned,
          requestParameters.week,
          requestParameters.folderId,
          requestParameters.notesCreateRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesDRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesDRetrieve(
      requestParameters: NotesApiNotesDRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesDRetrieve(
          requestParameters.dateStr,
          requestParameters.createIfNotFound,
          requestParameters.redirect,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesDUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesDUpdate(
      requestParameters: NotesApiNotesDUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesDUpdate(
          requestParameters.dateStr,
          requestParameters.note,
          requestParameters.createIfNotFound,
          requestParameters.redirect,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Move a note to trash
     * @param {NotesApiNotesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesDestroy(
      requestParameters: NotesApiNotesDestroyRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .notesDestroy(
          requestParameters.id,
          requestParameters.includeTrash,
          requestParameters.includeAbandoned,
          requestParameters.week,
          requestParameters.folderId,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesERetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesERetrieve(
      requestParameters: NotesApiNotesERetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesERetrieve(
          requestParameters.encodedEventId,
          requestParameters.createIfNotFound,
          requestParameters.redirect,
          requestParameters.associatedEventCalendar,
          requestParameters.associatedEventTitle,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesEUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesEUpdate(
      requestParameters: NotesApiNotesEUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesEUpdate(
          requestParameters.encodedEventId,
          requestParameters.note,
          requestParameters.createIfNotFound,
          requestParameters.redirect,
          requestParameters.associatedEventCalendar,
          requestParameters.associatedEventTitle,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Initialize demo notes for a new user
     * @param {NotesApiNotesInitializeDemoNotesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesInitializeDemoNotesCreate(
      requestParameters: NotesApiNotesInitializeDemoNotesCreateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<NotesInitializeDemoNotesCreate200Response> {
      return localVarFp
        .notesInitializeDemoNotesCreate(
          requestParameters.notesInitializeDemoNotesCreateRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesList(
      requestParameters: NotesApiNotesListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNoteItemList> {
      return localVarFp
        .notesList(
          requestParameters.includeTrash,
          requestParameters.includeAbandoned,
          requestParameters.week,
          requestParameters.folderId,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesPartialUpdate(
      requestParameters: NotesApiNotesPartialUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesPartialUpdate(
          requestParameters.id,
          requestParameters.includeTrash,
          requestParameters.includeAbandoned,
          requestParameters.week,
          requestParameters.folderId,
          requestParameters.patchedNote,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesPinsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesPinsUpdate(
      requestParameters: NotesApiNotesPinsUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<UpdatePinsRequest> {
      return localVarFp
        .notesPinsUpdate(requestParameters.updatePinsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesRecentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesRecentList(
      requestParameters: NotesApiNotesRecentListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNoteItemList> {
      return localVarFp
        .notesRecentList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesRetrieve(
      requestParameters: NotesApiNotesRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesRetrieve(
          requestParameters.id,
          requestParameters.includeTrash,
          requestParameters.includeAbandoned,
          requestParameters.week,
          requestParameters.folderId,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesSearchListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesSearchList(
      requestParameters: NotesApiNotesSearchListRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNoteSearchResultList> {
      return localVarFp
        .notesSearchList(
          requestParameters.q,
          requestParameters.hideMarks,
          requestParameters.page,
          requestParameters.perPage,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesTrashCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesTrashCreate(
      requestParameters: NotesApiNotesTrashCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<NoteItem> {
      return localVarFp
        .notesTrashCreate(requestParameters.noteItem, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesTrashDestroy(options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.notesTrashDestroy(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesTrashListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesTrashList(
      requestParameters: NotesApiNotesTrashListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNoteItemList> {
      return localVarFp
        .notesTrashList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesUpdate(
      requestParameters: NotesApiNotesUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesUpdate(
          requestParameters.id,
          requestParameters.note,
          requestParameters.includeTrash,
          requestParameters.includeAbandoned,
          requestParameters.week,
          requestParameters.folderId,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesWRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesWRetrieve(
      requestParameters: NotesApiNotesWRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesWRetrieve(
          requestParameters.weekStr,
          requestParameters.createIfNotFound,
          requestParameters.redirect,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {NotesApiNotesWUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notesWUpdate(
      requestParameters: NotesApiNotesWUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .notesWUpdate(
          requestParameters.weekStr,
          requestParameters.note,
          requestParameters.createIfNotFound,
          requestParameters.redirect,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for notesCleanCreate operation in NotesApi.
 * @export
 * @interface NotesApiNotesCleanCreateRequest
 */
export interface NotesApiNotesCleanCreateRequest {
  /**
   *
   * @type {NotesCleanCreateRequest}
   * @memberof NotesApiNotesCleanCreate
   */
  readonly notesCleanCreateRequest?: NotesCleanCreateRequest
}

/**
 * Request parameters for notesCreate operation in NotesApi.
 * @export
 * @interface NotesApiNotesCreateRequest
 */
export interface NotesApiNotesCreateRequest {
  /**
   * If true, include soft-deleted notes in the list (consistent with folders).
   * @type {boolean}
   * @memberof NotesApiNotesCreate
   */
  readonly includeTrash?: boolean

  /**
   * Includes abandoned notes in the response.
   * @type {boolean}
   * @memberof NotesApiNotesCreate
   */
  readonly includeAbandoned?: boolean

  /**
   * Filters notes by week.
   * @type {string}
   * @memberof NotesApiNotesCreate
   */
  readonly week?: string

  /**
   * Filter notes by folder (char id). Use empty string for unfiled.
   * @type {string}
   * @memberof NotesApiNotesCreate
   */
  readonly folderId?: string

  /**
   *
   * @type {NotesCreateRequest}
   * @memberof NotesApiNotesCreate
   */
  readonly notesCreateRequest?: NotesCreateRequest
}

/**
 * Request parameters for notesDRetrieve operation in NotesApi.
 * @export
 * @interface NotesApiNotesDRetrieveRequest
 */
export interface NotesApiNotesDRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesDRetrieve
   */
  readonly dateStr: string

  /**
   * Creates the associated note if it does not exist, instead of returning a 404.
   * @type {boolean}
   * @memberof NotesApiNotesDRetrieve
   */
  readonly createIfNotFound?: boolean

  /**
   * When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
   * @type {boolean}
   * @memberof NotesApiNotesDRetrieve
   */
  readonly redirect?: boolean
}

/**
 * Request parameters for notesDUpdate operation in NotesApi.
 * @export
 * @interface NotesApiNotesDUpdateRequest
 */
export interface NotesApiNotesDUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesDUpdate
   */
  readonly dateStr: string

  /**
   *
   * @type {Note}
   * @memberof NotesApiNotesDUpdate
   */
  readonly note: Note

  /**
   * Creates the associated note if it does not exist, instead of returning a 404.
   * @type {boolean}
   * @memberof NotesApiNotesDUpdate
   */
  readonly createIfNotFound?: boolean

  /**
   * When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
   * @type {boolean}
   * @memberof NotesApiNotesDUpdate
   */
  readonly redirect?: boolean
}

/**
 * Request parameters for notesDestroy operation in NotesApi.
 * @export
 * @interface NotesApiNotesDestroyRequest
 */
export interface NotesApiNotesDestroyRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesDestroy
   */
  readonly id: string

  /**
   * If true, include soft-deleted notes in the list (consistent with folders).
   * @type {boolean}
   * @memberof NotesApiNotesDestroy
   */
  readonly includeTrash?: boolean

  /**
   * Includes abandoned notes in the response.
   * @type {boolean}
   * @memberof NotesApiNotesDestroy
   */
  readonly includeAbandoned?: boolean

  /**
   * Filters notes by week.
   * @type {string}
   * @memberof NotesApiNotesDestroy
   */
  readonly week?: string

  /**
   * Filter notes by folder (char id). Use empty string for unfiled.
   * @type {string}
   * @memberof NotesApiNotesDestroy
   */
  readonly folderId?: string
}

/**
 * Request parameters for notesERetrieve operation in NotesApi.
 * @export
 * @interface NotesApiNotesERetrieveRequest
 */
export interface NotesApiNotesERetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesERetrieve
   */
  readonly encodedEventId: string

  /**
   * Creates the associated note if it does not exist, instead of returning a 404.
   * @type {boolean}
   * @memberof NotesApiNotesERetrieve
   */
  readonly createIfNotFound?: boolean

  /**
   * When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
   * @type {boolean}
   * @memberof NotesApiNotesERetrieve
   */
  readonly redirect?: boolean

  /**
   * Calendar ID where the associated event can be found. Required for non-primary calendar events.
   * @type {string}
   * @memberof NotesApiNotesERetrieve
   */
  readonly associatedEventCalendar?: string

  /**
   * Title of the associated event to use as default title when creating a new note.
   * @type {string}
   * @memberof NotesApiNotesERetrieve
   */
  readonly associatedEventTitle?: string
}

/**
 * Request parameters for notesEUpdate operation in NotesApi.
 * @export
 * @interface NotesApiNotesEUpdateRequest
 */
export interface NotesApiNotesEUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesEUpdate
   */
  readonly encodedEventId: string

  /**
   *
   * @type {Note}
   * @memberof NotesApiNotesEUpdate
   */
  readonly note: Note

  /**
   * Creates the associated note if it does not exist, instead of returning a 404.
   * @type {boolean}
   * @memberof NotesApiNotesEUpdate
   */
  readonly createIfNotFound?: boolean

  /**
   * When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
   * @type {boolean}
   * @memberof NotesApiNotesEUpdate
   */
  readonly redirect?: boolean

  /**
   * Calendar ID where the associated event can be found. Required for non-primary calendar events.
   * @type {string}
   * @memberof NotesApiNotesEUpdate
   */
  readonly associatedEventCalendar?: string

  /**
   * Title of the associated event to use as default title when creating a new note.
   * @type {string}
   * @memberof NotesApiNotesEUpdate
   */
  readonly associatedEventTitle?: string
}

/**
 * Request parameters for notesInitializeDemoNotesCreate operation in NotesApi.
 * @export
 * @interface NotesApiNotesInitializeDemoNotesCreateRequest
 */
export interface NotesApiNotesInitializeDemoNotesCreateRequest {
  /**
   *
   * @type {NotesInitializeDemoNotesCreateRequest}
   * @memberof NotesApiNotesInitializeDemoNotesCreate
   */
  readonly notesInitializeDemoNotesCreateRequest?: NotesInitializeDemoNotesCreateRequest
}

/**
 * Request parameters for notesList operation in NotesApi.
 * @export
 * @interface NotesApiNotesListRequest
 */
export interface NotesApiNotesListRequest {
  /**
   * If true, include soft-deleted notes in the list (consistent with folders).
   * @type {boolean}
   * @memberof NotesApiNotesList
   */
  readonly includeTrash?: boolean

  /**
   * Includes abandoned notes in the response.
   * @type {boolean}
   * @memberof NotesApiNotesList
   */
  readonly includeAbandoned?: boolean

  /**
   * Filters notes by week.
   * @type {string}
   * @memberof NotesApiNotesList
   */
  readonly week?: string

  /**
   * Filter notes by folder (char id). Use empty string for unfiled.
   * @type {string}
   * @memberof NotesApiNotesList
   */
  readonly folderId?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof NotesApiNotesList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof NotesApiNotesList
   */
  readonly perPage?: number
}

/**
 * Request parameters for notesPartialUpdate operation in NotesApi.
 * @export
 * @interface NotesApiNotesPartialUpdateRequest
 */
export interface NotesApiNotesPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesPartialUpdate
   */
  readonly id: string

  /**
   * If true, include soft-deleted notes in the list (consistent with folders).
   * @type {boolean}
   * @memberof NotesApiNotesPartialUpdate
   */
  readonly includeTrash?: boolean

  /**
   * Includes abandoned notes in the response.
   * @type {boolean}
   * @memberof NotesApiNotesPartialUpdate
   */
  readonly includeAbandoned?: boolean

  /**
   * Filters notes by week.
   * @type {string}
   * @memberof NotesApiNotesPartialUpdate
   */
  readonly week?: string

  /**
   * Filter notes by folder (char id). Use empty string for unfiled.
   * @type {string}
   * @memberof NotesApiNotesPartialUpdate
   */
  readonly folderId?: string

  /**
   *
   * @type {PatchedNote}
   * @memberof NotesApiNotesPartialUpdate
   */
  readonly patchedNote?: PatchedNote
}

/**
 * Request parameters for notesPinsUpdate operation in NotesApi.
 * @export
 * @interface NotesApiNotesPinsUpdateRequest
 */
export interface NotesApiNotesPinsUpdateRequest {
  /**
   *
   * @type {UpdatePinsRequest}
   * @memberof NotesApiNotesPinsUpdate
   */
  readonly updatePinsRequest: UpdatePinsRequest
}

/**
 * Request parameters for notesRecentList operation in NotesApi.
 * @export
 * @interface NotesApiNotesRecentListRequest
 */
export interface NotesApiNotesRecentListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof NotesApiNotesRecentList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof NotesApiNotesRecentList
   */
  readonly perPage?: number
}

/**
 * Request parameters for notesRetrieve operation in NotesApi.
 * @export
 * @interface NotesApiNotesRetrieveRequest
 */
export interface NotesApiNotesRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesRetrieve
   */
  readonly id: string

  /**
   * If true, include soft-deleted notes in the list (consistent with folders).
   * @type {boolean}
   * @memberof NotesApiNotesRetrieve
   */
  readonly includeTrash?: boolean

  /**
   * Includes abandoned notes in the response.
   * @type {boolean}
   * @memberof NotesApiNotesRetrieve
   */
  readonly includeAbandoned?: boolean

  /**
   * Filters notes by week.
   * @type {string}
   * @memberof NotesApiNotesRetrieve
   */
  readonly week?: string

  /**
   * Filter notes by folder (char id). Use empty string for unfiled.
   * @type {string}
   * @memberof NotesApiNotesRetrieve
   */
  readonly folderId?: string
}

/**
 * Request parameters for notesSearchList operation in NotesApi.
 * @export
 * @interface NotesApiNotesSearchListRequest
 */
export interface NotesApiNotesSearchListRequest {
  /**
   * Search query string
   * @type {string}
   * @memberof NotesApiNotesSearchList
   */
  readonly q: string

  /**
   * If true, remove &lt;mark&gt; tags from title/content snippets.
   * @type {boolean}
   * @memberof NotesApiNotesSearchList
   */
  readonly hideMarks?: boolean

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof NotesApiNotesSearchList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof NotesApiNotesSearchList
   */
  readonly perPage?: number
}

/**
 * Request parameters for notesTrashCreate operation in NotesApi.
 * @export
 * @interface NotesApiNotesTrashCreateRequest
 */
export interface NotesApiNotesTrashCreateRequest {
  /**
   *
   * @type {NoteItem}
   * @memberof NotesApiNotesTrashCreate
   */
  readonly noteItem: NoteItem
}

/**
 * Request parameters for notesTrashList operation in NotesApi.
 * @export
 * @interface NotesApiNotesTrashListRequest
 */
export interface NotesApiNotesTrashListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof NotesApiNotesTrashList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof NotesApiNotesTrashList
   */
  readonly perPage?: number
}

/**
 * Request parameters for notesUpdate operation in NotesApi.
 * @export
 * @interface NotesApiNotesUpdateRequest
 */
export interface NotesApiNotesUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesUpdate
   */
  readonly id: string

  /**
   *
   * @type {Note}
   * @memberof NotesApiNotesUpdate
   */
  readonly note: Note

  /**
   * If true, include soft-deleted notes in the list (consistent with folders).
   * @type {boolean}
   * @memberof NotesApiNotesUpdate
   */
  readonly includeTrash?: boolean

  /**
   * Includes abandoned notes in the response.
   * @type {boolean}
   * @memberof NotesApiNotesUpdate
   */
  readonly includeAbandoned?: boolean

  /**
   * Filters notes by week.
   * @type {string}
   * @memberof NotesApiNotesUpdate
   */
  readonly week?: string

  /**
   * Filter notes by folder (char id). Use empty string for unfiled.
   * @type {string}
   * @memberof NotesApiNotesUpdate
   */
  readonly folderId?: string
}

/**
 * Request parameters for notesWRetrieve operation in NotesApi.
 * @export
 * @interface NotesApiNotesWRetrieveRequest
 */
export interface NotesApiNotesWRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesWRetrieve
   */
  readonly weekStr: string

  /**
   * Creates the associated note if it does not exist, instead of returning a 404.
   * @type {boolean}
   * @memberof NotesApiNotesWRetrieve
   */
  readonly createIfNotFound?: boolean

  /**
   * When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
   * @type {boolean}
   * @memberof NotesApiNotesWRetrieve
   */
  readonly redirect?: boolean
}

/**
 * Request parameters for notesWUpdate operation in NotesApi.
 * @export
 * @interface NotesApiNotesWUpdateRequest
 */
export interface NotesApiNotesWUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof NotesApiNotesWUpdate
   */
  readonly weekStr: string

  /**
   *
   * @type {Note}
   * @memberof NotesApiNotesWUpdate
   */
  readonly note: Note

  /**
   * Creates the associated note if it does not exist, instead of returning a 404.
   * @type {boolean}
   * @memberof NotesApiNotesWUpdate
   */
  readonly createIfNotFound?: boolean

  /**
   * When false, returns the note directly instead of a 301 redirect. Defaults to true for backward compatibility.
   * @type {boolean}
   * @memberof NotesApiNotesWUpdate
   */
  readonly redirect?: boolean
}

/**
 * NotesApi - object-oriented interface
 * @export
 * @class NotesApi
 * @extends {BaseAPI}
 */
export class NotesApi extends BaseAPI {
  /**
   * Remove junk notes (empty or &lt; 10 chars). dry_run=true to preview only. ignore_note_ids=IDs to keep.
   * @param {NotesApiNotesCleanCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesCleanCreate(
    requestParameters: NotesApiNotesCleanCreateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesCleanCreate(requestParameters.notesCleanCreateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesCreate(
    requestParameters: NotesApiNotesCreateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesCreate(
        requestParameters.includeTrash,
        requestParameters.includeAbandoned,
        requestParameters.week,
        requestParameters.folderId,
        requestParameters.notesCreateRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesDRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesDRetrieve(
    requestParameters: NotesApiNotesDRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesDRetrieve(
        requestParameters.dateStr,
        requestParameters.createIfNotFound,
        requestParameters.redirect,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesDUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesDUpdate(
    requestParameters: NotesApiNotesDUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesDUpdate(
        requestParameters.dateStr,
        requestParameters.note,
        requestParameters.createIfNotFound,
        requestParameters.redirect,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Move a note to trash
   * @param {NotesApiNotesDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesDestroy(
    requestParameters: NotesApiNotesDestroyRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesDestroy(
        requestParameters.id,
        requestParameters.includeTrash,
        requestParameters.includeAbandoned,
        requestParameters.week,
        requestParameters.folderId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesERetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesERetrieve(
    requestParameters: NotesApiNotesERetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesERetrieve(
        requestParameters.encodedEventId,
        requestParameters.createIfNotFound,
        requestParameters.redirect,
        requestParameters.associatedEventCalendar,
        requestParameters.associatedEventTitle,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesEUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesEUpdate(
    requestParameters: NotesApiNotesEUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesEUpdate(
        requestParameters.encodedEventId,
        requestParameters.note,
        requestParameters.createIfNotFound,
        requestParameters.redirect,
        requestParameters.associatedEventCalendar,
        requestParameters.associatedEventTitle,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Initialize demo notes for a new user
   * @param {NotesApiNotesInitializeDemoNotesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesInitializeDemoNotesCreate(
    requestParameters: NotesApiNotesInitializeDemoNotesCreateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesInitializeDemoNotesCreate(
        requestParameters.notesInitializeDemoNotesCreateRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesList(requestParameters: NotesApiNotesListRequest = {}, options?: AxiosRequestConfig) {
    return NotesApiFp(this.configuration)
      .notesList(
        requestParameters.includeTrash,
        requestParameters.includeAbandoned,
        requestParameters.week,
        requestParameters.folderId,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesPartialUpdate(
    requestParameters: NotesApiNotesPartialUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesPartialUpdate(
        requestParameters.id,
        requestParameters.includeTrash,
        requestParameters.includeAbandoned,
        requestParameters.week,
        requestParameters.folderId,
        requestParameters.patchedNote,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesPinsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesPinsUpdate(
    requestParameters: NotesApiNotesPinsUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesPinsUpdate(requestParameters.updatePinsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesRecentListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesRecentList(
    requestParameters: NotesApiNotesRecentListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesRecentList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesRetrieve(
    requestParameters: NotesApiNotesRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesRetrieve(
        requestParameters.id,
        requestParameters.includeTrash,
        requestParameters.includeAbandoned,
        requestParameters.week,
        requestParameters.folderId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesSearchListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesSearchList(
    requestParameters: NotesApiNotesSearchListRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesSearchList(
        requestParameters.q,
        requestParameters.hideMarks,
        requestParameters.page,
        requestParameters.perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesTrashCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesTrashCreate(
    requestParameters: NotesApiNotesTrashCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesTrashCreate(requestParameters.noteItem, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesTrashDestroy(options?: AxiosRequestConfig) {
    return NotesApiFp(this.configuration)
      .notesTrashDestroy(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesTrashListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesTrashList(
    requestParameters: NotesApiNotesTrashListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesTrashList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesUpdate(requestParameters: NotesApiNotesUpdateRequest, options?: AxiosRequestConfig) {
    return NotesApiFp(this.configuration)
      .notesUpdate(
        requestParameters.id,
        requestParameters.note,
        requestParameters.includeTrash,
        requestParameters.includeAbandoned,
        requestParameters.week,
        requestParameters.folderId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesWRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesWRetrieve(
    requestParameters: NotesApiNotesWRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesWRetrieve(
        requestParameters.weekStr,
        requestParameters.createIfNotFound,
        requestParameters.redirect,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {NotesApiNotesWUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotesApi
   */
  public notesWUpdate(
    requestParameters: NotesApiNotesWUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return NotesApiFp(this.configuration)
      .notesWUpdate(
        requestParameters.weekStr,
        requestParameters.note,
        requestParameters.createIfNotFound,
        requestParameters.redirect,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PromosApi - axios parameter creator
 * @export
 */
export const PromosApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    promosList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/promos/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PromosApi - functional programming interface
 * @export
 */
export const PromosApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PromosApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async promosList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPromoProgressList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.promosList(page, perPage, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * PromosApi - factory interface
 * @export
 */
export const PromosApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PromosApiFp(configuration)
  return {
    /**
     *
     * @param {PromosApiPromosListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    promosList(
      requestParameters: PromosApiPromosListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedPromoProgressList> {
      return localVarFp
        .promosList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for promosList operation in PromosApi.
 * @export
 * @interface PromosApiPromosListRequest
 */
export interface PromosApiPromosListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof PromosApiPromosList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof PromosApiPromosList
   */
  readonly perPage?: number
}

/**
 * PromosApi - object-oriented interface
 * @export
 * @class PromosApi
 * @extends {BaseAPI}
 */
export class PromosApi extends BaseAPI {
  /**
   *
   * @param {PromosApiPromosListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromosApi
   */
  public promosList(
    requestParameters: PromosApiPromosListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return PromosApiFp(this.configuration)
      .promosList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PushDevicesApi - axios parameter creator
 * @export
 */
export const PushDevicesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Register or update an FCM token for the current user.  If the registration_id already exists for another user, the old record is deleted and a new one is created for the current user. This ensures only the most recent user to register a device token owns it.
     * @param {RegisterFCMDevice} registerFCMDevice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesCreate: async (
      registerFCMDevice: RegisterFCMDevice,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'registerFCMDevice' is not null or undefined
      assertParamExists('pushDevicesCreate', 'registerFCMDevice', registerFCMDevice)
      const localVarPath = `/push-devices/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication knoxApiToken required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerFCMDevice,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an FCM device by UUID.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesDestroy: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pushDevicesDestroy', 'id', id)
      const localVarPath = `/push-devices/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication knoxApiToken required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update device info for an existing FCM device by UUID.
     * @param {string} id
     * @param {PatchedRegisterFCMDevice} [patchedRegisterFCMDevice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesPartialUpdate: async (
      id: string,
      patchedRegisterFCMDevice?: PatchedRegisterFCMDevice,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pushDevicesPartialUpdate', 'id', id)
      const localVarPath = `/push-devices/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication knoxApiToken required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedRegisterFCMDevice,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * List all FCM devices for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/push-devices/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication knoxApiToken required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Send a test push to the current user\'s devices.
     * @param {SendTestPushRequest} [sendTestPushRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesSendTestCreate: async (
      sendTestPushRequest?: SendTestPushRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/push-devices/send-test/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication knoxApiToken required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendTestPushRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PushDevicesApi - functional programming interface
 * @export
 */
export const PushDevicesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PushDevicesApiAxiosParamCreator(configuration)
  return {
    /**
     * Register or update an FCM token for the current user.  If the registration_id already exists for another user, the old record is deleted and a new one is created for the current user. This ensures only the most recent user to register a device token owns it.
     * @param {RegisterFCMDevice} registerFCMDevice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pushDevicesCreate(
      registerFCMDevice: RegisterFCMDevice,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCMDevice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pushDevicesCreate(
        registerFCMDevice,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Delete an FCM device by UUID.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pushDevicesDestroy(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pushDevicesDestroy(id, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Update device info for an existing FCM device by UUID.
     * @param {string} id
     * @param {PatchedRegisterFCMDevice} [patchedRegisterFCMDevice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pushDevicesPartialUpdate(
      id: string,
      patchedRegisterFCMDevice?: PatchedRegisterFCMDevice,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCMDevice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pushDevicesPartialUpdate(
        id,
        patchedRegisterFCMDevice,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * List all FCM devices for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pushDevicesRetrieve(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushDeviceListResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pushDevicesRetrieve(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Send a test push to the current user\'s devices.
     * @param {SendTestPushRequest} [sendTestPushRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pushDevicesSendTestCreate(
      sendTestPushRequest?: SendTestPushRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendTestPushResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pushDevicesSendTestCreate(
        sendTestPushRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * PushDevicesApi - factory interface
 * @export
 */
export const PushDevicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PushDevicesApiFp(configuration)
  return {
    /**
     * Register or update an FCM token for the current user.  If the registration_id already exists for another user, the old record is deleted and a new one is created for the current user. This ensures only the most recent user to register a device token owns it.
     * @param {PushDevicesApiPushDevicesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesCreate(
      requestParameters: PushDevicesApiPushDevicesCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FCMDevice> {
      return localVarFp
        .pushDevicesCreate(requestParameters.registerFCMDevice, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an FCM device by UUID.
     * @param {PushDevicesApiPushDevicesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesDestroy(
      requestParameters: PushDevicesApiPushDevicesDestroyRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .pushDevicesDestroy(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update device info for an existing FCM device by UUID.
     * @param {PushDevicesApiPushDevicesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesPartialUpdate(
      requestParameters: PushDevicesApiPushDevicesPartialUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FCMDevice> {
      return localVarFp
        .pushDevicesPartialUpdate(
          requestParameters.id,
          requestParameters.patchedRegisterFCMDevice,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List all FCM devices for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesRetrieve(options?: AxiosRequestConfig): AxiosPromise<PushDeviceListResponse> {
      return localVarFp.pushDevicesRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     * Send a test push to the current user\'s devices.
     * @param {PushDevicesApiPushDevicesSendTestCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushDevicesSendTestCreate(
      requestParameters: PushDevicesApiPushDevicesSendTestCreateRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<SendTestPushResponse> {
      return localVarFp
        .pushDevicesSendTestCreate(requestParameters.sendTestPushRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for pushDevicesCreate operation in PushDevicesApi.
 * @export
 * @interface PushDevicesApiPushDevicesCreateRequest
 */
export interface PushDevicesApiPushDevicesCreateRequest {
  /**
   *
   * @type {RegisterFCMDevice}
   * @memberof PushDevicesApiPushDevicesCreate
   */
  readonly registerFCMDevice: RegisterFCMDevice
}

/**
 * Request parameters for pushDevicesDestroy operation in PushDevicesApi.
 * @export
 * @interface PushDevicesApiPushDevicesDestroyRequest
 */
export interface PushDevicesApiPushDevicesDestroyRequest {
  /**
   *
   * @type {string}
   * @memberof PushDevicesApiPushDevicesDestroy
   */
  readonly id: string
}

/**
 * Request parameters for pushDevicesPartialUpdate operation in PushDevicesApi.
 * @export
 * @interface PushDevicesApiPushDevicesPartialUpdateRequest
 */
export interface PushDevicesApiPushDevicesPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PushDevicesApiPushDevicesPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {PatchedRegisterFCMDevice}
   * @memberof PushDevicesApiPushDevicesPartialUpdate
   */
  readonly patchedRegisterFCMDevice?: PatchedRegisterFCMDevice
}

/**
 * Request parameters for pushDevicesSendTestCreate operation in PushDevicesApi.
 * @export
 * @interface PushDevicesApiPushDevicesSendTestCreateRequest
 */
export interface PushDevicesApiPushDevicesSendTestCreateRequest {
  /**
   *
   * @type {SendTestPushRequest}
   * @memberof PushDevicesApiPushDevicesSendTestCreate
   */
  readonly sendTestPushRequest?: SendTestPushRequest
}

/**
 * PushDevicesApi - object-oriented interface
 * @export
 * @class PushDevicesApi
 * @extends {BaseAPI}
 */
export class PushDevicesApi extends BaseAPI {
  /**
   * Register or update an FCM token for the current user.  If the registration_id already exists for another user, the old record is deleted and a new one is created for the current user. This ensures only the most recent user to register a device token owns it.
   * @param {PushDevicesApiPushDevicesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PushDevicesApi
   */
  public pushDevicesCreate(
    requestParameters: PushDevicesApiPushDevicesCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return PushDevicesApiFp(this.configuration)
      .pushDevicesCreate(requestParameters.registerFCMDevice, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an FCM device by UUID.
   * @param {PushDevicesApiPushDevicesDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PushDevicesApi
   */
  public pushDevicesDestroy(
    requestParameters: PushDevicesApiPushDevicesDestroyRequest,
    options?: AxiosRequestConfig
  ) {
    return PushDevicesApiFp(this.configuration)
      .pushDevicesDestroy(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update device info for an existing FCM device by UUID.
   * @param {PushDevicesApiPushDevicesPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PushDevicesApi
   */
  public pushDevicesPartialUpdate(
    requestParameters: PushDevicesApiPushDevicesPartialUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return PushDevicesApiFp(this.configuration)
      .pushDevicesPartialUpdate(
        requestParameters.id,
        requestParameters.patchedRegisterFCMDevice,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List all FCM devices for the current user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PushDevicesApi
   */
  public pushDevicesRetrieve(options?: AxiosRequestConfig) {
    return PushDevicesApiFp(this.configuration)
      .pushDevicesRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Send a test push to the current user\'s devices.
   * @param {PushDevicesApiPushDevicesSendTestCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PushDevicesApi
   */
  public pushDevicesSendTestCreate(
    requestParameters: PushDevicesApiPushDevicesSendTestCreateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return PushDevicesApiFp(this.configuration)
      .pushDevicesSendTestCreate(requestParameters.sendTestPushRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ReferralsApi - axios parameter creator
 * @export
 */
export const ReferralsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    referralsCodeRetrieve: async (
      code: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists('referralsCodeRetrieve', 'code', code)
      const localVarPath = `/referrals/code/{code}/`.replace(
        `{${'code'}}`,
        encodeURIComponent(String(code))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ReferralsApi - functional programming interface
 * @export
 */
export const ReferralsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReferralsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async referralsCodeRetrieve(
      code: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralCodeLookup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.referralsCodeRetrieve(code, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * ReferralsApi - factory interface
 * @export
 */
export const ReferralsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ReferralsApiFp(configuration)
  return {
    /**
     *
     * @param {ReferralsApiReferralsCodeRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    referralsCodeRetrieve(
      requestParameters: ReferralsApiReferralsCodeRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<ReferralCodeLookup> {
      return localVarFp
        .referralsCodeRetrieve(requestParameters.code, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for referralsCodeRetrieve operation in ReferralsApi.
 * @export
 * @interface ReferralsApiReferralsCodeRetrieveRequest
 */
export interface ReferralsApiReferralsCodeRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof ReferralsApiReferralsCodeRetrieve
   */
  readonly code: string
}

/**
 * ReferralsApi - object-oriented interface
 * @export
 * @class ReferralsApi
 * @extends {BaseAPI}
 */
export class ReferralsApi extends BaseAPI {
  /**
   *
   * @param {ReferralsApiReferralsCodeRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReferralsApi
   */
  public referralsCodeRetrieve(
    requestParameters: ReferralsApiReferralsCodeRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return ReferralsApiFp(this.configuration)
      .referralsCodeRetrieve(requestParameters.code, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * List the current user\'s most recently modified incomplete tasks, deduplicated by lineage_id. Excludes tasks in trashed notes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/tasks/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Toggle a task\'s completion state. Updates the Task row and the note content (HTML + ydoc) via the tiptap transform pipeline.
     * @param {string} taskUuid
     * @param {PatchedTaskToggle} [patchedTaskToggle]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksPartialUpdate: async (
      taskUuid: string,
      patchedTaskToggle?: PatchedTaskToggle,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'taskUuid' is not null or undefined
      assertParamExists('tasksPartialUpdate', 'taskUuid', taskUuid)
      const localVarPath = `/tasks/{task_uuid}/`.replace(
        `{${'task_uuid'}}`,
        encodeURIComponent(String(taskUuid))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTaskToggle,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration)
  return {
    /**
     * List the current user\'s most recently modified incomplete tasks, deduplicated by lineage_id. Excludes tasks in trashed notes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksList(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Task>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksList(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Toggle a task\'s completion state. Updates the Task row and the note content (HTML + ydoc) via the tiptap transform pipeline.
     * @param {string} taskUuid
     * @param {PatchedTaskToggle} [patchedTaskToggle]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksPartialUpdate(
      taskUuid: string,
      patchedTaskToggle?: PatchedTaskToggle,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksPartialUpdate(
        taskUuid,
        patchedTaskToggle,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TasksApiFp(configuration)
  return {
    /**
     * List the current user\'s most recently modified incomplete tasks, deduplicated by lineage_id. Excludes tasks in trashed notes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksList(options?: AxiosRequestConfig): AxiosPromise<Array<Task>> {
      return localVarFp.tasksList(options).then((request) => request(axios, basePath))
    },
    /**
     * Toggle a task\'s completion state. Updates the Task row and the note content (HTML + ydoc) via the tiptap transform pipeline.
     * @param {TasksApiTasksPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksPartialUpdate(
      requestParameters: TasksApiTasksPartialUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .tasksPartialUpdate(
          requestParameters.taskUuid,
          requestParameters.patchedTaskToggle,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for tasksPartialUpdate operation in TasksApi.
 * @export
 * @interface TasksApiTasksPartialUpdateRequest
 */
export interface TasksApiTasksPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof TasksApiTasksPartialUpdate
   */
  readonly taskUuid: string

  /**
   *
   * @type {PatchedTaskToggle}
   * @memberof TasksApiTasksPartialUpdate
   */
  readonly patchedTaskToggle?: PatchedTaskToggle
}

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
  /**
   * List the current user\'s most recently modified incomplete tasks, deduplicated by lineage_id. Excludes tasks in trashed notes.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public tasksList(options?: AxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .tasksList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Toggle a task\'s completion state. Updates the Task row and the note content (HTML + ydoc) via the tiptap transform pipeline.
   * @param {TasksApiTasksPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public tasksPartialUpdate(
    requestParameters: TasksApiTasksPartialUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return TasksApiFp(this.configuration)
      .tasksPartialUpdate(requestParameters.taskUuid, requestParameters.patchedTaskToggle, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TemplatesApi - axios parameter creator
 * @export
 */
export const TemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {NoteTemplate} noteTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesCreate: async (
      noteTemplate: NoteTemplate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteTemplate' is not null or undefined
      assertParamExists('templatesCreate', 'noteTemplate', noteTemplate)
      const localVarPath = `/templates/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        noteTemplate,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesDestroy: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('templatesDestroy', 'id', id)
      const localVarPath = `/templates/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesList: async (
      page?: number,
      perPage?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/templates/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {PatchedNoteTemplate} [patchedNoteTemplate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesPartialUpdate: async (
      id: string,
      patchedNoteTemplate?: PatchedNoteTemplate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('templatesPartialUpdate', 'id', id)
      const localVarPath = `/templates/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedNoteTemplate,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesRetrieve: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('templatesRetrieve', 'id', id)
      const localVarPath = `/templates/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {NoteTemplate} noteTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesUpdate: async (
      id: string,
      noteTemplate: NoteTemplate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('templatesUpdate', 'id', id)
      // verify required parameter 'noteTemplate' is not null or undefined
      assertParamExists('templatesUpdate', 'noteTemplate', noteTemplate)
      const localVarPath = `/templates/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication nocalBearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        noteTemplate,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * TemplatesApi - functional programming interface
 * @export
 */
export const TemplatesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TemplatesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {NoteTemplate} noteTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templatesCreate(
      noteTemplate: NoteTemplate,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteTemplate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.templatesCreate(
        noteTemplate,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templatesDestroy(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.templatesDestroy(id, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templatesList(
      page?: number,
      perPage?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNoteTemplateList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.templatesList(
        page,
        perPage,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {PatchedNoteTemplate} [patchedNoteTemplate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templatesPartialUpdate(
      id: string,
      patchedNoteTemplate?: PatchedNoteTemplate,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteTemplate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.templatesPartialUpdate(
        id,
        patchedNoteTemplate,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templatesRetrieve(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteTemplate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.templatesRetrieve(id, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @param {string} id
     * @param {NoteTemplate} noteTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templatesUpdate(
      id: string,
      noteTemplate: NoteTemplate,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteTemplate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.templatesUpdate(
        id,
        noteTemplate,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    }
  }
}

/**
 * TemplatesApi - factory interface
 * @export
 */
export const TemplatesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TemplatesApiFp(configuration)
  return {
    /**
     *
     * @param {TemplatesApiTemplatesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesCreate(
      requestParameters: TemplatesApiTemplatesCreateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<NoteTemplate> {
      return localVarFp
        .templatesCreate(requestParameters.noteTemplate, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {TemplatesApiTemplatesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesDestroy(
      requestParameters: TemplatesApiTemplatesDestroyRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .templatesDestroy(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {TemplatesApiTemplatesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesList(
      requestParameters: TemplatesApiTemplatesListRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<PaginatedNoteTemplateList> {
      return localVarFp
        .templatesList(requestParameters.page, requestParameters.perPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {TemplatesApiTemplatesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesPartialUpdate(
      requestParameters: TemplatesApiTemplatesPartialUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<NoteTemplate> {
      return localVarFp
        .templatesPartialUpdate(
          requestParameters.id,
          requestParameters.patchedNoteTemplate,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {TemplatesApiTemplatesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesRetrieve(
      requestParameters: TemplatesApiTemplatesRetrieveRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<NoteTemplate> {
      return localVarFp
        .templatesRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {TemplatesApiTemplatesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templatesUpdate(
      requestParameters: TemplatesApiTemplatesUpdateRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<NoteTemplate> {
      return localVarFp
        .templatesUpdate(requestParameters.id, requestParameters.noteTemplate, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for templatesCreate operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplatesCreateRequest
 */
export interface TemplatesApiTemplatesCreateRequest {
  /**
   *
   * @type {NoteTemplate}
   * @memberof TemplatesApiTemplatesCreate
   */
  readonly noteTemplate: NoteTemplate
}

/**
 * Request parameters for templatesDestroy operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplatesDestroyRequest
 */
export interface TemplatesApiTemplatesDestroyRequest {
  /**
   *
   * @type {string}
   * @memberof TemplatesApiTemplatesDestroy
   */
  readonly id: string
}

/**
 * Request parameters for templatesList operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplatesListRequest
 */
export interface TemplatesApiTemplatesListRequest {
  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof TemplatesApiTemplatesList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof TemplatesApiTemplatesList
   */
  readonly perPage?: number
}

/**
 * Request parameters for templatesPartialUpdate operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplatesPartialUpdateRequest
 */
export interface TemplatesApiTemplatesPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof TemplatesApiTemplatesPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {PatchedNoteTemplate}
   * @memberof TemplatesApiTemplatesPartialUpdate
   */
  readonly patchedNoteTemplate?: PatchedNoteTemplate
}

/**
 * Request parameters for templatesRetrieve operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplatesRetrieveRequest
 */
export interface TemplatesApiTemplatesRetrieveRequest {
  /**
   *
   * @type {string}
   * @memberof TemplatesApiTemplatesRetrieve
   */
  readonly id: string
}

/**
 * Request parameters for templatesUpdate operation in TemplatesApi.
 * @export
 * @interface TemplatesApiTemplatesUpdateRequest
 */
export interface TemplatesApiTemplatesUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof TemplatesApiTemplatesUpdate
   */
  readonly id: string

  /**
   *
   * @type {NoteTemplate}
   * @memberof TemplatesApiTemplatesUpdate
   */
  readonly noteTemplate: NoteTemplate
}

/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
export class TemplatesApi extends BaseAPI {
  /**
   *
   * @param {TemplatesApiTemplatesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TemplatesApi
   */
  public templatesCreate(
    requestParameters: TemplatesApiTemplatesCreateRequest,
    options?: AxiosRequestConfig
  ) {
    return TemplatesApiFp(this.configuration)
      .templatesCreate(requestParameters.noteTemplate, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {TemplatesApiTemplatesDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TemplatesApi
   */
  public templatesDestroy(
    requestParameters: TemplatesApiTemplatesDestroyRequest,
    options?: AxiosRequestConfig
  ) {
    return TemplatesApiFp(this.configuration)
      .templatesDestroy(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {TemplatesApiTemplatesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TemplatesApi
   */
  public templatesList(
    requestParameters: TemplatesApiTemplatesListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return TemplatesApiFp(this.configuration)
      .templatesList(requestParameters.page, requestParameters.perPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {TemplatesApiTemplatesPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TemplatesApi
   */
  public templatesPartialUpdate(
    requestParameters: TemplatesApiTemplatesPartialUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return TemplatesApiFp(this.configuration)
      .templatesPartialUpdate(requestParameters.id, requestParameters.patchedNoteTemplate, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {TemplatesApiTemplatesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TemplatesApi
   */
  public templatesRetrieve(
    requestParameters: TemplatesApiTemplatesRetrieveRequest,
    options?: AxiosRequestConfig
  ) {
    return TemplatesApiFp(this.configuration)
      .templatesRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {TemplatesApiTemplatesUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TemplatesApi
   */
  public templatesUpdate(
    requestParameters: TemplatesApiTemplatesUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return TemplatesApiFp(this.configuration)
      .templatesUpdate(requestParameters.id, requestParameters.noteTemplate, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
